export default [
    {
        date: 1552986290230,
        row: 11,
        col: 11,
        segments: [
            [5, 8, 6, 9],
            [6, 9, 7, 8],
            [5, 8, 7, 8],
            [6, 9, 5, 10],
            [5, 10, 4, 9],
            [4, 9, 5, 8],
            [6, 9, 7, 10],
            [7, 10, 8, 9],
            [8, 9, 7, 8],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [5, 8, 5, 7],
            [5, 7, 4, 5],
            [4, 5, 3, 5],
            [3, 5, 2, 6],
            [2, 6, 5, 7],
            [7, 7, 7, 8],
            [7, 7, 8, 5],
            [8, 5, 9, 5],
            [9, 5, 10, 6],
            [10, 6, 7, 7],
            [1, 6, 2, 4],
            [10, 4, 11, 6],
            [1, 6, 1, 8],
            [1, 8, 2, 9],
            [2, 9, 5, 10],
            [11, 6, 11, 8],
            [11, 8, 10, 9],
            [10, 9, 7, 10],
            [2, 4, 2, 3],
            [2, 3, 2, 2],
            [2, 2, 3, 1],
            [3, 1, 4, 2],
            [5, 3, 4, 2],
            [5, 3, 7, 3],
            [7, 3, 9, 1],
            [9, 1, 10, 2],
            [10, 2, 10, 4],
            [2, 4, 3, 2],
            [3, 2, 4, 3],
            [4, 3, 2, 4],
            [8, 3, 9, 2],
            [9, 2, 10, 4],
            [10, 4, 8, 3],
            [4, 4, 5, 4],
            [7, 4, 8, 4],
        ],
    },
    {
        date: 1549548237594,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 6, 2],
            [6, 6, 6, 2],
            [2, 6, 6, 6],
            [2, 6, 2, 2],
            [2, 6, 2, 10],
            [2, 10, 6, 10],
            [6, 10, 6, 6],
            [6, 6, 10, 6],
            [10, 6, 10, 10],
            [10, 10, 6, 10],
            [6, 10, 6, 2],
            [6, 2, 10, 2],
            [10, 2, 10, 6],
            [2, 2, 6, 6],
            [3, 2, 6, 5],
            [4, 2, 6, 4],
            [5, 2, 6, 3],
            [2, 3, 5, 6],
            [2, 4, 4, 6],
            [3, 6, 2, 5],
            [7, 2, 7, 6],
            [8, 2, 8, 6],
            [9, 2, 9, 6],
            [2, 7, 6, 7],
            [2, 8, 6, 8],
            [2, 9, 6, 9],
            [6, 7, 7, 6],
            [6, 8, 8, 6],
            [6, 9, 9, 6],
            [6, 10, 10, 6],
            [7, 10, 10, 7],
            [8, 10, 10, 8],
            [9, 10, 10, 9],
        ],
    },
    {
        date: 1549218559962,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 2],
            [10, 2, 10, 10],
            [10, 10, 2, 10],
            [2, 10, 2, 2],
            [2, 3, 3, 2],
            [3, 2, 4, 3],
            [4, 3, 5, 2],
            [5, 2, 6, 3],
            [6, 3, 7, 2],
            [7, 2, 8, 3],
            [8, 3, 9, 2],
            [9, 2, 10, 3],
            [10, 3, 9, 4],
            [9, 4, 10, 5],
            [10, 5, 9, 6],
            [9, 6, 10, 7],
            [10, 7, 9, 8],
            [9, 8, 10, 9],
            [10, 9, 9, 10],
            [9, 10, 8, 9],
            [8, 9, 7, 10],
            [7, 10, 6, 9],
            [6, 9, 5, 10],
            [5, 10, 4, 9],
            [4, 9, 3, 10],
            [3, 10, 2, 9],
            [2, 9, 3, 8],
            [3, 8, 2, 7],
            [2, 7, 3, 6],
            [3, 6, 2, 5],
            [2, 5, 3, 4],
            [3, 4, 2, 3],
            [2, 5, 4, 5],
            [4, 5, 5, 6],
            [5, 6, 4, 7],
            [4, 7, 2, 7],
            [5, 10, 5, 8],
            [5, 8, 6, 7],
            [6, 7, 7, 8],
            [7, 8, 7, 10],
            [10, 7, 8, 7],
            [8, 7, 7, 6],
            [7, 6, 8, 5],
            [8, 5, 10, 5],
            [5, 2, 5, 4],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [7, 4, 7, 2],
            [4, 5, 5, 4],
            [4, 7, 5, 8],
            [7, 8, 8, 7],
            [8, 5, 7, 4],
        ],
    },
    {
        date: 1549218475555,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 2],
            [10, 2, 10, 10],
            [10, 10, 2, 10],
            [2, 10, 2, 2],
            [2, 3, 3, 2],
            [2, 4, 4, 2],
            [9, 2, 10, 3],
            [8, 2, 10, 4],
            [2, 9, 3, 10],
            [2, 8, 4, 10],
            [9, 10, 10, 9],
            [10, 8, 8, 10],
            [5, 10, 6, 9],
            [6, 9, 7, 10],
            [4, 10, 6, 8],
            [6, 8, 8, 10],
            [2, 7, 3, 6],
            [3, 6, 2, 5],
            [2, 4, 4, 6],
            [4, 6, 2, 8],
            [5, 2, 6, 3],
            [6, 3, 7, 2],
            [10, 5, 9, 6],
            [9, 6, 10, 7],
            [10, 8, 8, 6],
            [8, 6, 10, 4],
            [8, 2, 6, 4],
            [6, 4, 4, 2],
            [3, 4, 4, 3],
            [4, 3, 6, 5],
            [6, 5, 8, 3],
            [8, 3, 9, 4],
            [9, 4, 7, 6],
            [7, 6, 9, 8],
            [9, 8, 8, 9],
            [8, 9, 6, 7],
            [6, 7, 4, 9],
            [4, 9, 3, 8],
            [3, 8, 5, 6],
            [5, 6, 3, 4],
            [4, 4, 5, 5],
            [8, 4, 7, 5],
            [4, 8, 5, 7],
            [7, 7, 8, 8],
        ],
    },
    {
        date: 1586969007594,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 2],
            [2, 2, 2, 3],
            [3, 3, 2, 3],
            [3, 3, 2, 4],
            [2, 4, 10, 4],
            [10, 4, 9, 3],
            [9, 3, 10, 3],
            [10, 3, 10, 2],
            [10, 2, 11, 1],
            [6, 4, 6, 10],
            [6, 10, 1, 10],
            [6, 10, 11, 10],
            [10, 10, 6, 4],
            [2, 10, 6, 4],
            [4, 7, 8, 7],
            [6, 4, 1, 5],
            [6, 4, 1, 6],
            [6, 4, 1, 7],
            [6, 4, 1, 8],
            [6, 4, 1, 9],
            [6, 4, 1, 10],
            [1, 4, 6, 4],
            [6, 4, 11, 4],
            [6, 4, 11, 5],
            [6, 4, 11, 6],
            [6, 4, 11, 7],
            [6, 4, 11, 8],
            [6, 4, 11, 9],
            [6, 4, 11, 10],
            [6, 4, 2, 2],
            [6, 4, 10, 2],
            [6, 4, 9, 3],
            [6, 4, 3, 3],
            [6, 4, 1, 1],
            [6, 4, 11, 1],
            [6, 5, 8, 7],
            [6, 5, 4, 7],
            [5, 6, 7, 6],
            [5, 7, 5, 10],
            [4, 7, 4, 10],
            [7, 7, 7, 10],
            [8, 7, 8, 10],
            [4, 8, 8, 8],
            [4, 9, 8, 9],
            [7, 8, 6, 8],
            [5, 9, 6, 9],
            [6, 9, 7, 9],
            [5, 8, 6, 4],
            [6, 4, 7, 8],
            [7, 8, 6, 10],
            [5, 8, 6, 10],
            [6, 4, 6, 1],
            [6, 4, 5, 1],
            [6, 4, 4, 1],
            [6, 4, 3, 1],
            [6, 4, 2, 1],
            [6, 4, 7, 1],
            [6, 4, 8, 1],
            [6, 4, 9, 1],
            [6, 4, 10, 1],
            [1, 3, 2, 3],
            [2, 3, 2, 4],
            [1, 2, 2, 2],
            [10, 3, 10, 4],
            [10, 3, 11, 3],
            [10, 2, 11, 2],
            [2, 10, 2, 11],
            [3, 10, 3, 11],
            [4, 10, 4, 11],
            [5, 10, 5, 11],
            [6, 10, 6, 11],
            [7, 10, 7, 11],
            [8, 10, 8, 11],
            [9, 10, 9, 11],
            [10, 10, 10, 11],
            [11, 11, 11, 10],
            [11, 1, 11, 10],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [1, 1, 11, 1],
            [9, 3, 9, 4],
            [3, 3, 3, 4],
            [10, 4, 10, 10],
            [8, 4, 8, 7],
            [4, 4, 4, 7],
            [2, 4, 2, 10],
        ],
    },
    {
        date: 1586509209128,
        row: 11,
        col: 11,
        segments: [
            [3, 11, 3, 9],
            [5, 9, 3, 9],
            [6, 11, 6, 9],
            [5, 9, 6, 9],
            [7, 11, 7, 9],
            [8, 9, 8, 11],
            [7, 9, 8, 9],
            [2, 11, 2, 7],
            [6, 7, 2, 7],
            [6, 5, 6, 7],
            [8, 3, 6, 5],
            [8, 3, 10, 5],
            [6, 5, 10, 5],
            [10, 5, 10, 11],
            [2, 7, 4, 5],
            [6, 7, 4, 5],
            [7, 7, 9, 7],
            [7, 6, 9, 6],
            [9, 7, 9, 6],
            [8, 6, 8, 7],
            [7, 6, 7, 7],
        ],
    },
    {
        date: 1586364793901,
        row: 11,
        col: 11,
        segments: [
            [3, 11, 3, 6],
            [7, 6, 3, 6],
            [7, 11, 7, 6],
            [7, 7, 10, 7],
            [10, 7, 10, 11],
            [7, 6, 10, 7],
            [3, 6, 5, 3],
            [7, 6, 5, 3],
            [4, 9, 5, 9],
            [5, 9, 5, 11],
            [4, 9, 4, 11],
            [5, 7, 5, 8],
            [6, 7, 6, 8],
            [5, 8, 6, 8],
            [5, 7, 6, 7],
            [8, 11, 8, 9],
            [8, 9, 9, 9],
            [9, 9, 9, 11],
        ],
    },
    {
        date: 1586339327797,
        row: 11,
        col: 11,
        segments: [
            [4, 10, 9, 10],
            [9, 10, 10, 9],
            [10, 9, 10, 7],
            [10, 7, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 7, 3],
            [7, 3, 6, 3],
            [6, 3, 5, 4],
            [5, 4, 4, 4],
            [4, 5, 4, 4],
            [4, 5, 5, 5],
            [5, 5, 5, 9],
            [5, 9, 4, 9],
            [4, 9, 4, 10],
            [5, 9, 6, 9],
            [6, 9, 6, 8],
            [6, 8, 7, 7],
            [7, 7, 8, 7],
            [8, 5, 8, 6],
            [8, 6, 7, 6],
            [7, 6, 7, 4],
        ],
    },
    {
        date: 1585732886121,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [11, 1, 1, 11],
            [3, 3, 9, 3],
            [9, 3, 9, 9],
            [9, 9, 3, 9],
            [3, 9, 3, 3],
            [6, 3, 6, 9],
            [9, 6, 3, 6],
            [5, 3, 5, 5],
            [5, 7, 5, 9],
            [7, 9, 7, 7],
            [7, 5, 7, 3],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [5, 5, 5, 7],
            [5, 7, 7, 7],
            [7, 5, 8, 5],
            [5, 5, 4, 5],
            [5, 7, 4, 7],
            [7, 7, 8, 7],
            [4, 5, 5, 4],
            [8, 5, 7, 4],
            [8, 7, 7, 8],
            [4, 7, 5, 8],
            [4, 7, 3, 6],
            [4, 5, 3, 6],
            [8, 5, 9, 6],
            [8, 7, 9, 6],
            [5, 4, 7, 4],
            [5, 8, 7, 8],
            [6, 1, 3, 3],
            [6, 1, 9, 3],
            [6, 11, 3, 9],
            [6, 11, 9, 9],
            [6, 9, 6, 11],
            [6, 3, 6, 1],
            [1, 6, 11, 6],
            [4, 3, 1, 5],
            [8, 3, 11, 5],
            [1, 7, 4, 9],
            [8, 9, 11, 7],
        ],
    },
    {
        date: 1585568945511,
        row: 11,
        col: 11,
        segments: [
            [3, 4, 3, 7],
            [3, 4, 4, 5],
            [3, 7, 4, 6],
            [4, 5, 5, 4],
            [5, 4, 8, 4],
            [8, 4, 10, 5],
            [10, 5, 8, 7],
            [8, 7, 5, 7],
            [5, 7, 4, 6],
            [8, 4, 7, 5],
            [7, 5, 8, 6],
            [8, 6, 9, 6],
            [8, 5, 9, 5],
            [6, 4, 5, 5],
            [5, 5, 6, 6],
            [6, 6, 5, 7],
            [7, 4, 6, 5],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [4, 5, 4, 6],
            [8, 6, 7, 7],
            [6, 4, 6, 3],
            [6, 3, 7, 4],
            [6, 7, 6, 8],
            [6, 8, 7, 7],
        ],
    },
    {
        date: 1585489573206,
        row: 11,
        col: 11,
        segments: [
            [5, 3, 7, 3],
            [5, 5, 5, 3],
            [7, 5, 5, 5],
            [7, 3, 7, 5],
            [11, 1, 7, 3],
            [1, 1, 5, 3],
            [3, 2, 1, 5],
            [9, 2, 11, 5],
            [6, 11, 1, 5],
            [6, 11, 11, 5],
            [6, 5, 6, 11],
            [5, 3, 1, 5],
            [7, 3, 11, 5],
            [5, 5, 1, 5],
            [11, 5, 7, 5],
            [1, 1, 5, 5],
            [7, 5, 11, 1],
            [5, 6, 5, 7],
            [4, 6, 5, 6],
            [4, 7, 5, 7],
            [4, 6, 4, 7],
            [7, 7, 7, 6],
            [8, 6, 7, 6],
            [8, 7, 8, 6],
            [7, 7, 8, 7],
            [6, 9, 5, 10],
            [7, 10, 6, 9],
            [5, 10, 6, 11],
            [7, 10, 6, 11],
            [3, 2, 4, 4],
            [9, 2, 8, 4],
            [3, 5, 5, 10],
            [9, 5, 7, 10],
        ],
    },
    {
        date: 1585232430559,
        row: 11,
        col: 11,
        segments: [
            [4, 5, 4, 6],
            [4, 7, 4, 6],
            [5, 8, 4, 7],
            [7, 8, 5, 8],
            [8, 7, 7, 8],
            [8, 5, 8, 7],
            [7, 4, 8, 5],
            [4, 5, 5, 4],
            [5, 4, 7, 4],
            [6, 4, 6, 8],
            [5, 5, 5, 6],
            [7, 5, 7, 6],
            [5, 7, 6, 8],
            [7, 7, 6, 8],
            [7, 4, 8, 3],
            [9, 2, 8, 3],
            [9, 2, 10, 3],
            [5, 4, 4, 3],
            [4, 3, 3, 2],
            [2, 3, 3, 2],
            [2, 3, 3, 3],
            [3, 3, 4, 4],
            [4, 4, 4, 5],
            [8, 5, 8, 4],
            [8, 4, 9, 3],
            [9, 3, 10, 3],
            [5, 8, 6, 9],
            [6, 9, 7, 8],
            [6, 9, 5, 9],
            [6, 9, 7, 9],
            [6, 8, 7, 8],
            [5, 8, 6, 8],
            [7, 9, 6, 10],
            [5, 9, 6, 10],
        ],
    },
    {
        date: 1585218969443,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 8, 3],
            [8, 4, 7, 5],
            [8, 3, 8, 4],
            [5, 5, 4, 4],
            [4, 3, 4, 4],
            [4, 3, 1, 1],
            [5, 5, 6, 6],
            [6, 6, 7, 5],
            [6, 6, 7, 7],
            [6, 6, 5, 7],
            [4, 8, 5, 7],
            [7, 7, 8, 8],
            [8, 9, 8, 8],
            [4, 8, 4, 9],
            [4, 9, 1, 11],
            [8, 9, 11, 11],
            [7, 7, 8, 7],
            [8, 6, 7, 6],
            [7, 6, 7, 5],
            [5, 7, 4, 7],
            [4, 6, 5, 6],
            [5, 6, 5, 5],
            [5, 5, 6, 5],
            [7, 5, 6, 5],
            [6, 5, 6, 2],
            [6, 3, 5, 3],
            [6, 3, 7, 4],
            [5, 4, 6, 4],
            [6, 4, 7, 3],
            [4, 9, 5, 8],
            [6, 7, 5, 8],
            [6, 7, 8, 9],
            [7, 8, 6, 7],
            [8, 7, 9, 6],
            [8, 6, 9, 6],
            [9, 5, 9, 8],
            [4, 7, 3, 6],
            [3, 6, 4, 6],
            [3, 5, 3, 8],
            [3, 8, 2, 8],
            [3, 8, 4, 8],
            [3, 9, 3, 8],
            [9, 9, 9, 8],
            [9, 8, 8, 8],
            [9, 8, 10, 8],
            [5, 4, 6, 3],
            [5, 3, 6, 4],
            [6, 3, 7, 3],
            [7, 4, 6, 4],
            [4, 2, 8, 2],
            [4, 2, 4, 1],
            [8, 2, 8, 1],
            [3, 1, 4, 2],
            [8, 2, 9, 1],
        ],
    },
    {
        date: 1585217153485,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 3, 3],
            [3, 3, 3, 5],
            [3, 7, 3, 9],
            [3, 9, 1, 11],
            [11, 1, 9, 3],
            [9, 5, 9, 3],
            [9, 7, 9, 9],
            [11, 11, 9, 9],
            [9, 3, 6, 1],
            [6, 1, 3, 3],
            [3, 9, 6, 11],
            [9, 9, 6, 11],
            [3, 5, 1, 6],
            [1, 6, 3, 7],
            [9, 5, 11, 6],
            [11, 6, 9, 7],
            [3, 5, 3, 7],
            [9, 5, 9, 7],
            [9, 7, 7, 5],
            [3, 7, 5, 5],
            [5, 5, 7, 5],
            [3, 3, 5, 3],
            [9, 3, 7, 3],
            [3, 9, 5, 9],
            [9, 9, 7, 9],
            [7, 9, 7, 5],
            [5, 9, 5, 5],
            [5, 3, 6, 5],
            [6, 5, 7, 3],
            [7, 5, 7, 3],
            [5, 3, 5, 5],
            [7, 5, 9, 3],
            [5, 5, 3, 3],
            [3, 5, 5, 5],
            [3, 7, 5, 9],
            [9, 7, 7, 9],
            [9, 7, 7, 7],
            [5, 7, 3, 7],
            [5, 9, 7, 9],
            [5, 9, 6, 7],
            [6, 7, 7, 9],
            [6, 7, 6, 5],
            [5, 6, 7, 6],
            [7, 7, 5, 5],
            [5, 7, 7, 5],
            [3, 9, 5, 7],
            [9, 9, 7, 7],
            [7, 3, 9, 5],
            [7, 7, 9, 5],
            [3, 5, 5, 7],
            [3, 5, 5, 3],
            [5, 3, 7, 3],
            [6, 3, 6, 1],
            [6, 9, 6, 11],
        ],
    },
    {
        date: 1585085272944,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 2],
            [11, 1, 10, 2],
            [1, 11, 2, 10],
            [11, 11, 10, 10],
            [9, 9, 8, 8],
            [9, 3, 8, 4],
            [3, 3, 4, 4],
            [3, 9, 4, 8],
            [5, 7, 6, 6],
            [5, 5, 6, 6],
            [7, 5, 6, 6],
            [7, 7, 6, 6],
            [7, 5, 8, 6],
            [9, 3, 10, 4],
            [3, 3, 2, 4],
            [3, 9, 2, 8],
            [9, 9, 10, 8],
            [7, 7, 6, 8],
            [5, 7, 4, 6],
            [5, 5, 6, 4],
            [6, 4, 5, 3],
            [8, 6, 9, 5],
            [6, 8, 7, 9],
            [4, 6, 3, 7],
            [2, 8, 1, 9],
            [1, 9, 2, 10],
            [10, 8, 11, 9],
            [11, 9, 10, 10],
            [10, 2, 11, 3],
            [11, 3, 10, 4],
            [2, 2, 1, 3],
            [1, 3, 2, 4],
            [4, 4, 2, 6],
            [8, 4, 6, 2],
            [8, 8, 10, 6],
            [4, 8, 6, 10],
            [2, 6, 3, 7],
            [5, 3, 6, 2],
            [9, 5, 10, 6],
            [7, 9, 6, 10],
            [3, 1, 4, 2],
            [4, 2, 5, 1],
            [7, 1, 8, 2],
            [8, 2, 9, 1],
            [9, 11, 8, 10],
            [8, 10, 7, 11],
            [5, 11, 4, 10],
            [4, 10, 3, 11],
        ],
    },
    {
        date: 1585076472018,
        row: 11,
        col: 11,
        segments: [
            [6, 3, 6, 5],
            [5, 2, 6, 3],
            [7, 2, 6, 3],
            [3, 1, 3, 2],
            [4, 2, 4, 1],
            [3, 2, 4, 2],
            [9, 1, 8, 1],
            [8, 2, 9, 2],
            [9, 1, 9, 2],
            [8, 1, 8, 2],
            [4, 7, 8, 7],
            [4, 7, 6, 9],
            [8, 7, 6, 9],
            [6, 7, 6, 9],
            [7, 7, 6, 8],
            [5, 7, 6, 8],
            [4, 5, 8, 5],
            [6, 6, 9, 5],
            [6, 6, 9, 6],
            [6, 6, 9, 7],
            [3, 5, 6, 6],
            [6, 6, 3, 6],
            [6, 6, 3, 7],
        ],
    },
    {
        date: 1585047080011,
        row: 11,
        col: 11,
        segments: [
            [2, 11, 2, 8],
            [5, 8, 2, 8],
            [7, 8, 10, 8],
            [10, 11, 10, 8],
            [7, 8, 7, 7],
            [5, 7, 5, 8],
            [5, 7, 3, 7],
            [7, 7, 9, 7],
            [9, 7, 9, 3],
            [9, 3, 3, 3],
            [3, 3, 3, 7],
            [5, 4, 4, 4],
            [4, 4, 4, 5],
            [4, 5, 5, 5],
            [5, 5, 5, 4],
            [7, 4, 7, 5],
            [7, 5, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 7, 4],
            [4, 6, 8, 6],
            [9, 9, 9, 11],
            [3, 9, 3, 11],
            [3, 3, 4, 2],
            [4, 2, 5, 3],
            [5, 3, 6, 2],
            [6, 2, 7, 3],
            [7, 3, 8, 2],
            [8, 2, 9, 3],
        ],
    },
    {
        date: 1584968034722,
        row: 11,
        col: 11,
        segments: [
            [4, 2, 4, 5],
            [5, 3, 6, 2],
            [4, 2, 5, 3],
            [7, 3, 6, 2],
            [8, 2, 7, 3],
            [8, 5, 8, 2],
            [4, 5, 6, 6],
            [6, 6, 8, 5],
            [6, 6, 6, 11],
            [6, 11, 8, 9],
            [8, 9, 8, 8],
            [8, 8, 7, 8],
            [7, 8, 6, 11],
        ],
    },
    {
        date: 1576597589372,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 4, 3],
            [6, 1, 8, 3],
            [5, 3, 4, 3],
            [7, 3, 8, 3],
            [5, 3, 3, 5],
            [7, 3, 9, 5],
            [4, 5, 3, 5],
            [8, 5, 9, 5],
            [2, 7, 4, 5],
            [8, 5, 10, 7],
            [2, 7, 3, 7],
            [9, 7, 10, 7],
            [3, 7, 1, 9],
            [9, 7, 11, 9],
            [1, 9, 5, 9],
            [7, 9, 11, 9],
            [5, 9, 5, 11],
            [5, 11, 7, 11],
            [7, 11, 7, 9],
        ],
    },
    {
        date: 1574937363218,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 1, 1],
            [11, 1, 1, 1],
            [6, 1, 6, 11],
            [11, 6, 1, 6],
            [1, 3, 11, 9],
            [11, 3, 1, 9],
            [11, 1, 11, 11],
            [1, 1, 1, 11],
            [7, 1, 5, 11],
            [8, 1, 6, 11],
            [5, 1, 7, 11],
            [4, 1, 6, 11],
            [11, 5, 1, 7],
            [1, 5, 11, 7],
            [8, 11, 6, 1],
            [4, 11, 6, 1],
        ],
    },
    {
        date: 1578825978505,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 2],
            [10, 10, 2, 10],
            [10, 2, 10, 10],
            [2, 2, 2, 10],
            [6, 2, 2, 6],
            [6, 2, 10, 6],
            [10, 6, 6, 10],
            [2, 6, 6, 10],
            [6, 2, 6, 10],
            [2, 6, 10, 6],
            [2, 10, 10, 2],
            [2, 2, 10, 10],
            [3, 3, 5, 3],
            [5, 5, 5, 3],
            [3, 5, 5, 5],
            [3, 3, 3, 5],
            [7, 3, 9, 3],
            [9, 3, 9, 5],
            [9, 5, 7, 5],
            [7, 5, 7, 3],
            [3, 7, 9, 7],
            [9, 9, 3, 9],
            [3, 7, 3, 9],
            [9, 7, 9, 9],
        ],
    },
    {
        date: 1582010092190,
        row: 11,
        col: 11,
        segments: [
            [3, 1, 1, 3],
            [1, 3, 4, 6],
            [4, 6, 6, 4],
            [6, 4, 3, 1],
            [6, 4, 8, 6],
            [6, 4, 9, 1],
            [9, 1, 11, 3],
            [11, 3, 8, 6],
            [8, 6, 6, 8],
            [6, 8, 3, 11],
            [3, 11, 1, 9],
            [1, 9, 4, 6],
            [4, 6, 6, 8],
            [6, 8, 9, 11],
            [8, 6, 11, 9],
            [11, 9, 9, 11],
            [5, 1, 5, 2],
            [7, 2, 7, 1],
            [5, 2, 7, 2],
            [5, 1, 7, 1],
            [11, 5, 10, 5],
            [10, 7, 10, 5],
            [10, 7, 11, 7],
            [11, 5, 11, 7],
            [5, 10, 5, 11],
            [5, 11, 7, 11],
            [7, 10, 5, 10],
            [7, 11, 7, 10],
            [1, 5, 2, 5],
            [2, 7, 1, 7],
            [2, 5, 2, 7],
            [1, 5, 1, 7],
            [3, 2, 5, 4],
            [5, 4, 4, 5],
            [4, 5, 2, 3],
            [2, 3, 3, 2],
            [7, 4, 9, 2],
            [9, 2, 10, 3],
            [10, 3, 8, 5],
            [8, 5, 7, 4],
            [4, 7, 2, 9],
            [2, 9, 3, 10],
            [3, 10, 5, 8],
            [5, 8, 4, 7],
            [7, 8, 8, 7],
            [8, 7, 10, 9],
            [10, 9, 9, 10],
            [9, 10, 7, 8],
            [5, 5, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 7, 5],
            [7, 5, 5, 5],
        ],
    },
    {
        date: 1542748958651,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 1],
            [1, 2, 1, 3],
            [1, 2, 2, 2],
            [2, 2, 2, 3],
            [2, 3, 1, 3],
            [1, 1, 1, 2],
            [2, 1, 2, 2],
            [2, 2, 3, 2],
            [2, 3, 3, 3],
            [3, 2, 3, 3],
            [3, 3, 3, 4],
            [3, 3, 4, 3],
            [4, 4, 4, 3],
            [3, 4, 4, 4],
            [4, 3, 5, 3],
            [5, 3, 6, 3],
            [5, 3, 5, 4],
            [4, 4, 5, 4],
            [5, 4, 6, 4],
            [6, 3, 6, 4],
            [4, 4, 4, 5],
            [4, 5, 5, 5],
            [5, 4, 5, 5],
            [4, 5, 4, 6],
            [4, 6, 5, 6],
            [5, 6, 5, 5],
            [4, 5, 3, 6],
            [3, 6, 2, 7],
            [2, 6, 2, 7],
            [2, 6, 3, 6],
            [3, 6, 3, 7],
            [3, 8, 3, 7],
            [2, 7, 2, 8],
            [2, 8, 3, 8],
            [2, 7, 3, 8],
            [3, 6, 4, 6],
            [4, 6, 4, 7],
            [3, 7, 4, 7],
            [4, 8, 4, 7],
            [3, 8, 4, 8],
            [3, 7, 2, 7],
            [3, 6, 4, 7],
            [4, 7, 3, 8],
            [5, 6, 6, 6],
            [7, 6, 6, 6],
            [5, 6, 5, 7],
            [5, 7, 5, 8],
            [5, 8, 6, 8],
            [6, 8, 7, 8],
            [7, 7, 7, 8],
            [7, 6, 7, 7],
            [5, 7, 6, 7],
            [6, 7, 7, 7],
            [6, 6, 6, 7],
            [6, 7, 6, 8],
            [5, 7, 6, 6],
            [6, 6, 7, 7],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [4, 8, 5, 8],
            [4, 8, 4, 9],
            [4, 9, 4, 10],
            [4, 10, 4, 11],
            [4, 11, 5, 11],
            [5, 11, 5, 10],
            [5, 10, 5, 9],
            [5, 9, 5, 8],
            [4, 9, 5, 9],
            [5, 10, 4, 10],
            [5, 5, 6, 6],
            [7, 6, 8, 6],
            [8, 6, 8, 7],
            [8, 7, 8, 8],
            [7, 8, 8, 8],
            [8, 6, 9, 6],
            [8, 7, 9, 7],
            [9, 7, 10, 7],
            [8, 8, 9, 8],
            [9, 8, 10, 8],
            [10, 8, 10, 7],
            [9, 7, 9, 6],
            [10, 6, 10, 7],
            [9, 6, 10, 6],
            [9, 8, 9, 7],
            [8, 7, 9, 8],
            [9, 8, 10, 7],
            [10, 7, 9, 6],
            [9, 6, 8, 7],
            [7, 8, 7, 9],
            [7, 9, 7, 10],
            [7, 10, 7, 11],
            [8, 8, 8, 9],
            [8, 9, 8, 10],
            [8, 10, 8, 11],
            [7, 11, 8, 11],
            [7, 10, 8, 10],
            [7, 9, 8, 9],
            [2, 6, 1, 6],
            [2, 8, 1, 8],
            [10, 6, 11, 6],
            [10, 8, 11, 8],
            [2, 8, 2, 9],
            [1, 6, 1, 7],
            [1, 7, 1, 8],
            [1, 8, 1, 9],
            [1, 9, 1, 10],
            [1, 10, 1, 11],
            [2, 9, 2, 10],
            [2, 10, 2, 11],
            [1, 9, 2, 9],
            [1, 10, 2, 10],
            [1, 11, 2, 11],
            [10, 8, 10, 9],
            [10, 9, 10, 10],
            [10, 10, 10, 11],
            [11, 8, 11, 9],
            [11, 6, 11, 7],
            [11, 7, 11, 8],
            [11, 9, 11, 10],
            [11, 10, 11, 11],
            [10, 11, 11, 11],
            [10, 10, 11, 10],
            [10, 9, 11, 9],
            [7, 6, 7, 5],
            [7, 5, 7, 4],
            [7, 4, 7, 3],
            [6, 3, 7, 3],
            [6, 4, 7, 4],
            [7, 3, 8, 3],
            [8, 3, 8, 4],
            [8, 4, 8, 5],
            [8, 5, 8, 6],
            [7, 4, 8, 4],
            [7, 5, 8, 5],
            [6, 6, 7, 5],
            [3, 6, 2, 5],
            [2, 5, 2, 6],
            [2, 5, 1, 5],
            [1, 6, 1, 5],
            [9, 6, 8, 5],
            [9, 6, 10, 5],
            [10, 5, 10, 6],
            [10, 5, 11, 5],
            [11, 5, 11, 6],
            [2, 6, 1, 8],
            [4, 6, 5, 8],
            [7, 8, 8, 6],
            [10, 6, 11, 8],
            [1, 6, 2, 8],
            [5, 6, 4, 8],
            [7, 6, 8, 8],
            [11, 6, 10, 8],
            [8, 2, 9, 2],
            [9, 2, 10, 2],
            [10, 2, 10, 3],
            [10, 3, 9, 3],
            [8, 3, 9, 3],
            [9, 2, 9, 3],
            [9, 2, 9, 1],
            [9, 1, 10, 1],
            [10, 1, 10, 2],
            [2, 8, 3, 9],
            [3, 9, 4, 8],
            [2, 8, 3, 10],
            [3, 10, 4, 8],
            [2, 8, 3, 11],
            [3, 11, 4, 8],
            [5, 11, 6, 8],
            [6, 8, 7, 11],
            [5, 11, 6, 9],
            [6, 9, 7, 11],
            [5, 11, 6, 10],
            [6, 10, 7, 11],
            [8, 8, 9, 11],
            [9, 11, 10, 8],
            [8, 8, 9, 10],
            [9, 10, 10, 8],
            [8, 8, 9, 9],
            [9, 9, 10, 8],
            [3, 4, 2, 4],
            [2, 4, 2, 5],
            [8, 4, 9, 4],
            [9, 4, 10, 4],
            [10, 4, 10, 5],
            [10, 4, 11, 4],
            [2, 4, 1, 4],
            [1, 5, 1, 4],
            [1, 4, 1, 3],
            [2, 3, 2, 4],
            [9, 3, 9, 4],
            [10, 3, 10, 4],
            [10, 3, 11, 3],
            [11, 3, 11, 4],
            [11, 4, 11, 5],
            [10, 2, 11, 2],
            [11, 2, 11, 3],
            [11, 2, 11, 1],
            [11, 1, 10, 1],
            [2, 5, 3, 4],
            [3, 4, 4, 5],
            [5, 5, 6, 4],
            [6, 4, 7, 5],
            [8, 5, 9, 4],
            [9, 4, 10, 5],
            [3, 2, 4, 1],
            [4, 1, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 8, 1],
            [8, 1, 9, 2],
            [7, 2, 8, 2],
            [7, 2, 6, 2],
            [6, 2, 5, 2],
            [5, 2, 4, 2],
            [4, 2, 3, 2],
            [3, 2, 4, 3],
            [4, 3, 5, 2],
            [5, 2, 6, 3],
            [6, 3, 7, 2],
            [7, 2, 8, 3],
            [2, 1, 3, 1],
            [3, 1, 4, 1],
            [4, 1, 5, 1],
            [5, 1, 6, 1],
            [6, 1, 7, 1],
            [7, 1, 8, 1],
            [8, 1, 9, 1],
            [8, 3, 9, 2],
            [3, 2, 3, 1],
            [1, 1, 2, 3],
            [2, 3, 3, 1],
            [1, 1, 2, 2],
            [2, 2, 3, 1],
            [1, 1, 2, 4],
            [2, 4, 3, 1],
            [9, 1, 10, 2],
            [10, 2, 11, 1],
            [9, 1, 10, 3],
            [10, 3, 11, 1],
            [9, 1, 10, 4],
            [10, 4, 11, 1],
            [3, 4, 4, 3],
            [4, 3, 5, 4],
            [5, 4, 6, 3],
            [6, 3, 7, 4],
            [7, 4, 8, 3],
            [8, 3, 9, 4],
            [5, 1, 5, 2],
            [5, 3, 5, 2],
            [7, 1, 7, 2],
            [7, 2, 7, 3],
        ],
    },
    {
        date: 1524082264540,
        row: 11,
        col: 11,
        segments: [
            [4, 2, 8, 2],
            [3, 3, 4, 2],
            [9, 3, 8, 2],
            [2, 4, 3, 3],
            [10, 4, 9, 3],
            [10, 7, 10, 4],
            [2, 7, 2, 4],
            [4, 9, 2, 7],
            [8, 9, 10, 7],
            [4, 9, 8, 9],
            [5, 9, 6, 10],
            [7, 9, 6, 10],
            [6, 10, 4, 11],
            [3, 10, 5, 9],
            [4, 11, 3, 10],
            [8, 11, 6, 10],
            [9, 10, 8, 11],
            [9, 10, 7, 9],
            [6, 5, 5, 6],
            [7, 6, 5, 6],
            [7, 6, 6, 5],
            [7, 8, 5, 8],
            [5, 8, 4, 7],
            [7, 8, 8, 7],
            [4, 4, 4, 5],
            [5, 4, 4, 4],
            [4, 5, 5, 5],
            [7, 5, 8, 5],
            [8, 4, 7, 4],
            [7, 4, 7, 5],
            [8, 5, 8, 4],
            [5, 4, 4, 5],
            [7, 4, 8, 5],
            [7, 5, 8, 4],
            [5, 5, 5, 4],
            [4, 4, 5, 5],
            [4, 2, 4, 3],
            [5, 2, 4, 3],
            [5, 3, 5, 2],
            [6, 2, 5, 3],
            [7, 2, 6, 3],
            [6, 2, 6, 3],
            [7, 2, 7, 3],
            [8, 2, 7, 3],
            [10, 5, 11, 5],
            [11, 6, 10, 6],
            [11, 5, 11, 6],
            [2, 6, 1, 6],
            [1, 5, 1, 6],
            [2, 5, 1, 5],
        ],
    },
    {
        date: 1520111980052,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 10],
            [10, 2, 2, 10],
            [4, 10, 2, 10],
            [2, 10, 2, 8],
            [2, 8, 6, 6],
            [4, 10, 6, 6],
            [6, 6, 10, 8],
            [10, 10, 8, 10],
            [6, 6, 8, 10],
            [10, 10, 10, 8],
            [10, 2, 10, 4],
            [6, 6, 10, 4],
            [8, 2, 6, 6],
            [8, 2, 10, 2],
            [4, 2, 6, 6],
            [2, 4, 6, 6],
            [2, 2, 2, 4],
            [4, 2, 2, 2],
            [8, 6, 10, 5],
            [10, 7, 8, 6],
            [10, 5, 10, 7],
            [5, 2, 7, 2],
            [6, 4, 5, 2],
            [7, 2, 6, 4],
            [2, 7, 2, 5],
            [4, 6, 2, 7],
            [2, 5, 4, 6],
            [6, 8, 5, 10],
            [7, 10, 6, 8],
            [5, 10, 7, 10],
        ],
    },
    {
        date: 1512939865735,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 4, 3],
            [6, 1, 8, 3],
            [8, 3, 3, 5],
            [4, 3, 9, 5],
            [1, 9, 9, 5],
            [3, 5, 11, 9],
            [11, 9, 1, 9],
            [6, 1, 6, 4],
            [6, 4, 6, 7],
            [6, 7, 6, 9],
            [4, 3, 4, 4],
            [8, 3, 8, 4],
            [9, 5, 9, 6],
            [3, 5, 3, 6],
            [1, 9, 1, 10],
            [11, 9, 11, 10],
            [6, 9, 6, 11],
        ],
    },
    {
        date: 1512939784300,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 4, 3],
            [6, 1, 8, 3],
            [6, 1, 3, 6],
            [6, 1, 9, 6],
            [6, 1, 3, 8],
            [6, 1, 9, 8],
            [8, 9, 6, 1],
            [6, 1, 4, 9],
            [4, 9, 8, 9],
            [6, 9, 6, 11],
        ],
    },
    {
        date: 1511787115097,
        row: 11,
        col: 11,
        segments: [
            [2, 6, 5, 7],
            [5, 7, 6, 10],
            [6, 10, 7, 7],
            [7, 7, 10, 6],
            [10, 6, 7, 5],
            [7, 5, 6, 2],
            [6, 2, 5, 5],
            [5, 5, 2, 6],
            [6, 2, 6, 10],
            [2, 6, 10, 6],
            [5, 5, 7, 7],
            [5, 7, 7, 5],
            [2, 6, 6, 2],
            [6, 2, 10, 6],
            [2, 6, 6, 10],
            [10, 6, 6, 10],
            [2, 6, 2, 10],
            [2, 10, 10, 10],
            [10, 10, 10, 2],
            [10, 2, 2, 2],
            [2, 2, 2, 6],
            [2, 2, 5, 5],
            [10, 2, 7, 5],
            [2, 10, 5, 7],
            [7, 7, 10, 10],
            [4, 2, 2, 4],
            [2, 8, 4, 10],
            [8, 10, 10, 8],
            [8, 2, 10, 4],
            [7, 2, 10, 5],
            [10, 7, 7, 10],
            [2, 7, 5, 10],
            [2, 5, 5, 2],
            [3, 2, 5, 3],
            [2, 3, 3, 5],
            [3, 10, 5, 9],
            [2, 9, 3, 7],
            [9, 10, 7, 9],
            [10, 9, 9, 7],
            [9, 2, 7, 3],
            [10, 3, 9, 5],
            [5, 5, 5, 7],
            [7, 7, 7, 5],
            [7, 7, 5, 7],
            [5, 5, 7, 5],
            [2, 3, 3, 2],
            [9, 2, 10, 3],
            [9, 10, 10, 9],
            [2, 9, 3, 10],
            [5, 7, 5, 9],
            [5, 3, 5, 5],
            [7, 3, 7, 9],
            [3, 5, 9, 5],
            [3, 7, 9, 7],
            [4, 5, 5, 4],
            [7, 4, 8, 5],
            [8, 7, 7, 8],
            [4, 7, 5, 8],
            [5, 10, 5, 9],
            [7, 10, 7, 9],
            [7, 9, 7, 2],
            [5, 2, 5, 8],
        ],
    },
    {
        date: 1504712225555,
        row: 11,
        col: 11,
        segments: [
            [2, 11, 2, 7],
            [2, 7, 5, 4],
            [5, 4, 7, 4],
            [8, 4, 10, 7],
            [10, 7, 10, 11],
            [5, 4, 8, 4],
            [10, 11, 2, 11],
            [7, 4, 7, 3],
            [8, 4, 8, 3],
            [7, 2, 7, 3],
            [8, 2, 8, 3],
            [2, 7, 10, 7],
            [4, 11, 4, 9],
            [4, 9, 5, 9],
            [5, 11, 5, 9],
            [7, 10, 8, 10],
            [8, 9, 7, 9],
            [7, 9, 7, 10],
            [8, 9, 8, 10],
            [8, 2, 7, 2],
            [6, 5, 6, 6],
            [7, 6, 7, 5],
            [6, 5, 7, 5],
            [6, 6, 7, 6],
            [6, 5, 7, 6],
            [6, 6, 7, 5],
        ],
    },
    {
        date: 1505733478433,
        row: 11,
        col: 11,
        segments: [
            [5, 2, 9, 2],
            [7, 5, 9, 2],
            [5, 2, 2, 5],
            [7, 5, 2, 5],
            [9, 2, 11, 5],
            [7, 5, 11, 5],
            [7, 5, 7, 8],
            [11, 5, 11, 8],
            [7, 8, 11, 8],
            [7, 8, 2, 8],
            [2, 5, 2, 8],
            [3, 6, 3, 7],
            [4, 7, 4, 6],
            [3, 6, 4, 6],
            [4, 7, 3, 7],
            [5, 6, 5, 7],
            [6, 7, 6, 6],
            [5, 6, 6, 6],
            [5, 7, 6, 7],
            [8, 8, 8, 6],
            [9, 6, 9, 8],
            [8, 6, 9, 6],
            [6, 3, 6, 1],
            [7, 1, 6, 1],
            [7, 1, 7, 3],
            [6, 3, 7, 3],
            [8, 8, 8, 9],
            [7, 9, 8, 9],
            [9, 8, 9, 9],
            [9, 10, 9, 9],
            [9, 10, 8, 10],
            [8, 10, 7, 10],
            [7, 10, 7, 11],
            [7, 9, 6, 9],
            [6, 9, 6, 10],
            [6, 10, 6, 11],
        ],
    },
    {
        date: 1507975270946,
        row: 11,
        col: 11,
        segments: [
            [11, 8, 11, 11],
            [1, 8, 11, 8],
            [1, 11, 1, 8],
            [1, 11, 11, 11],
            [8, 8, 8, 5],
            [4, 5, 4, 8],
            [4, 5, 8, 5],
            [7, 5, 7, 3],
            [6, 5, 6, 3],
            [5, 5, 5, 3],
            [1, 8, 2, 9],
            [3, 8, 2, 9],
            [3, 8, 4, 9],
            [5, 8, 4, 9],
            [5, 8, 6, 9],
            [7, 8, 6, 9],
            [7, 8, 8, 9],
            [8, 9, 9, 8],
            [9, 8, 10, 9],
            [10, 9, 11, 8],
        ],
    },
    {
        date: 1508488916043,
        row: 11,
        col: 11,
        segments: [
            [4, 1, 1, 6],
            [1, 6, 3, 4],
            [3, 4, 3, 6],
            [3, 6, 4, 10],
            [8, 1, 11, 6],
            [11, 6, 9, 4],
            [9, 4, 9, 6],
            [9, 6, 8, 10],
            [8, 10, 7, 11],
            [4, 10, 5, 11],
            [5, 11, 7, 11],
            [5, 6, 4, 7],
            [4, 7, 5, 7],
            [5, 7, 5, 6],
            [7, 6, 7, 7],
            [7, 7, 8, 7],
            [8, 7, 7, 6],
            [4, 4, 4, 1],
            [8, 1, 8, 4],
            [8, 4, 6, 3],
            [6, 3, 4, 4],
            [4, 6, 5, 5],
            [7, 5, 8, 6],
            [6, 7, 5, 9],
            [5, 9, 7, 9],
            [7, 9, 6, 7],
            [4, 9, 5, 10],
            [5, 10, 7, 10],
            [7, 10, 8, 9],
            [8, 8, 10, 7],
            [8, 8, 11, 9],
            [8, 8, 11, 10],
            [4, 8, 2, 7],
            [4, 8, 1, 9],
            [4, 8, 1, 10],
        ],
    },
    {
        date: 1508577299014,
        row: 11,
        col: 11,
        segments: [
            [11, 11, 1, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [1, 11, 1, 1],
            [1, 11, 2, 10],
            [2, 10, 3, 11],
            [11, 11, 10, 10],
            [10, 10, 9, 11],
            [9, 11, 8, 10],
            [8, 10, 7, 11],
            [7, 11, 6, 10],
            [6, 10, 5, 11],
            [5, 11, 4, 10],
            [4, 10, 3, 11],
            [11, 10, 1, 10],
            [11, 1, 10, 2],
            [10, 2, 9, 1],
            [9, 1, 8, 2],
            [8, 2, 7, 1],
            [7, 1, 6, 2],
            [6, 2, 5, 1],
            [5, 1, 4, 2],
            [4, 2, 3, 1],
            [3, 1, 2, 2],
            [2, 2, 1, 1],
            [11, 2, 1, 2],
            [1, 10, 6, 3],
            [6, 3, 11, 10],
            [2, 10, 6, 4],
            [3, 10, 6, 5],
            [4, 10, 6, 6],
            [6, 4, 10, 10],
            [6, 5, 9, 10],
            [6, 6, 8, 10],
            [5, 10, 6, 7],
            [6, 7, 7, 10],
            [6, 10, 6, 8],
        ],
    },
    {
        date: 1498750027378,
        row: 11,
        col: 11,
        segments: [
            [6, 6, 7, 5],
            [7, 5, 5, 5],
            [6, 6, 5, 5],
            [6, 6, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 6, 6],
            [4, 5, 5, 4],
            [5, 4, 7, 4],
            [7, 4, 8, 5],
            [8, 5, 8, 7],
            [8, 7, 7, 8],
            [7, 8, 5, 8],
            [5, 8, 4, 7],
            [4, 7, 4, 5],
            [6, 4, 5, 1],
            [5, 1, 7, 1],
            [7, 1, 6, 4],
            [4, 6, 1, 5],
            [1, 5, 1, 7],
            [1, 7, 4, 6],
            [6, 8, 5, 11],
            [5, 11, 7, 11],
            [7, 11, 6, 8],
            [8, 6, 11, 5],
            [11, 5, 11, 7],
            [11, 7, 8, 6],
            [6, 2, 10, 6],
            [10, 6, 6, 10],
            [6, 10, 2, 6],
            [2, 6, 6, 2],
            [7, 3, 9, 3],
            [9, 3, 9, 5],
            [9, 7, 9, 9],
            [9, 9, 7, 9],
            [5, 9, 3, 9],
            [3, 9, 3, 7],
            [3, 5, 3, 3],
            [3, 3, 5, 3],
            [1, 6, 6, 1],
            [6, 1, 11, 6],
            [11, 6, 6, 11],
            [6, 11, 1, 6],
            [7, 2, 10, 2],
            [10, 2, 10, 5],
            [10, 7, 10, 10],
            [10, 10, 7, 10],
            [5, 10, 2, 10],
            [2, 10, 2, 7],
            [2, 5, 2, 2],
            [2, 2, 5, 2],
        ],
    },
    {
        date: 1498730068163,
        row: 11,
        col: 11,
        segments: [
            [1, 2, 1, 10],
            [1, 10, 11, 10],
            [1, 2, 11, 2],
            [11, 2, 11, 10],
            [6, 2, 6, 10],
            [6, 10, 11, 2],
            [6, 10, 1, 2],
            [6, 2, 1, 10],
            [6, 2, 11, 10],
            [10, 10, 6, 3],
            [6, 3, 2, 10],
            [11, 3, 7, 10],
            [10, 2, 6, 9],
            [6, 9, 2, 2],
            [1, 3, 5, 10],
            [1, 9, 5, 2],
            [7, 2, 11, 9],
        ],
    },
    {
        date: 1498729725478,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [11, 1, 6, 6],
            [6, 6, 6, 1],
            [6, 6, 11, 6],
            [11, 6, 6, 1],
            [6, 6, 1, 11],
            [6, 6, 1, 6],
            [6, 6, 6, 11],
            [6, 11, 1, 6],
            [1, 6, 6, 1],
            [11, 6, 6, 11],
            [4, 3, 8, 3],
            [8, 3, 8, 8],
            [8, 8, 4, 8],
            [4, 8, 4, 3],
            [1, 3, 11, 3],
            [11, 3, 1, 6],
            [1, 6, 11, 9],
            [11, 9, 1, 9],
        ],
    },
    {
        date: 1496689767849,
        row: 11,
        col: 11,
        segments: [
            [2, 10, 2, 5],
            [3, 5, 2, 5],
            [3, 6, 3, 5],
            [3, 6, 4, 6],
            [4, 6, 4, 5],
            [4, 5, 5, 5],
            [5, 5, 5, 6],
            [5, 6, 6, 6],
            [6, 6, 6, 5],
            [6, 5, 7, 5],
            [7, 5, 7, 6],
            [7, 6, 8, 6],
            [8, 4, 8, 6],
            [8, 4, 10, 4],
            [10, 4, 10, 10],
            [10, 10, 2, 10],
            [5, 8, 5, 10],
            [5, 8, 7, 8],
            [7, 8, 7, 10],
            [8, 2, 8, 4],
            [8, 2, 9, 3],
            [9, 3, 8, 3],
        ],
    },
    {
        date: 1497537468115,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 2],
            [11, 2, 1, 3],
            [1, 3, 11, 4],
            [11, 4, 1, 5],
            [1, 5, 11, 6],
            [11, 6, 1, 7],
            [1, 7, 11, 8],
            [11, 8, 1, 9],
            [1, 9, 11, 10],
            [11, 10, 1, 11],
            [11, 11, 1, 10],
            [1, 10, 11, 9],
            [11, 9, 1, 8],
            [1, 8, 11, 7],
            [11, 7, 1, 6],
            [1, 6, 11, 5],
            [11, 5, 1, 4],
            [1, 4, 11, 3],
            [1, 2, 11, 2],
            [1, 2, 11, 1],
            [6, 11, 6, 1],
            [6, 1, 1, 11],
            [6, 1, 11, 11],
            [1, 1, 11, 11],
            [1, 11, 11, 1],
            [1, 6, 11, 6],
            [1, 5, 11, 5],
            [11, 4, 1, 4],
            [1, 3, 11, 3],
            [11, 3, 1, 2],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [1, 7, 11, 7],
            [11, 8, 1, 8],
            [1, 9, 11, 9],
            [11, 10, 1, 10],
        ],
    },
    {
        date: 1495367839771,
        row: 11,
        col: 11,
        segments: [
            [4, 5, 6, 9],
            [6, 9, 6, 10],
            [7, 10, 6, 10],
            [7, 10, 7, 9],
            [7, 9, 6, 9],
            [7, 9, 9, 5],
            [5, 5, 6, 6],
            [6, 6, 6, 5],
            [6, 5, 5, 5],
            [7, 5, 7, 6],
            [7, 6, 8, 5],
            [8, 5, 7, 5],
            [7, 9, 8, 8],
            [7, 9, 8, 9],
            [7, 9, 8, 10],
            [6, 9, 5, 8],
            [6, 9, 5, 9],
            [6, 9, 5, 10],
            [4, 5, 4, 1],
            [4, 1, 5, 3],
            [5, 3, 8, 3],
            [8, 3, 9, 1],
            [9, 1, 9, 5],
            [8, 7, 10, 11],
            [10, 11, 3, 11],
            [3, 11, 5, 7],
        ],
    },
    {
        date: 1495367405629,
        row: 11,
        col: 11,
        segments: [
            [6, 4, 7, 5],
            [7, 5, 6, 5],
            [6, 5, 6, 4],
            [7, 4, 7, 5],
            [7, 4, 8, 5],
            [8, 5, 7, 5],
            [7, 3, 10, 6],
            [10, 6, 6, 6],
            [6, 6, 5, 5],
            [5, 5, 6, 7],
            [6, 7, 8, 7],
            [8, 7, 6, 8],
            [7, 3, 7, 1],
            [6, 3, 7, 1],
            [6, 3, 6, 1],
            [6, 1, 5, 3],
            [5, 3, 2, 8],
            [6, 8, 4, 6],
            [5, 7, 6, 11],
            [2, 8, 1, 11],
            [1, 11, 6, 11],
        ],
    },
    {
        date: 1495367319801,
        row: 11,
        col: 11,
        segments: [
            [6, 6, 5, 6],
            [5, 6, 5, 5],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [7, 7, 4, 7],
            [4, 7, 4, 4],
            [4, 4, 8, 4],
            [8, 4, 8, 5],
            [8, 5, 7, 6],
            [8, 5, 9, 4],
            [9, 4, 9, 3],
            [9, 3, 10, 3],
            [10, 3, 10, 4],
            [10, 4, 8, 7],
            [8, 7, 7, 8],
            [7, 8, 1, 8],
            [1, 8, 4, 7],
            [9, 3, 8, 2],
            [10, 3, 9, 2],
        ],
    },
    {
        date: 1495290119451,
        row: 11,
        col: 11,
        segments: [
            [9, 3, 3, 3],
            [3, 3, 3, 9],
            [3, 9, 9, 9],
            [9, 9, 9, 3],
            [9, 5, 3, 5],
            [3, 7, 9, 7],
            [7, 8, 3, 8],
            [7, 7, 7, 9],
        ],
    },
    {
        date: 1495111682942,
        row: 11,
        col: 11,
        segments: [
            [3, 11, 3, 7],
            [9, 7, 9, 11],
            [9, 11, 3, 11],
            [4, 5, 4, 7],
            [8, 5, 4, 5],
            [8, 7, 8, 5],
            [5, 5, 5, 3],
            [7, 3, 5, 3],
            [7, 5, 7, 3],
            [6, 2, 6, 3],
            [3, 7, 9, 7],
            [4, 7, 5, 5],
            [5, 5, 5, 7],
            [6, 5, 5, 7],
            [6, 7, 6, 5],
            [6, 5, 7, 5],
            [7, 5, 6, 7],
            [7, 7, 6, 7],
            [7, 5, 7, 7],
            [7, 7, 8, 5],
            [3, 8, 4, 9],
            [4, 9, 5, 8],
            [5, 8, 6, 9],
            [6, 9, 7, 8],
            [7, 8, 8, 9],
            [8, 9, 9, 8],
            [3, 11, 4, 10],
            [5, 11, 4, 10],
            [5, 11, 6, 10],
            [7, 11, 6, 10],
            [8, 10, 7, 11],
            [8, 10, 9, 11],
            [3, 8, 9, 8],
            [3, 8, 4, 7],
            [4, 7, 5, 8],
            [5, 8, 6, 7],
            [7, 8, 6, 7],
            [8, 7, 7, 8],
            [9, 8, 8, 7],
            [5, 5, 7, 3],
            [5, 3, 7, 5],
            [6, 3, 6, 5],
            [5, 4, 7, 4],
            [10, 3, 9, 3],
            [9, 3, 9, 4],
            [9, 4, 10, 4],
            [10, 4, 10, 3],
            [9, 4, 10, 3],
            [9, 3, 10, 4],
            [2, 2, 2, 3],
            [3, 3, 2, 3],
            [2, 2, 3, 2],
            [3, 3, 3, 2],
            [2, 2, 3, 3],
            [2, 3, 3, 2],
            [10, 6, 10, 7],
            [10, 7, 11, 7],
            [11, 7, 11, 6],
            [10, 6, 11, 6],
            [10, 6, 11, 7],
            [10, 7, 11, 6],
            [7, 1, 7, 2],
            [8, 2, 8, 1],
            [8, 1, 7, 1],
            [7, 2, 8, 2],
            [7, 2, 8, 1],
            [7, 1, 8, 2],
            [4, 2, 4, 1],
            [4, 1, 5, 1],
            [5, 2, 5, 1],
            [4, 2, 5, 2],
            [4, 2, 5, 1],
            [4, 1, 5, 2],
            [2, 5, 2, 6],
            [1, 6, 2, 6],
            [1, 5, 1, 6],
            [2, 5, 1, 5],
            [1, 5, 2, 6],
            [1, 6, 2, 5],
            [2, 8, 2, 9],
            [1, 9, 2, 9],
            [1, 9, 1, 8],
            [2, 8, 1, 8],
            [1, 8, 2, 9],
            [1, 9, 2, 8],
            [10, 9, 10, 10],
            [10, 10, 11, 10],
            [11, 10, 11, 9],
            [11, 9, 10, 9],
            [10, 10, 11, 9],
            [10, 9, 11, 10],
            [11, 1, 1, 1],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
        ],
    },
    {
        date: 1494155375078,
        row: 11,
        col: 11,
        segments: [
            [1, 2, 2, 1],
            [2, 1, 4, 1],
            [4, 1, 5, 2],
            [5, 2, 7, 2],
            [7, 2, 8, 1],
            [8, 1, 10, 1],
            [10, 1, 11, 2],
            [11, 2, 11, 4],
            [11, 4, 9, 4],
            [3, 4, 1, 4],
            [1, 4, 1, 2],
            [4, 4, 5, 4],
            [5, 4, 5, 5],
            [5, 5, 4, 5],
            [4, 5, 4, 4],
            [8, 4, 7, 4],
            [7, 4, 7, 5],
            [7, 5, 8, 5],
            [8, 5, 8, 4],
            [2, 4, 3, 8],
            [10, 4, 9, 8],
            [8, 8, 10, 8],
            [10, 8, 10, 10],
            [10, 10, 9, 11],
            [2, 8, 4, 8],
            [2, 8, 2, 10],
            [2, 10, 3, 11],
            [3, 11, 9, 11],
            [5, 8, 7, 8],
            [4, 9, 5, 8],
            [8, 9, 7, 8],
            [4, 9, 8, 9],
            [6, 9, 6, 10],
            [6, 10, 5, 11],
            [6, 10, 7, 11],
        ],
    },
    {
        date: 1494158121026,
        row: 11,
        col: 11,
        segments: [
            [1, 3, 3, 1],
            [3, 1, 9, 1],
            [11, 3, 9, 1],
            [1, 7, 1, 3],
            [11, 7, 11, 3],
            [3, 3, 9, 3],
            [2, 4, 3, 3],
            [10, 4, 9, 3],
            [2, 5, 2, 4],
            [3, 6, 2, 5],
            [9, 6, 10, 5],
            [10, 4, 10, 5],
            [8, 4, 7, 4],
            [4, 4, 5, 4],
            [4, 5, 5, 5],
            [7, 5, 8, 5],
            [5, 4, 5, 5],
            [4, 4, 4, 5],
            [7, 4, 7, 5],
            [8, 4, 8, 5],
            [3, 8, 1, 7],
            [9, 8, 11, 7],
            [3, 6, 3, 10],
            [9, 6, 9, 10],
            [8, 11, 4, 11],
            [4, 11, 3, 10],
            [9, 10, 8, 11],
            [4, 10, 8, 10],
            [8, 10, 9, 9],
            [3, 9, 4, 10],
            [4, 11, 4, 10],
            [8, 10, 8, 11],
            [7, 11, 7, 10],
            [6, 10, 6, 11],
            [5, 10, 5, 11],
            [7, 9, 5, 9],
            [6, 6, 7, 9],
            [5, 9, 6, 6],
        ],
    },
    {
        date: 1494164357534,
        row: 11,
        col: 11,
        segments: [
            [1, 7, 2, 6],
            [1, 7, 4, 11],
            [4, 11, 6, 9],
            [6, 9, 2, 6],
            [2, 6, 4, 11],
            [1, 7, 6, 9],
            [10, 6, 11, 7],
            [11, 7, 8, 11],
            [8, 11, 6, 9],
            [6, 9, 10, 6],
            [10, 6, 8, 11],
            [6, 9, 11, 7],
            [1, 5, 2, 6],
            [10, 6, 11, 5],
            [11, 5, 8, 1],
            [8, 1, 6, 3],
            [6, 3, 4, 1],
            [4, 1, 1, 5],
            [2, 6, 6, 3],
            [6, 3, 10, 6],
            [10, 6, 8, 1],
            [6, 3, 11, 5],
            [4, 1, 2, 6],
            [1, 5, 6, 3],
            [1, 7, 1, 5],
            [1, 6, 2, 6],
            [10, 6, 11, 6],
            [11, 5, 11, 7],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [4, 11, 8, 11],
            [4, 1, 8, 1],
            [6, 1, 5, 2],
            [6, 1, 7, 2],
            [6, 5, 5, 6],
            [6, 7, 7, 6],
            [7, 6, 6, 5],
            [5, 6, 6, 7],
        ],
    },
    {
        date: 1494164580706,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 6, 11],
            [1, 6, 11, 6],
            [1, 1, 11, 11],
            [11, 1, 1, 11],
            [7, 7, 6, 11],
            [8, 8, 6, 11],
            [9, 9, 6, 11],
            [10, 10, 6, 11],
            [5, 7, 6, 11],
            [4, 8, 6, 11],
            [3, 9, 6, 11],
            [2, 10, 6, 11],
            [11, 6, 7, 7],
            [8, 8, 11, 6],
            [9, 9, 11, 6],
            [10, 10, 11, 6],
            [1, 6, 5, 7],
            [4, 8, 1, 6],
            [3, 9, 1, 6],
            [2, 10, 1, 6],
            [11, 1, 1, 1],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [2, 2, 1, 6],
            [3, 3, 1, 6],
            [4, 4, 1, 6],
            [5, 5, 1, 6],
            [7, 5, 11, 6],
            [8, 4, 11, 6],
            [9, 3, 11, 6],
            [10, 2, 11, 6],
            [6, 1, 2, 2],
            [3, 3, 6, 1],
            [4, 4, 6, 1],
            [5, 5, 6, 1],
            [7, 5, 6, 1],
            [8, 4, 6, 1],
            [9, 3, 6, 1],
            [10, 2, 6, 1],
        ],
    },
    {
        date: 1494165268077,
        row: 11,
        col: 11,
        segments: [
            [1, 2, 5, 1],
            [6, 2, 5, 1],
            [6, 2, 7, 1],
            [7, 1, 11, 2],
            [1, 10, 5, 11],
            [5, 11, 6, 10],
            [6, 10, 7, 11],
            [7, 11, 11, 10],
            [2, 5, 1, 6],
            [1, 6, 2, 7],
            [2, 7, 1, 10],
            [1, 2, 2, 5],
            [11, 2, 10, 5],
            [10, 5, 11, 6],
            [11, 6, 10, 7],
            [10, 7, 11, 10],
            [5, 2, 6, 3],
            [6, 3, 7, 2],
            [7, 2, 10, 3],
            [10, 3, 9, 5],
            [9, 5, 10, 6],
            [10, 6, 9, 7],
            [9, 7, 10, 9],
            [10, 9, 7, 10],
            [7, 10, 6, 9],
            [6, 9, 5, 10],
            [5, 10, 2, 9],
            [2, 9, 3, 7],
            [3, 7, 2, 6],
            [2, 6, 3, 5],
            [3, 5, 2, 3],
            [2, 3, 5, 2],
            [6, 4, 7, 3],
            [6, 4, 5, 3],
            [6, 8, 7, 9],
            [6, 8, 5, 9],
            [4, 7, 3, 6],
            [3, 6, 4, 5],
            [8, 5, 9, 6],
            [9, 6, 8, 7],
            [3, 4, 5, 3],
            [3, 4, 4, 5],
            [7, 3, 9, 4],
            [9, 4, 8, 5],
            [8, 7, 9, 8],
            [9, 8, 7, 9],
            [4, 7, 3, 8],
            [3, 8, 5, 9],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [6, 7, 5, 8],
            [7, 8, 6, 7],
            [5, 5, 4, 6],
            [4, 6, 5, 7],
            [7, 5, 8, 6],
            [8, 6, 7, 7],
            [8, 4, 7, 5],
            [7, 4, 8, 4],
            [5, 4, 4, 4],
            [4, 4, 5, 5],
            [5, 7, 4, 8],
            [4, 8, 5, 8],
            [7, 8, 8, 8],
            [8, 8, 7, 7],
            [4, 6, 8, 6],
            [6, 5, 6, 7],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 5],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [3, 2, 5, 4],
            [5, 4, 7, 2],
            [3, 2, 7, 2],
            [5, 4, 5, 6],
            [4, 6, 6, 6],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [10, 2, 2, 4],
            [6, 10, 2, 4],
            [10, 2, 6, 10],
            [8, 6, 6, 3],
            [6, 3, 4, 7],
            [4, 7, 8, 6],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 5, 2],
            [5, 2, 5, 5],
            [5, 5, 2, 5],
            [2, 5, 2, 2],
            [5, 7, 8, 5],
            [8, 5, 10, 8],
            [10, 8, 7, 10],
            [7, 10, 5, 7],
            [3, 8, 5, 8],
            [5, 8, 5, 10],
            [5, 10, 3, 10],
            [3, 10, 3, 8],
            [8, 2, 7, 3],
            [7, 3, 8, 4],
            [8, 4, 9, 3],
            [9, 3, 8, 2],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 5],
            [4, 4, 8, 4],
            [8, 4, 8, 8],
            [8, 8, 4, 8],
            [4, 8, 4, 4],
            [4, 4, 5, 5],
            [5, 7, 4, 8],
            [7, 7, 8, 8],
            [8, 4, 7, 5],
            [7, 3, 5, 3],
            [6, 1, 7, 3],
            [5, 3, 6, 1],
            [6, 1, 8, 3],
            [7, 4, 8, 3],
            [6, 1, 4, 3],
            [4, 3, 5, 4],
            [6, 1, 6, 2],
            [6, 2, 7, 3],
            [7, 3, 6, 4],
            [6, 4, 5, 3],
            [5, 3, 6, 2],
            [6, 1, 10, 4],
            [10, 4, 8, 8],
            [8, 8, 11, 11],
            [11, 11, 6, 9],
            [6, 9, 1, 11],
            [1, 11, 4, 8],
            [4, 8, 2, 4],
            [2, 4, 6, 1],
            [6, 6, 10, 9],
            [6, 11, 10, 9],
            [6, 11, 2, 9],
            [2, 9, 6, 6],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 2],
            [10, 2, 2, 10],
            [2, 10, 10, 10],
            [10, 10, 2, 2],
            [2, 2, 2, 10],
            [10, 2, 10, 10],
            [2, 6, 10, 6],
            [6, 2, 6, 10],
        ],
    },
    {
        date: 1430347120616,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 2],
            [10, 2, 10, 10],
            [10, 10, 2, 10],
            [2, 10, 2, 2],
            [2, 2, 10, 10],
            [10, 2, 2, 10],
            [6, 2, 6, 10],
            [2, 6, 10, 6],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [2, 3, 2, 1],
            [4, 1, 4, 3],
            [2, 1, 4, 1],
            [2, 3, 4, 3],
            [8, 1, 10, 1],
            [10, 1, 10, 3],
            [10, 3, 8, 3],
            [8, 3, 8, 1],
            [3, 4, 4, 3],
            [6, 2, 4, 3],
            [6, 2, 8, 3],
            [8, 3, 9, 4],
            [6, 9, 9, 4],
            [6, 9, 3, 4],
            [6, 9, 5, 10],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [7, 10, 6, 9],
            [7, 7, 9, 8],
            [7, 7, 9, 9],
            [7, 7, 8, 9],
            [5, 7, 4, 9],
            [5, 7, 3, 9],
            [5, 7, 3, 8],
            [5, 4, 4, 5],
            [6, 5, 4, 5],
            [6, 5, 5, 4],
            [6, 5, 7, 4],
            [7, 4, 8, 5],
            [8, 5, 6, 5],
            [5, 4, 5, 5],
            [7, 4, 7, 5],
            [5, 7, 3, 7],
            [7, 7, 9, 7],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [3, 11, 2, 10],
            [2, 10, 3, 8],
            [3, 8, 9, 8],
            [9, 8, 10, 10],
            [10, 10, 9, 11],
            [9, 11, 3, 11],
            [3, 9, 4, 10],
            [4, 10, 8, 10],
            [8, 10, 9, 9],
            [4, 7, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 5, 7],
            [5, 7, 4, 7],
            [4, 6, 5, 6],
            [7, 4, 7, 7],
            [7, 7, 8, 7],
            [8, 7, 8, 6],
            [8, 6, 7, 6],
            [8, 6, 8, 4],
            [7, 4, 8, 4],
            [5, 7, 7, 7],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [3, 8, 3, 3],
            [3, 3, 4, 2],
            [4, 2, 6, 3],
            [6, 3, 8, 2],
            [8, 2, 9, 3],
            [9, 3, 9, 8],
            [9, 4, 10, 4],
            [10, 4, 11, 5],
            [11, 7, 11, 5],
            [11, 7, 9, 8],
            [10, 5, 10, 7],
            [10, 5, 9, 4],
            [10, 7, 9, 8],
            [3, 4, 2, 4],
            [2, 4, 1, 5],
            [1, 5, 1, 7],
            [1, 7, 3, 8],
            [3, 4, 2, 5],
            [2, 5, 2, 7],
            [2, 7, 3, 8],
            [3, 3, 4, 1],
            [4, 1, 8, 1],
            [8, 1, 9, 3],
            [4, 3, 5, 3],
            [5, 3, 6, 4],
            [6, 4, 7, 3],
            [7, 3, 8, 3],
            [5, 2, 7, 2],
            [3, 9, 9, 9],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [1, 5, 2, 1],
            [2, 1, 3, 3],
            [11, 5, 10, 1],
            [10, 1, 9, 3],
            [3, 3, 4, 2],
            [4, 2, 8, 2],
            [8, 2, 9, 3],
            [2, 5, 2, 3],
            [2, 3, 3, 5],
            [3, 5, 2, 5],
            [10, 5, 10, 3],
            [10, 3, 9, 5],
            [9, 5, 10, 5],
            [4, 6, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 5, 6],
            [5, 6, 4, 6],
            [7, 4, 7, 6],
            [7, 6, 8, 6],
            [8, 6, 8, 4],
            [8, 4, 7, 4],
            [7, 5, 8, 5],
            [4, 5, 5, 5],
            [5, 6, 5, 8],
            [5, 8, 7, 8],
            [7, 8, 7, 6],
            [7, 7, 8, 7],
            [8, 7, 8, 9],
            [5, 7, 4, 7],
            [4, 7, 4, 9],
            [4, 9, 5, 9],
            [5, 8, 5, 9],
            [8, 9, 7, 9],
            [7, 9, 7, 8],
            [1, 5, 2, 8],
            [2, 8, 2, 10],
            [2, 10, 10, 10],
            [10, 10, 10, 8],
            [10, 8, 11, 5],
            [5, 9, 6, 10],
            [7, 9, 6, 10],
            [3, 10, 6, 11],
            [6, 11, 9, 10],
            [6, 5, 6, 7],
            [6, 2, 6, 1],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [2, 1, 3, 3],
            [9, 3, 3, 3],
            [3, 9, 3, 3],
            [4, 4, 3, 9],
            [4, 4, 9, 3],
            [11, 11, 4, 4],
            [6, 4, 11, 11],
            [4, 6, 11, 11],
            [4, 6, 4, 4],
            [4, 4, 6, 4],
            [6, 4, 4, 6],
            [4, 6, 5, 3],
            [6, 4, 3, 5],
            [2, 1, 3, 7],
            [2, 1, 7, 3],
            [3, 3, 1, 2],
            [1, 2, 7, 3],
            [1, 2, 3, 7],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [11, 6, 6, 1],
            [1, 6, 6, 1],
            [6, 11, 11, 6],
            [6, 11, 1, 6],
            [9, 6, 6, 3],
            [9, 6, 6, 9],
            [6, 9, 3, 6],
            [3, 6, 6, 3],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [6, 7, 5, 6],
            [5, 6, 6, 5],
            [6, 6, 3, 3],
            [6, 6, 9, 3],
            [6, 6, 9, 9],
            [6, 6, 3, 9],
            [2, 10, 2, 2],
            [2, 2, 10, 2],
            [10, 2, 10, 10],
            [10, 10, 2, 10],
            [3, 3, 9, 3],
            [9, 9, 9, 3],
            [3, 9, 3, 3],
            [9, 9, 3, 9],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [9, 1, 11, 4],
            [9, 1, 8, 3],
            [4, 3, 8, 3],
            [3, 1, 4, 3],
            [3, 1, 1, 4],
            [4, 11, 1, 4],
            [8, 11, 11, 4],
            [8, 11, 4, 11],
            [4, 10, 8, 10],
            [7, 10, 6, 11],
            [6, 11, 5, 10],
            [5, 7, 3, 5],
            [3, 7, 3, 5],
            [5, 7, 3, 7],
            [4, 6, 4, 7],
            [4, 6, 3, 6],
            [9, 7, 7, 7],
            [7, 7, 9, 5],
            [9, 5, 9, 7],
            [9, 6, 8, 6],
            [8, 6, 8, 7],
            [5, 6, 3, 4],
            [7, 6, 9, 4],
            [4, 2, 4, 3],
            [5, 2, 5, 3],
            [6, 2, 6, 3],
            [7, 2, 7, 3],
            [8, 2, 8, 3],
            [3, 3, 3, 2],
            [2, 3, 3, 2],
            [3, 3, 2, 3],
            [10, 3, 9, 2],
            [9, 2, 9, 3],
            [9, 3, 10, 3],
            [5, 9, 2, 9],
            [5, 9, 2, 8],
            [5, 9, 3, 8],
            [7, 9, 10, 9],
            [7, 9, 10, 8],
            [7, 9, 9, 8],
            [6, 7, 6, 9],
            [6, 8, 7, 9],
            [6, 8, 5, 9],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [7, 8, 7, 9],
            [5, 8, 5, 9],
            [5, 7, 5, 8],
            [7, 7, 7, 8],
            [5, 6, 5, 7],
            [7, 6, 7, 7],
            [7, 6, 8, 5],
            [8, 4, 8, 5],
            [8, 4, 8, 3],
            [8, 3, 7, 2],
            [7, 2, 6, 2],
            [5, 2, 6, 2],
            [5, 6, 4, 5],
            [4, 4, 4, 5],
            [4, 3, 4, 4],
            [5, 2, 4, 3],
            [4, 4, 3, 4],
            [2, 4, 3, 4],
            [1, 5, 2, 4],
            [1, 5, 2, 5],
            [3, 5, 2, 5],
            [3, 5, 4, 5],
            [5, 3, 5, 4],
            [6, 4, 6, 3],
            [5, 3, 6, 3],
            [5, 4, 6, 4],
            [5, 9, 5, 11],
            [7, 9, 9, 9],
            [9, 9, 11, 10],
            [5, 2, 6, 1],
            [6, 2, 7, 1],
            [7, 2, 8, 1],
            [8, 1, 9, 2],
            [9, 2, 9, 4],
            [9, 4, 9, 5],
            [9, 4, 8, 6],
            [9, 4, 10, 6],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [4, 10, 4, 11],
            [8, 11, 8, 10],
            [4, 9, 4, 10],
            [8, 9, 8, 10],
            [3, 8, 4, 9],
            [9, 8, 8, 9],
            [3, 7, 3, 8],
            [9, 7, 9, 8],
            [3, 6, 3, 7],
            [9, 6, 9, 7],
            [4, 7, 5, 7],
            [6, 7, 5, 7],
            [7, 7, 6, 7],
            [8, 7, 7, 7],
            [7, 8, 8, 7],
            [4, 7, 5, 8],
            [6, 8, 5, 8],
            [6, 8, 7, 8],
            [3, 5, 3, 6],
            [9, 5, 9, 6],
            [5, 6, 6, 5],
            [7, 6, 6, 6],
            [7, 6, 6, 5],
            [5, 6, 6, 6],
            [3, 4, 3, 5],
            [9, 4, 9, 5],
            [3, 3, 3, 4],
            [9, 3, 9, 4],
            [4, 3, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 5, 3],
            [5, 3, 4, 3],
            [7, 3, 7, 4],
            [7, 4, 8, 4],
            [8, 4, 8, 3],
            [8, 3, 7, 3],
            [9, 2, 9, 3],
            [9, 2, 8, 1],
            [8, 1, 7, 1],
            [7, 1, 6, 1],
            [6, 1, 5, 1],
            [5, 1, 4, 1],
            [4, 1, 3, 2],
            [3, 2, 3, 3],
            [3, 3, 2, 2],
            [2, 2, 2, 3],
            [2, 3, 2, 4],
            [2, 4, 2, 5],
            [2, 5, 3, 5],
            [9, 3, 10, 2],
            [10, 2, 10, 3],
            [10, 3, 10, 4],
            [10, 5, 10, 4],
            [9, 5, 10, 5],
        ],
    },
    {
        date: 1415514443207,
        row: 11,
        col: 11,
        segments: [
            [4, 7, 8, 7],
            [8, 7, 6, 9],
            [6, 9, 4, 7],
            [6, 9, 5, 10],
            [3, 10, 5, 10],
            [3, 10, 2, 9],
            [2, 9, 2, 8],
            [2, 8, 4, 7],
            [6, 9, 7, 10],
            [7, 10, 9, 10],
            [9, 10, 10, 9],
            [10, 9, 10, 8],
            [10, 8, 8, 7],
            [3, 10, 4, 11],
            [4, 11, 8, 11],
            [8, 11, 9, 10],
            [4, 10, 5, 11],
            [5, 11, 5, 10],
            [7, 10, 7, 11],
            [7, 11, 8, 10],
            [3, 5, 5, 7],
            [5, 7, 5, 5],
            [5, 5, 3, 5],
            [7, 7, 9, 5],
            [9, 5, 7, 5],
            [7, 5, 7, 7],
            [3, 7, 2, 6],
            [2, 4, 2, 6],
            [2, 4, 5, 4],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [7, 4, 10, 4],
            [10, 4, 10, 6],
            [10, 6, 9, 7],
            [4, 5, 4, 6],
            [8, 5, 8, 6],
            [3, 7, 1, 7],
            [1, 7, 2, 6],
            [2, 6, 1, 5],
            [1, 5, 2, 4],
            [2, 4, 1, 3],
            [1, 3, 2, 2],
            [2, 2, 3, 3],
            [3, 3, 3, 2],
            [3, 2, 4, 1],
            [4, 1, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 8, 1],
            [8, 1, 9, 2],
            [9, 2, 9, 3],
            [9, 3, 10, 2],
            [10, 2, 11, 3],
            [11, 3, 10, 4],
            [10, 4, 11, 5],
            [11, 5, 10, 6],
            [10, 6, 11, 7],
            [11, 7, 9, 7],
            [10, 7, 11, 8],
            [11, 8, 10, 9],
            [10, 9, 11, 10],
            [11, 10, 10, 10],
            [10, 10, 9, 10],
            [2, 7, 1, 8],
            [1, 8, 2, 9],
            [2, 9, 1, 10],
            [1, 10, 2, 10],
            [2, 10, 3, 10],
            [5, 10, 7, 10],
            [5, 8, 6, 8],
            [6, 8, 7, 8],
            [4, 6, 5, 6],
            [5, 6, 4, 5],
            [8, 6, 7, 6],
            [7, 6, 8, 5],
        ],
    },
    {
        date: 1416464549010,
        row: 11,
        col: 11,
        segments: [
            [6, 6, 5, 5],
            [7, 5, 6, 6],
            [6, 4, 5, 5],
            [7, 5, 6, 4],
            [6, 6, 7, 6],
            [7, 6, 8, 5],
            [8, 5, 9, 6],
            [7, 6, 8, 7],
            [8, 7, 9, 6],
            [5, 6, 6, 6],
            [5, 6, 4, 7],
            [3, 6, 4, 7],
            [4, 5, 3, 6],
            [4, 5, 5, 6],
            [6, 6, 5, 7],
            [6, 8, 5, 7],
            [6, 6, 7, 7],
            [6, 8, 7, 7],
        ],
    },
    {
        date: 1427877875675,
        row: 11,
        col: 11,
        segments: [
            [2, 1, 4, 1],
            [4, 1, 4, 3],
            [2, 3, 2, 1],
            [4, 3, 2, 3],
            [6, 2, 4, 3],
            [8, 3, 6, 2],
            [8, 3, 9, 4],
            [8, 3, 10, 3],
            [10, 3, 10, 1],
            [10, 1, 8, 1],
            [8, 1, 8, 3],
            [7, 11, 8, 10],
            [8, 10, 7, 9],
            [7, 9, 6, 10],
            [6, 10, 7, 11],
            [7, 9, 9, 4],
            [4, 3, 3, 4],
            [4, 5, 5, 4],
            [5, 4, 6, 5],
            [6, 5, 4, 5],
            [5, 5, 5, 4],
            [6, 5, 7, 4],
            [7, 4, 8, 5],
            [8, 5, 6, 5],
            [7, 5, 7, 4],
            [3, 4, 7, 9],
        ],
    },
    {
        date: 1428395198760,
        row: 11,
        col: 11,
        segments: [
            [4, 2, 4, 5],
            [8, 5, 8, 2],
            [8, 2, 4, 2],
            [4, 5, 8, 5],
            [6, 5, 6, 9],
            [7, 7, 6, 7],
            [6, 7, 5, 7],
            [6, 9, 8, 11],
            [6, 9, 5, 11],
            [8, 2, 10, 2],
            [8, 5, 10, 5],
            [10, 5, 10, 2],
            [4, 2, 2, 2],
            [2, 5, 4, 5],
            [2, 5, 2, 2],
            [5, 2, 5, 3],
            [4, 3, 5, 3],
            [7, 2, 7, 3],
            [8, 3, 7, 3],
            [7, 7, 8, 6],
            [7, 7, 8, 8],
            [5, 7, 4, 6],
            [5, 7, 4, 8],
            [5, 5, 5, 4],
            [6, 4, 6, 5],
            [5, 4, 6, 4],
            [6, 5, 7, 5],
            [7, 4, 6, 4],
            [7, 4, 7, 5],
            [9, 2, 9, 5],
            [3, 2, 3, 5],
        ],
    },
    {
        date: 1428395267685,
        row: 11,
        col: 11,
        segments: [
            [1, 2, 2, 1],
            [2, 1, 2, 2],
            [2, 2, 1, 2],
            [2, 2, 2, 3],
            [2, 2, 3, 2],
            [3, 2, 3, 3],
            [3, 3, 3, 4],
            [3, 4, 4, 4],
            [4, 4, 4, 5],
            [4, 5, 5, 5],
            [5, 5, 5, 6],
            [5, 6, 6, 6],
            [6, 6, 6, 7],
            [6, 7, 7, 7],
            [7, 7, 7, 8],
            [7, 8, 8, 8],
            [8, 8, 8, 9],
            [8, 9, 9, 9],
            [9, 9, 9, 10],
            [9, 10, 10, 10],
            [10, 10, 10, 11],
            [2, 3, 4, 3],
            [4, 3, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 5, 5],
            [5, 5, 6, 5],
            [6, 5, 6, 6],
            [6, 6, 7, 6],
            [7, 6, 7, 7],
            [7, 7, 8, 7],
            [8, 7, 8, 8],
            [8, 8, 9, 8],
            [9, 8, 9, 9],
            [9, 9, 10, 9],
            [10, 10, 10, 9],
            [10, 10, 11, 10],
            [11, 10, 10, 11],
            [10, 1, 11, 2],
            [11, 2, 10, 2],
            [10, 2, 10, 1],
            [10, 2, 9, 2],
            [10, 2, 10, 3],
            [10, 3, 9, 3],
            [9, 3, 8, 3],
            [9, 2, 9, 4],
            [9, 4, 7, 4],
            [7, 4, 7, 5],
            [8, 3, 8, 5],
            [8, 5, 7, 5],
            [7, 5, 6, 5],
            [7, 5, 7, 6],
            [6, 7, 5, 7],
            [5, 7, 5, 6],
            [5, 7, 4, 7],
            [4, 7, 4, 8],
            [4, 8, 5, 8],
            [5, 8, 5, 7],
            [4, 8, 3, 8],
            [3, 8, 3, 9],
            [3, 9, 4, 9],
            [4, 9, 4, 8],
            [3, 9, 2, 9],
            [2, 9, 2, 10],
            [2, 10, 1, 10],
            [2, 11, 2, 10],
            [2, 10, 3, 10],
            [3, 10, 3, 9],
            [1, 10, 2, 11],
            [1, 6, 11, 6],
            [6, 1, 6, 11],
            [3, 1, 6, 5],
            [6, 5, 9, 1],
            [6, 7, 3, 11],
            [6, 7, 9, 11],
            [7, 6, 11, 3],
            [7, 6, 11, 9],
            [5, 6, 1, 3],
            [5, 6, 1, 9],
        ],
    },
    {
        date: 1428395385638,
        row: 11,
        col: 11,
        segments: [
            [5, 7, 6, 7],
            [5, 7, 4, 9],
            [4, 9, 3, 7],
            [6, 7, 7, 9],
            [7, 9, 8, 7],
            [8, 7, 7, 6],
            [3, 7, 4, 6],
            [4, 6, 3, 5],
            [3, 5, 3, 4],
            [3, 4, 2, 3],
            [7, 6, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 9, 3],
            [2, 3, 4, 4],
            [9, 3, 7, 4],
            [7, 4, 6, 3],
            [4, 4, 5, 3],
            [5, 3, 5, 2],
            [5, 2, 6, 2],
            [6, 2, 6, 3],
            [5, 3, 6, 3],
            [5, 4, 5, 6],
            [6, 6, 6, 4],
            [7, 4, 7, 6],
            [7, 6, 7, 9],
            [4, 4, 4, 6],
            [4, 6, 4, 9],
            [4, 6, 5, 7],
            [7, 6, 6, 7],
            [5, 2, 4, 1],
            [6, 2, 7, 1],
            [9, 3, 10, 5],
            [10, 5, 8, 5],
            [2, 3, 1, 5],
            [1, 5, 3, 5],
            [3, 7, 1, 9],
            [1, 9, 4, 9],
            [8, 7, 10, 9],
            [10, 9, 7, 9],
            [10, 5, 9, 7],
            [9, 7, 10, 9],
            [1, 5, 2, 7],
            [2, 7, 1, 9],
        ],
    },
    {
        date: 1428395430125,
        row: 11,
        col: 11,
        segments: [
            [5, 7, 6, 7],
            [5, 7, 4, 9],
            [4, 9, 3, 7],
            [6, 7, 7, 9],
            [7, 9, 8, 7],
            [8, 7, 7, 6],
            [3, 7, 4, 6],
            [4, 6, 3, 5],
            [3, 5, 3, 4],
            [3, 4, 2, 3],
            [7, 6, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 9, 3],
            [2, 3, 4, 4],
            [9, 3, 7, 4],
            [7, 4, 6, 3],
            [4, 4, 5, 3],
            [5, 3, 5, 2],
            [5, 2, 6, 2],
            [6, 2, 6, 3],
            [5, 3, 6, 3],
            [5, 4, 5, 6],
            [6, 6, 6, 4],
            [7, 4, 7, 6],
            [7, 6, 7, 9],
            [4, 4, 4, 6],
            [4, 6, 4, 9],
            [4, 6, 5, 7],
            [7, 6, 6, 7],
            [5, 2, 4, 1],
            [6, 2, 7, 1],
            [9, 3, 10, 5],
            [10, 5, 8, 5],
            [2, 3, 1, 5],
            [1, 5, 3, 5],
            [3, 7, 1, 9],
            [1, 9, 4, 9],
            [8, 7, 10, 9],
            [10, 9, 7, 9],
            [10, 5, 9, 7],
            [9, 7, 10, 9],
            [1, 5, 2, 7],
            [2, 7, 1, 9],
            [6, 3, 9, 1],
            [9, 1, 9, 3],
            [5, 3, 2, 1],
            [2, 1, 2, 3],
            [3, 2, 3, 3],
            [8, 2, 8, 3],
            [8, 6, 9, 6],
            [2, 6, 3, 6],
            [8, 9, 9, 10],
            [9, 10, 10, 9],
            [1, 9, 2, 10],
            [2, 10, 3, 9],
        ],
    },
    {
        date: 1428395494218,
        row: 11,
        col: 11,
        segments: [
            [3, 2, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [1, 1, 3, 2],
            [3, 2, 2, 10],
            [2, 10, 10, 10],
            [10, 10, 10, 2],
            [10, 2, 3, 2],
            [3, 2, 4, 9],
            [4, 9, 9, 9],
            [9, 9, 9, 3],
            [9, 3, 3, 2],
            [4, 3, 3, 2],
            [4, 3, 5, 8],
            [5, 8, 8, 8],
            [3, 2, 8, 4],
            [8, 4, 8, 8],
            [1, 11, 11, 1],
            [1, 1, 11, 1],
            [1, 1, 1, 11],
            [2, 11, 1, 10],
            [1, 9, 3, 11],
            [4, 11, 1, 8],
            [1, 7, 5, 11],
            [6, 11, 1, 6],
            [1, 5, 7, 11],
            [8, 11, 1, 4],
            [1, 3, 9, 11],
            [10, 11, 1, 2],
            [1, 1, 11, 11],
            [11, 10, 2, 1],
            [3, 1, 11, 9],
            [11, 8, 4, 1],
            [5, 1, 11, 7],
            [11, 7, 6, 1],
            [7, 1, 11, 6],
            [8, 1, 11, 5],
            [9, 1, 11, 4],
            [10, 1, 11, 3],
            [1, 2, 2, 1],
            [2, 1, 3, 2],
            [3, 2, 4, 1],
            [4, 1, 5, 2],
            [5, 1, 4, 2],
        ],
    },
    {
        date: 1428395523912,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 4, 3],
            [6, 2, 8, 3],
            [8, 3, 8, 4],
            [8, 4, 6, 5],
            [6, 5, 4, 4],
            [4, 4, 4, 3],
            [5, 3, 5, 4],
            [5, 4, 7, 4],
            [7, 4, 7, 3],
            [7, 3, 5, 3],
            [6, 3, 6, 4],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [6, 4, 6, 5],
            [6, 2, 8, 2],
            [8, 2, 9, 3],
            [9, 3, 8, 4],
            [6, 2, 4, 2],
            [4, 2, 3, 3],
            [3, 3, 4, 4],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [6, 2, 6, 1],
            [7, 2, 8, 1],
            [8, 1, 8, 2],
            [5, 2, 4, 1],
            [4, 1, 4, 2],
            [8, 4, 8, 6],
            [8, 6, 7, 8],
            [7, 8, 5, 8],
            [5, 8, 4, 6],
            [4, 6, 4, 4],
            [5, 6, 7, 6],
            [7, 6, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 6],
            [8, 5, 9, 5],
            [9, 5, 9, 4],
            [9, 5, 10, 5],
            [9, 5, 9, 6],
            [9, 5, 10, 6],
            [9, 5, 10, 4],
            [4, 5, 3, 5],
            [3, 5, 3, 4],
            [3, 5, 3, 6],
            [3, 5, 2, 5],
            [3, 5, 2, 6],
            [3, 5, 2, 4],
            [5, 8, 5, 9],
            [7, 8, 7, 9],
            [7, 9, 7, 10],
            [7, 9, 8, 10],
            [7, 9, 8, 9],
            [7, 9, 6, 9],
            [5, 9, 6, 9],
            [5, 9, 5, 10],
            [5, 9, 4, 10],
            [5, 9, 4, 9],
            [5, 9, 6, 10],
            [7, 9, 6, 10],
            [6, 9, 6, 10],
            [6, 6, 6, 7],
        ],
    },
    {
        date: 1416501255643,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 2, 5],
            [6, 2, 8, 5],
            [2, 5, 8, 5],
            [6, 2, 6, 7],
            [2, 7, 9, 7],
            [3, 9, 2, 7],
            [9, 7, 8, 9],
            [3, 9, 8, 9],
        ],
    },
    {
        date: 1428395533385,
        row: 11,
        col: 11,
        segments: [
            [5, 7, 6, 7],
            [5, 7, 4, 9],
            [4, 9, 3, 7],
            [6, 7, 7, 9],
            [7, 9, 8, 7],
            [8, 7, 7, 6],
            [3, 7, 4, 6],
            [4, 6, 3, 5],
            [3, 5, 3, 4],
            [3, 4, 2, 3],
            [7, 6, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 9, 3],
            [2, 3, 4, 4],
            [9, 3, 7, 4],
            [7, 4, 6, 3],
            [4, 4, 5, 3],
            [5, 3, 5, 2],
            [5, 2, 6, 2],
            [6, 2, 6, 3],
            [5, 3, 6, 3],
            [5, 4, 5, 6],
            [6, 6, 6, 4],
            [7, 4, 7, 6],
            [7, 6, 7, 9],
            [4, 4, 4, 6],
            [4, 6, 4, 9],
            [4, 6, 5, 7],
            [7, 6, 6, 7],
            [5, 2, 4, 1],
            [6, 2, 7, 1],
            [9, 3, 10, 5],
            [10, 5, 8, 5],
            [2, 3, 1, 5],
            [1, 5, 3, 5],
            [3, 7, 1, 9],
            [1, 9, 4, 9],
            [8, 7, 10, 9],
            [10, 9, 7, 9],
            [10, 5, 9, 7],
            [9, 7, 10, 9],
            [1, 5, 2, 7],
            [2, 7, 1, 9],
            [6, 3, 9, 1],
            [9, 1, 9, 3],
            [5, 3, 2, 1],
            [2, 1, 2, 3],
            [3, 2, 3, 3],
            [8, 2, 8, 3],
            [8, 6, 9, 6],
            [2, 6, 3, 6],
            [8, 9, 9, 10],
            [9, 10, 10, 9],
            [1, 9, 2, 10],
            [2, 10, 3, 9],
            [4, 9, 5, 11],
            [7, 9, 6, 11],
            [6, 11, 5, 11],
            [5, 8, 5, 10],
            [6, 8, 6, 10],
        ],
    },
    {
        date: 1428396019612,
        row: 11,
        col: 11,
        segments: [
            [6, 5, 6, 7],
            [6, 7, 5, 7],
            [6, 7, 7, 7],
            [7, 7, 6, 6],
            [6, 6, 5, 7],
            [6, 5, 4, 3],
            [4, 3, 8, 3],
            [8, 3, 6, 5],
            [4, 3, 6, 4],
            [6, 4, 8, 3],
            [6, 4, 6, 3],
            [6, 4, 7, 3],
            [7, 3, 7, 2],
            [7, 2, 8, 2],
            [8, 3, 8, 2],
            [8, 2, 7, 3],
            [7, 2, 8, 3],
        ],
    },
    {
        date: 1428395989415,
        row: 11,
        col: 11,
        segments: [
            [3, 5, 3, 3],
            [3, 3, 5, 2],
            [5, 2, 7, 3],
            [7, 3, 7, 5],
            [7, 5, 8, 7],
            [3, 5, 2, 7],
            [2, 7, 2, 9],
            [2, 9, 5, 9],
            [5, 9, 5, 6],
            [8, 7, 8, 9],
            [8, 9, 5, 9],
            [5, 6, 6, 7],
            [5, 6, 4, 7],
            [3, 4, 7, 4],
            [7, 4, 5, 3],
            [3, 4, 5, 3],
            [4, 4, 4, 6],
            [6, 6, 6, 4],
            [4, 6, 6, 6],
            [6, 4, 4, 4],
            [5, 5, 6, 4],
            [5, 5, 6, 6],
            [4, 6, 5, 5],
            [5, 5, 4, 4],
            [5, 4, 5, 6],
            [4, 5, 6, 5],
            [6, 9, 8, 7],
            [2, 7, 4, 9],
            [4, 9, 6, 7],
            [6, 9, 4, 7],
        ],
    },
    {
        date: 1428396107981,
        row: 11,
        col: 11,
        segments: [
            [4, 2, 7, 2],
            [7, 2, 7, 4],
            [7, 4, 4, 4],
            [4, 4, 4, 2],
            [4, 2, 5, 1],
            [6, 2, 7, 1],
            [5, 2, 6, 1],
            [7, 2, 8, 1],
            [8, 1, 5, 1],
            [8, 1, 8, 4],
            [8, 4, 7, 4],
            [5, 3, 6, 3],
            [8, 4, 8, 8],
            [4, 4, 4, 8],
            [4, 8, 6, 8],
            [8, 8, 6, 8],
            [6, 8, 6, 6],
            [6, 6, 8, 8],
            [6, 6, 4, 8],
            [6, 6, 7, 8],
            [5, 8, 6, 6],
            [6, 6, 8, 5],
            [6, 6, 4, 5],
            [6, 6, 6, 4],
            [6, 6, 8, 7],
            [6, 6, 8, 6],
            [6, 6, 4, 7],
            [6, 6, 4, 6],
            [6, 6, 8, 4],
            [6, 6, 4, 4],
            [6, 5, 5, 4],
            [6, 5, 7, 4],
            [6, 6, 7, 4],
            [6, 6, 5, 4],
        ],
    },
    {
        date: 1428396393693,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [11, 1, 1, 11],
            [4, 2, 5, 1],
            [8, 1, 5, 1],
            [8, 1, 7, 2],
            [7, 2, 4, 2],
            [5, 2, 6, 1],
            [6, 2, 7, 1],
            [5, 2, 5, 4],
            [5, 4, 4, 4],
            [4, 4, 4, 5],
            [4, 5, 5, 5],
            [5, 5, 4, 8],
            [4, 8, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 8, 8],
            [8, 8, 7, 5],
            [7, 5, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 7, 4],
            [7, 4, 7, 2],
            [4, 3, 4, 6],
            [4, 5, 3, 6],
            [4, 5, 3, 4],
            [4, 4, 3, 3],
            [4, 4, 3, 4],
            [3, 6, 4, 6],
            [8, 3, 8, 6],
            [8, 4, 9, 4],
            [9, 4, 8, 5],
            [8, 5, 9, 5],
            [9, 5, 8, 6],
            [8, 3, 9, 4],
            [9, 4, 9, 5],
            [5, 7, 6, 8],
            [6, 8, 5, 9],
            [5, 9, 6, 10],
            [6, 10, 5, 11],
            [7, 7, 6, 8],
            [6, 8, 7, 9],
            [7, 9, 6, 10],
            [6, 10, 7, 11],
            [7, 11, 5, 11],
            [6, 11, 6, 6],
        ],
    },
    {
        date: 1428576463430,
        row: 11,
        col: 11,
        segments: [
            [3, 3, 4, 2],
            [4, 2, 8, 2],
            [8, 2, 9, 3],
            [9, 3, 9, 6],
            [9, 6, 3, 6],
            [3, 6, 3, 3],
            [4, 3, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 5, 3],
            [5, 3, 4, 3],
            [7, 3, 8, 3],
            [8, 3, 8, 4],
            [8, 4, 7, 4],
            [7, 4, 7, 3],
            [6, 5, 6, 4],
            [5, 5, 7, 5],
            [9, 6, 9, 9],
            [9, 9, 7, 9],
            [7, 9, 7, 6],
            [5, 6, 5, 9],
            [5, 9, 3, 9],
            [3, 9, 3, 6],
            [6, 6, 6, 10],
            [6, 10, 3, 10],
            [6, 10, 9, 10],
        ],
    },
    {
        date: 1428575779046,
        row: 11,
        col: 11,
        segments: [
            [6, 6, 1, 11],
            [6, 6, 11, 1],
            [1, 1, 11, 11],
            [6, 11, 6, 1],
            [1, 6, 11, 6],
            [1, 11, 11, 11],
            [1, 1, 1, 11],
            [11, 1, 11, 6],
            [11, 11, 11, 6],
            [1, 1, 11, 1],
            [1, 8, 11, 8],
            [1, 10, 11, 10],
            [1, 4, 11, 4],
            [1, 2, 11, 2],
            [4, 11, 4, 1],
            [8, 11, 8, 1],
            [10, 11, 10, 1],
            [1, 7, 4, 7],
            [1, 5, 4, 5],
            [1, 9, 4, 9],
            [4, 9, 8, 9],
            [8, 9, 11, 9],
            [8, 7, 4, 7],
            [10, 7, 8, 7],
            [4, 5, 11, 5],
            [11, 7, 10, 7],
            [9, 11, 7, 7],
            [7, 11, 9, 5],
            [7, 11, 7, 5],
            [5, 11, 5, 3],
            [5, 3, 1, 3],
            [5, 3, 3, 4],
            [3, 4, 2, 1],
            [2, 1, 2, 11],
            [3, 11, 3, 1],
            [5, 1, 5, 3],
            [5, 3, 8, 3],
            [7, 5, 7, 1],
            [9, 5, 9, 1],
            [8, 3, 11, 3],
            [9, 11, 9, 5],
        ],
    },
    {
        date: 1428576550820,
        row: 11,
        col: 11,
        segments: [
            [3, 2, 9, 2],
            [9, 2, 8, 3],
            [3, 2, 4, 3],
            [4, 3, 4, 9],
            [4, 9, 3, 10],
            [3, 10, 9, 10],
            [9, 10, 8, 9],
            [8, 9, 8, 3],
            [8, 5, 10, 5],
            [8, 6, 10, 6],
            [10, 6, 10, 9],
            [10, 9, 11, 9],
            [11, 9, 11, 2],
            [11, 2, 10, 2],
            [10, 2, 10, 5],
            [4, 5, 2, 5],
            [4, 6, 2, 6],
            [2, 6, 2, 9],
            [2, 9, 1, 9],
            [1, 9, 1, 2],
            [1, 2, 2, 2],
            [2, 2, 2, 5],
            [5, 4, 6, 4],
            [7, 4, 6, 4],
            [6, 4, 6, 3],
            [6, 4, 6, 5],
            [6, 8, 5, 7],
            [6, 8, 7, 7],
            [7, 7, 7, 6],
            [5, 7, 5, 6],
            [5, 6, 7, 6],
        ],
    },
    {
        date: 1428594700720,
        row: 11,
        col: 11,
        segments: [
            [9, 5, 2, 5],
            [9, 5, 9, 3],
            [9, 3, 2, 3],
            [2, 3, 2, 5],
            [3, 5, 3, 9],
            [5, 9, 3, 9],
            [5, 5, 5, 9],
            [7, 5, 7, 7],
            [9, 7, 7, 7],
            [9, 5, 9, 7],
        ],
    },
    {
        date: 1429721122994,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 2, 2],
            [6, 10, 2, 2],
            [6, 2, 6, 10],
            [2, 6, 2, 10],
            [2, 10, 10, 6],
            [10, 6, 2, 6],
            [6, 10, 10, 10],
            [10, 10, 6, 2],
            [10, 2, 10, 6],
            [10, 2, 2, 6],
        ],
    },
    {
        date: 1430204077245,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 3, 3],
            [2, 3, 2, 2],
            [3, 4, 2, 3],
            [3, 3, 4, 2],
            [4, 2, 4, 3],
            [4, 3, 3, 4],
            [3, 4, 3, 7],
            [3, 7, 4, 7],
            [4, 7, 5, 6],
            [5, 6, 4, 6],
            [4, 6, 3, 7],
            [6, 2, 7, 3],
            [6, 2, 6, 4],
            [7, 3, 8, 2],
            [8, 2, 8, 4],
            [8, 4, 7, 5],
            [6, 4, 7, 5],
            [7, 5, 7, 8],
            [7, 8, 9, 8],
            [9, 8, 9, 7],
            [9, 7, 8, 7],
            [8, 7, 7, 8],
        ],
    },
    {
        date: 1429721307537,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 6, 2],
            [6, 2, 6, 10],
            [6, 10, 10, 10],
            [10, 10, 2, 2],
            [2, 6, 2, 10],
            [2, 10, 10, 2],
            [10, 2, 10, 6],
            [10, 6, 2, 6],
            [9, 5, 3, 7],
            [3, 7, 3, 10],
            [3, 10, 9, 2],
            [9, 2, 9, 5],
            [5, 3, 7, 9],
            [7, 9, 10, 9],
            [10, 9, 2, 3],
            [2, 3, 5, 3],
            [5, 4, 7, 8],
            [7, 8, 10, 8],
            [10, 8, 2, 4],
            [2, 4, 5, 4],
            [8, 5, 8, 2],
            [8, 2, 4, 10],
            [4, 10, 4, 7],
            [4, 7, 8, 5],
            [5, 7, 5, 10],
            [5, 10, 7, 2],
            [7, 2, 7, 5],
            [2, 5, 5, 5],
            [2, 5, 10, 7],
            [10, 7, 7, 7],
        ],
    },
    {
        date: 1430402757410,
        row: 11,
        col: 11,
        segments: [
            [4, 3, 4, 7],
            [4, 7, 7, 7],
            [7, 7, 7, 3],
            [4, 3, 7, 3],
            [4, 3, 6, 2],
            [7, 3, 6, 2],
            [4, 9, 4, 7],
            [7, 7, 7, 9],
            [4, 9, 7, 9],
        ],
    },
    {
        date: 1430408880862,
        row: 11,
        col: 11,
        segments: [
            [4, 4, 8, 4],
            [8, 4, 8, 11],
            [8, 11, 4, 11],
            [4, 11, 4, 4],
            [4, 4, 6, 1],
            [8, 4, 6, 1],
            [6, 6, 10, 3],
            [10, 3, 10, 4],
            [10, 4, 6, 6],
            [6, 6, 2, 3],
            [2, 3, 2, 4],
            [2, 4, 6, 6],
            [2, 7, 2, 8],
            [6, 6, 2, 7],
            [6, 6, 2, 8],
            [10, 8, 10, 7],
            [10, 7, 6, 6],
            [6, 6, 10, 8],
        ],
    },
    {
        date: 1443862368704,
        row: 11,
        col: 11,
        segments: [
            [4, 4, 5, 2],
            [5, 2, 6, 4],
            [6, 4, 4, 4],
            [4, 4, 4, 8],
            [4, 8, 6, 8],
            [6, 8, 6, 4],
            [6, 6, 8, 8],
            [8, 8, 7, 8],
            [7, 8, 6, 7],
            [4, 6, 2, 8],
            [2, 8, 3, 8],
            [3, 8, 4, 7],
        ],
    },
    {
        date: 1444566094299,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 7, 2],
            [7, 2, 6, 3],
            [6, 3, 6, 2],
            [4, 3, 8, 3],
            [4, 3, 2, 4],
            [8, 3, 10, 4],
            [2, 4, 2, 8],
            [10, 4, 10, 8],
            [3, 4, 3, 5],
            [3, 5, 5, 5],
            [5, 5, 3, 4],
            [9, 4, 9, 5],
            [9, 5, 7, 5],
            [7, 5, 9, 4],
            [2, 8, 4, 9],
            [4, 9, 8, 9],
            [8, 9, 10, 8],
            [3, 8, 4, 7],
            [4, 7, 5, 8],
            [5, 8, 6, 7],
            [6, 7, 7, 8],
            [7, 8, 8, 7],
            [8, 7, 9, 8],
            [6, 5, 7, 6],
            [7, 6, 6, 6],
            [1, 9, 11, 9],
            [1, 10, 11, 10],
            [1, 10, 2, 9],
            [2, 9, 3, 10],
            [3, 10, 4, 9],
            [4, 9, 5, 10],
            [5, 10, 6, 9],
            [6, 9, 7, 10],
            [7, 10, 8, 9],
            [8, 9, 9, 10],
            [9, 10, 10, 9],
            [10, 9, 11, 10],
            [11, 9, 10, 10],
            [10, 10, 9, 9],
            [9, 9, 8, 10],
            [8, 10, 7, 9],
            [7, 9, 6, 10],
            [6, 10, 5, 9],
            [5, 9, 4, 10],
            [4, 10, 3, 9],
            [3, 9, 2, 10],
            [2, 10, 1, 9],
        ],
    },
    {
        date: 1450006146394,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 6, 2],
            [6, 10, 6, 2],
            [2, 2, 6, 6],
            [10, 10, 6, 6],
            [6, 10, 10, 10],
            [9, 6, 6, 6],
            [9, 3, 9, 6],
            [9, 3, 6, 6],
            [3, 9, 6, 6],
            [3, 6, 3, 9],
            [6, 6, 3, 6],
            [1, 3, 1, 4],
            [2, 4, 2, 3],
            [1, 4, 3, 4],
            [3, 5, 3, 4],
            [2, 5, 3, 5],
            [2, 4, 2, 5],
            [2, 3, 1, 3],
            [7, 4, 7, 2],
            [7, 2, 10, 2],
            [10, 2, 10, 9],
            [10, 9, 8, 7],
        ],
    },
    {
        date: 1452522012803,
        row: 11,
        col: 11,
        segments: [
            [5, 10, 5, 9],
            [5, 10, 6, 10],
            [6, 10, 7, 10],
            [7, 10, 7, 9],
            [7, 9, 7, 8],
            [5, 9, 5, 8],
            [5, 8, 3, 8],
            [11, 5, 9, 8],
            [9, 6, 11, 5],
            [3, 8, 1, 5],
            [1, 5, 3, 6],
            [3, 6, 4, 5],
            [4, 5, 5, 4],
            [5, 4, 6, 4],
            [6, 4, 7, 4],
            [7, 4, 9, 6],
            [6, 5, 6, 4],
            [5, 5, 5, 4],
            [5, 4, 4, 3],
            [7, 5, 7, 4],
            [7, 4, 8, 3],
            [6, 4, 6, 3],
            [5, 9, 7, 9],
            [6, 10, 6, 9],
            [2, 6, 3, 7],
            [10, 6, 9, 7],
            [5, 6, 5, 7],
            [4, 7, 5, 7],
            [4, 7, 4, 6],
            [4, 6, 5, 6],
            [7, 6, 7, 7],
            [7, 7, 8, 7],
            [8, 7, 8, 6],
            [8, 6, 7, 6],
            [6, 7, 3, 9],
            [3, 9, 6, 8],
            [9, 8, 7, 8],
        ],
    },
    {
        date: 1453109966081,
        row: 11,
        col: 11,
        segments: [
            [3, 11, 10, 11],
            [10, 11, 10, 8],
            [10, 8, 6, 8],
            [6, 8, 6, 5],
            [3, 11, 2, 11],
            [2, 11, 2, 5],
            [4, 7, 4, 3],
            [4, 4, 3, 4],
            [3, 4, 3, 3],
            [3, 3, 2, 3],
            [2, 3, 2, 2],
            [2, 2, 3, 2],
            [3, 2, 3, 1],
            [3, 1, 4, 1],
            [4, 1, 5, 1],
            [5, 1, 5, 2],
            [5, 2, 6, 2],
            [6, 2, 6, 3],
            [6, 3, 5, 3],
            [5, 3, 5, 4],
            [5, 4, 4, 4],
            [2, 5, 6, 5],
            [7, 8, 7, 9],
            [8, 9, 8, 8],
            [9, 8, 9, 9],
            [2, 10, 10, 10],
            [4, 1, 4, 3],
            [4, 2, 3, 2],
            [5, 2, 4, 2],
            [3, 3, 5, 3],
            [5, 3, 5, 2],
            [3, 2, 3, 3],
            [6, 7, 5, 7],
            [6, 6, 5, 6],
        ],
    },
    {
        date: 1453111263085,
        row: 11,
        col: 11,
        segments: [
            [2, 4, 10, 4],
            [10, 2, 2, 2],
            [2, 4, 2, 2],
            [10, 2, 10, 4],
            [9, 3, 8, 3],
            [4, 3, 3, 3],
            [6, 3, 6, 4],
            [10, 4, 9, 5],
            [2, 4, 3, 5],
            [3, 5, 4, 6],
            [9, 5, 8, 6],
            [4, 6, 4, 8],
            [8, 6, 8, 8],
            [9, 5, 10, 6],
            [3, 5, 2, 6],
            [8, 8, 10, 8],
            [10, 9, 8, 9],
            [10, 8, 10, 9],
            [4, 8, 2, 8],
            [2, 9, 2, 8],
            [4, 9, 2, 9],
            [4, 8, 4, 9],
            [8, 8, 8, 9],
            [9, 6, 10, 6],
            [3, 6, 2, 6],
            [4, 6, 3, 6],
            [9, 6, 8, 6],
            [10, 2, 11, 1],
            [2, 2, 1, 1],
            [2, 2, 3, 2],
            [9, 2, 11, 1],
            [3, 2, 1, 1],
        ],
    },
    {
        date: 1453111352980,
        row: 11,
        col: 11,
        segments: [
            [5, 2, 5, 5],
            [8, 5, 8, 2],
            [5, 2, 8, 2],
            [8, 5, 5, 5],
            [6, 5, 6, 6],
            [7, 6, 7, 5],
            [6, 6, 7, 6],
            [6, 6, 4, 8],
            [9, 8, 7, 6],
            [5, 8, 5, 11],
            [4, 11, 4, 8],
            [8, 8, 8, 11],
            [9, 8, 9, 11],
            [3, 8, 9, 8],
            [10, 8, 9, 8],
            [6, 3, 6, 4],
            [7, 4, 7, 3],
            [6, 3, 7, 3],
            [6, 4, 7, 4],
            [7, 1, 7, 2],
            [6, 1, 6, 2],
            [8, 1, 8, 2],
            [5, 1, 5, 2],
            [4, 1, 5, 2],
            [8, 2, 9, 1],
            [8, 3, 9, 3],
            [5, 3, 4, 3],
            [4, 4, 5, 4],
            [8, 4, 9, 4],
            [9, 5, 8, 5],
            [5, 5, 4, 5],
            [5, 5, 4, 6],
            [8, 5, 9, 6],
            [6, 3, 7, 4],
            [6, 4, 7, 3],
        ],
    },
    {
        date: 1453111775732,
        row: 11,
        col: 11,
        segments: [
            [11, 10, 10, 10],
            [10, 9, 11, 9],
            [11, 10, 11, 9],
            [1, 9, 1, 10],
            [1, 10, 2, 10],
            [2, 9, 1, 9],
            [3, 10, 3, 9],
            [2, 10, 3, 10],
            [2, 9, 3, 9],
            [10, 10, 9, 10],
            [9, 9, 10, 9],
            [9, 9, 9, 10],
            [9, 7, 9, 9],
            [3, 9, 3, 7],
            [4, 7, 3, 7],
            [8, 7, 9, 7],
            [8, 6, 4, 6],
            [4, 7, 4, 6],
            [8, 7, 8, 6],
            [7, 6, 5, 6],
            [5, 4, 7, 4],
            [5, 2, 7, 2],
            [7, 4, 7, 3],
            [7, 2, 7, 3],
            [5, 3, 5, 2],
            [5, 3, 5, 4],
            [6, 3, 8, 3],
            [8, 2, 7, 3],
            [5, 3, 4, 2],
            [5, 3, 6, 3],
            [4, 3, 5, 3],
            [7, 4, 7, 6],
            [5, 6, 5, 4],
        ],
    },
    {
        date: 1453111664002,
        row: 11,
        col: 11,
        segments: [
            [9, 3, 9, 4],
            [9, 4, 7, 4],
            [7, 4, 7, 3],
            [7, 3, 5, 3],
            [5, 3, 5, 4],
            [5, 4, 3, 4],
            [3, 4, 3, 3],
            [3, 3, 1, 3],
            [9, 3, 11, 3],
            [1, 3, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 3],
            [10, 4, 9, 5],
            [9, 5, 10, 6],
            [10, 6, 11, 5],
            [11, 5, 10, 4],
            [10, 7, 9, 8],
            [9, 8, 10, 9],
            [10, 9, 11, 8],
            [11, 8, 10, 7],
            [2, 4, 1, 5],
            [1, 5, 2, 6],
            [2, 6, 3, 5],
            [3, 5, 2, 4],
            [2, 7, 1, 8],
            [1, 8, 2, 9],
            [2, 9, 3, 8],
            [3, 8, 2, 7],
            [4, 11, 4, 8],
            [8, 8, 8, 11],
            [8, 8, 8, 7],
            [8, 7, 7, 6],
            [4, 8, 4, 7],
            [4, 7, 5, 6],
            [5, 6, 7, 6],
        ],
    },
    {
        date: 1453111939460,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 2],
            [2, 2, 10, 2],
            [10, 2, 11, 1],
            [10, 2, 10, 10],
            [10, 10, 11, 11],
            [10, 10, 2, 10],
            [2, 10, 1, 11],
            [2, 10, 2, 2],
            [3, 3, 2, 2],
            [3, 3, 3, 9],
            [3, 9, 9, 9],
            [9, 9, 9, 3],
            [9, 3, 3, 3],
            [9, 3, 10, 2],
            [9, 9, 10, 10],
            [3, 9, 2, 10],
            [4, 8, 4, 4],
            [4, 4, 8, 4],
            [8, 4, 8, 8],
            [8, 8, 4, 8],
            [4, 8, 3, 9],
            [4, 4, 3, 3],
            [8, 4, 9, 3],
            [8, 8, 9, 9],
            [5, 7, 7, 7],
            [7, 7, 7, 5],
            [7, 5, 5, 5],
            [5, 5, 5, 7],
            [5, 5, 4, 4],
            [7, 5, 8, 4],
            [5, 7, 4, 8],
            [7, 7, 8, 8],
        ],
    },
    {
        date: 1453112152636,
        row: 11,
        col: 11,
        segments: [
            [11, 2, 1, 2],
            [11, 4, 1, 4],
            [10, 3, 9, 3],
            [3, 3, 2, 3],
            [6, 5, 4, 6],
            [6, 6, 4, 6],
            [2, 7, 2, 8],
            [2, 9, 2, 8],
            [10, 9, 10, 7],
            [2, 9, 10, 9],
            [10, 7, 9, 8],
            [3, 8, 9, 8],
            [2, 7, 3, 8],
            [9, 8, 8, 9],
            [3, 8, 4, 9],
            [5, 8, 6, 9],
            [8, 8, 7, 9],
        ],
    },
    {
        date: 1453111941269,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 11],
            [1, 1, 11, 11],
            [10, 1, 2, 11],
            [3, 11, 9, 1],
            [8, 1, 4, 11],
            [5, 11, 7, 1],
            [6, 1, 6, 11],
            [5, 1, 7, 11],
            [4, 1, 8, 11],
            [3, 1, 9, 11],
            [2, 1, 10, 11],
            [11, 2, 1, 10],
            [1, 9, 11, 3],
            [1, 8, 11, 4],
            [1, 7, 11, 5],
            [1, 6, 11, 6],
            [1, 5, 11, 7],
            [1, 4, 11, 8],
            [1, 3, 11, 9],
            [1, 2, 11, 10],
            [1, 1, 11, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
        ],
    },
    {
        date: 1453112220949,
        row: 11,
        col: 11,
        segments: [
            [3, 4, 3, 2],
            [3, 4, 5, 4],
            [5, 4, 5, 6],
            [7, 6, 7, 8],
            [7, 8, 9, 8],
            [9, 8, 9, 10],
            [9, 10, 11, 10],
            [11, 10, 11, 11],
            [1, 1, 1, 2],
            [1, 2, 3, 2],
            [11, 1, 11, 2],
            [11, 2, 9, 2],
            [9, 2, 9, 4],
            [9, 4, 7, 4],
            [7, 4, 7, 6],
            [5, 6, 5, 8],
            [5, 8, 3, 8],
            [7, 6, 5, 6],
            [3, 8, 3, 10],
            [3, 10, 1, 10],
            [1, 10, 1, 11],
            [6, 1, 6, 11],
            [1, 6, 11, 6],
            [1, 11, 11, 1],
            [1, 1, 11, 11],
            [10, 1, 1, 10],
            [1, 9, 9, 1],
            [8, 1, 1, 8],
            [1, 7, 7, 1],
            [6, 1, 1, 6],
            [1, 5, 5, 1],
            [4, 1, 1, 4],
            [1, 3, 3, 1],
            [2, 1, 1, 2],
            [2, 11, 11, 2],
            [11, 3, 3, 11],
            [4, 11, 11, 4],
            [11, 5, 5, 11],
            [6, 11, 11, 6],
            [11, 7, 7, 11],
            [8, 11, 11, 8],
            [11, 9, 9, 11],
            [10, 11, 11, 10],
            [2, 1, 11, 10],
            [11, 9, 3, 1],
            [4, 1, 11, 8],
            [11, 7, 5, 1],
            [6, 1, 11, 6],
            [11, 5, 7, 1],
            [8, 1, 11, 4],
            [11, 3, 9, 1],
            [10, 1, 11, 2],
            [1, 2, 10, 11],
            [9, 11, 1, 3],
            [1, 4, 8, 11],
            [7, 11, 1, 5],
            [1, 6, 6, 11],
            [5, 11, 1, 7],
            [1, 8, 4, 11],
            [3, 11, 1, 9],
            [1, 10, 2, 11],
            [4, 1, 4, 11],
            [3, 11, 3, 1],
            [2, 1, 2, 11],
            [5, 11, 5, 1],
            [7, 1, 7, 11],
            [8, 11, 8, 1],
            [9, 1, 9, 11],
            [10, 11, 10, 1],
            [11, 2, 1, 2],
            [1, 3, 11, 3],
            [11, 4, 1, 4],
            [1, 5, 11, 5],
            [11, 7, 1, 7],
            [1, 8, 11, 8],
            [11, 9, 1, 9],
            [1, 10, 11, 10],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [1, 1, 11, 1],
            [11, 1, 11, 11],
        ],
    },
    {
        date: 1453112267003,
        row: 11,
        col: 11,
        segments: [
            [7, 1, 7, 5],
            [7, 7, 7, 11],
            [5, 7, 5, 11],
            [5, 11, 7, 11],
            [7, 7, 11, 7],
            [11, 7, 11, 5],
            [11, 5, 7, 5],
            [7, 1, 5, 1],
            [5, 1, 5, 5],
            [5, 5, 1, 5],
            [1, 7, 5, 7],
            [1, 5, 1, 7],
            [5, 4, 2, 1],
            [2, 1, 1, 2],
            [1, 2, 4, 5],
            [7, 4, 10, 1],
            [10, 1, 11, 2],
            [11, 2, 8, 5],
            [4, 7, 1, 10],
            [1, 10, 2, 11],
            [2, 11, 5, 8],
            [7, 8, 10, 11],
            [10, 11, 11, 10],
            [11, 10, 8, 7],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 5],
            [5, 5, 7, 5],
            [9, 2, 10, 3],
            [10, 1, 10, 3],
            [9, 2, 11, 2],
            [3, 2, 2, 3],
            [2, 3, 2, 1],
            [1, 2, 3, 2],
            [2, 9, 3, 10],
            [3, 10, 1, 10],
            [2, 9, 2, 11],
            [10, 9, 9, 10],
            [9, 10, 11, 10],
            [10, 9, 10, 11],
            [11, 5, 7, 7],
            [7, 5, 11, 7],
            [7, 1, 5, 5],
            [5, 1, 7, 5],
            [5, 5, 1, 7],
            [1, 5, 5, 7],
            [5, 7, 7, 11],
            [7, 7, 5, 11],
            [7, 5, 5, 7],
            [5, 5, 7, 7],
            [4, 3, 3, 4],
            [3, 4, 3, 2],
            [2, 3, 4, 3],
            [4, 3, 4, 5],
            [3, 4, 5, 4],
            [8, 3, 8, 5],
            [7, 4, 9, 4],
            [9, 4, 8, 3],
            [8, 3, 10, 3],
            [9, 2, 9, 4],
            [3, 8, 4, 9],
            [4, 9, 2, 9],
            [3, 8, 3, 10],
            [3, 8, 5, 8],
            [4, 7, 4, 9],
            [8, 7, 8, 9],
            [7, 8, 9, 8],
            [9, 8, 9, 10],
            [8, 9, 10, 9],
            [9, 8, 8, 9],
            [8, 2, 8, 1],
            [7, 1, 8, 1],
            [7, 1, 7, 2],
            [7, 2, 8, 2],
            [5, 1, 4, 1],
            [4, 2, 5, 2],
            [4, 1, 4, 2],
            [5, 10, 4, 10],
            [4, 10, 4, 11],
            [4, 11, 5, 11],
            [7, 10, 8, 10],
            [8, 10, 8, 11],
            [7, 11, 8, 11],
            [1, 5, 1, 4],
            [1, 4, 2, 4],
            [2, 4, 2, 5],
            [1, 7, 1, 8],
            [1, 8, 2, 8],
            [2, 8, 2, 7],
            [10, 4, 10, 5],
            [10, 4, 11, 4],
            [11, 4, 11, 5],
            [10, 7, 10, 8],
            [10, 8, 11, 8],
            [11, 8, 11, 7],
        ],
    },
    {
        date: 1453123153335,
        row: 11,
        col: 11,
        segments: [
            [2, 1, 10, 11],
            [3, 1, 9, 11],
            [8, 11, 4, 1],
            [5, 1, 7, 11],
            [6, 1, 6, 11],
            [7, 1, 5, 11],
            [8, 1, 4, 11],
            [9, 1, 3, 11],
            [10, 1, 2, 11],
            [1, 11, 1, 1],
            [3, 1, 1, 3],
            [1, 9, 3, 11],
            [1, 4, 4, 1],
            [5, 1, 1, 5],
            [1, 8, 4, 11],
            [5, 11, 1, 7],
            [2, 1, 1, 2],
            [1, 10, 2, 11],
            [6, 1, 1, 6],
            [1, 6, 6, 11],
            [6, 2, 2, 6],
            [2, 6, 6, 10],
            [6, 10, 10, 6],
            [10, 6, 6, 2],
            [6, 3, 3, 6],
            [3, 6, 6, 9],
            [6, 9, 9, 6],
            [9, 6, 6, 3],
            [6, 4, 4, 6],
            [4, 6, 6, 8],
            [6, 8, 8, 6],
            [8, 6, 6, 4],
            [6, 5, 5, 6],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [7, 6, 6, 5],
            [6, 11, 11, 6],
            [11, 6, 6, 1],
            [7, 1, 11, 5],
            [11, 4, 8, 1],
            [9, 1, 11, 3],
            [10, 1, 11, 2],
            [11, 7, 7, 11],
            [8, 11, 11, 8],
            [11, 9, 9, 11],
            [10, 11, 11, 10],
            [1, 1, 11, 11],
            [11, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [1, 2, 11, 10],
            [11, 9, 1, 3],
            [1, 4, 11, 8],
            [11, 7, 1, 5],
            [1, 6, 11, 6],
            [11, 5, 1, 7],
            [1, 8, 11, 4],
            [1, 9, 11, 3],
            [1, 10, 11, 2],
        ],
    },
    {
        date: 1453123713158,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 10, 3],
            [10, 1, 11, 3],
            [11, 3, 10, 5],
            [10, 3, 11, 5],
            [11, 5, 10, 7],
            [10, 5, 11, 7],
            [11, 7, 10, 9],
            [10, 7, 11, 9],
            [11, 9, 10, 11],
            [10, 9, 11, 11],
            [8, 2, 10, 1],
            [8, 1, 10, 2],
            [8, 1, 6, 2],
            [6, 1, 8, 2],
            [6, 1, 4, 2],
            [4, 1, 6, 2],
            [4, 1, 2, 2],
            [2, 1, 4, 2],
            [2, 1, 1, 3],
            [1, 1, 2, 3],
            [2, 3, 1, 5],
            [1, 3, 2, 5],
            [2, 5, 1, 7],
            [1, 5, 2, 7],
            [2, 7, 1, 9],
            [1, 7, 2, 9],
            [2, 9, 1, 11],
            [1, 9, 2, 11],
            [2, 11, 4, 10],
            [2, 10, 4, 11],
            [4, 11, 6, 10],
            [4, 10, 6, 11],
            [6, 11, 8, 10],
            [6, 10, 8, 11],
            [8, 11, 10, 10],
            [8, 10, 10, 11],
            [10, 1, 10, 11],
            [11, 10, 1, 10],
            [2, 11, 2, 1],
            [1, 2, 11, 2],
            [6, 3, 3, 6],
            [3, 6, 6, 9],
            [6, 9, 9, 6],
            [6, 3, 9, 6],
            [6, 4, 8, 6],
            [8, 6, 6, 8],
            [4, 6, 6, 8],
            [4, 6, 6, 4],
            [6, 5, 6, 7],
            [5, 6, 7, 6],
            [7, 5, 5, 7],
            [5, 5, 7, 7],
            [7, 5, 5, 5],
            [5, 5, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 7, 5],
            [6, 3, 6, 4],
            [5, 4, 5, 5],
            [4, 5, 4, 6],
            [4, 6, 4, 7],
            [3, 6, 4, 6],
            [5, 7, 5, 8],
            [6, 8, 6, 9],
            [5, 4, 6, 4],
            [6, 4, 7, 4],
            [7, 4, 7, 5],
            [7, 5, 8, 5],
            [8, 5, 8, 6],
            [8, 6, 9, 6],
            [8, 6, 8, 7],
            [8, 7, 7, 7],
            [7, 7, 7, 8],
            [7, 8, 6, 8],
            [6, 8, 5, 8],
            [5, 7, 4, 7],
            [5, 5, 4, 5],
            [6, 4, 6, 5],
            [7, 6, 8, 6],
            [5, 6, 4, 6],
            [6, 7, 6, 8],
            [8, 2, 8, 5],
            [7, 2, 7, 4],
            [6, 2, 6, 3],
            [9, 2, 9, 6],
            [9, 6, 9, 10],
            [8, 7, 8, 10],
            [7, 8, 7, 10],
            [6, 9, 6, 10],
            [5, 8, 5, 10],
            [5, 2, 5, 4],
            [4, 2, 4, 5],
            [3, 2, 3, 6],
            [3, 6, 3, 10],
            [4, 7, 4, 10],
            [2, 3, 10, 3],
            [10, 4, 7, 4],
            [5, 4, 2, 4],
            [2, 5, 4, 5],
            [8, 5, 10, 5],
            [9, 6, 10, 6],
            [3, 6, 2, 6],
            [2, 7, 4, 7],
            [8, 7, 10, 7],
            [10, 8, 7, 8],
            [5, 8, 2, 8],
            [2, 9, 10, 9],
            [10, 2, 2, 10],
            [2, 2, 10, 10],
            [1, 1, 11, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
        ],
    },
    {
        date: 1453123775734,
        row: 11,
        col: 11,
        segments: [
            [3, 3, 5, 3],
            [9, 3, 7, 3],
            [9, 3, 9, 5],
            [3, 3, 3, 5],
            [3, 5, 6, 9],
            [6, 9, 9, 5],
            [5, 3, 6, 5],
            [6, 5, 7, 3],
        ],
    },
    {
        date: 1453726687974,
        row: 11,
        col: 11,
        segments: [
            [10, 1, 11, 2],
            [9, 1, 11, 3],
            [8, 1, 11, 4],
            [7, 1, 11, 5],
            [6, 1, 11, 6],
            [11, 1, 1, 1],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [1, 2, 2, 1],
            [1, 3, 3, 1],
            [1, 4, 4, 1],
            [1, 5, 5, 1],
            [1, 10, 2, 11],
            [1, 9, 3, 11],
            [1, 8, 4, 11],
            [1, 7, 5, 11],
            [1, 6, 6, 11],
            [1, 6, 6, 1],
            [11, 6, 6, 11],
            [11, 10, 10, 11],
            [11, 9, 9, 11],
            [11, 8, 8, 11],
            [11, 7, 7, 11],
            [6, 2, 10, 6],
            [10, 6, 6, 10],
            [6, 10, 2, 6],
            [2, 6, 6, 2],
            [9, 6, 6, 3],
            [6, 3, 3, 6],
            [3, 6, 6, 9],
            [6, 9, 9, 6],
            [8, 6, 6, 4],
            [6, 4, 4, 6],
            [4, 6, 6, 8],
            [6, 8, 8, 6],
            [7, 6, 6, 5],
            [6, 5, 5, 6],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [1, 6, 11, 6],
            [6, 1, 6, 11],
        ],
    },
    {
        date: 1453124012364,
        row: 11,
        col: 11,
        segments: [
            [6, 4, 4, 2],
            [6, 4, 8, 2],
            [8, 2, 9, 2],
            [9, 2, 9, 4],
            [9, 4, 6, 9],
            [3, 4, 6, 9],
            [3, 4, 3, 2],
            [3, 2, 4, 2],
            [6, 8, 5, 7],
            [6, 8, 7, 7],
            [7, 7, 5, 7],
            [4, 4, 4, 5],
            [5, 5, 5, 4],
            [5, 4, 4, 4],
            [4, 5, 5, 5],
            [7, 4, 7, 5],
            [7, 5, 8, 5],
            [8, 5, 8, 4],
            [8, 4, 7, 4],
        ],
    },
    {
        date: 1453726832660,
        row: 11,
        col: 11,
        segments: [
            [3, 2, 6, 5],
            [3, 2, 2, 3],
            [5, 6, 2, 3],
            [5, 6, 4, 7],
            [4, 7, 6, 9],
            [6, 9, 8, 7],
            [6, 5, 7, 4],
            [7, 4, 9, 6],
            [9, 6, 8, 7],
            [7, 8, 9, 10],
            [8, 7, 10, 9],
            [10, 9, 9, 10],
            [5, 6, 6, 5],
            [5, 7, 7, 5],
            [7, 5, 8, 6],
            [8, 6, 6, 8],
            [6, 8, 5, 7],
            [3, 2, 3, 3],
            [2, 3, 3, 3],
            [4, 3, 4, 4],
            [3, 4, 4, 4],
            [5, 4, 5, 5],
            [4, 5, 5, 5],
            [6, 5, 5, 5],
            [5, 6, 5, 5],
            [5, 4, 4, 4],
            [4, 5, 4, 4],
            [4, 3, 3, 3],
            [3, 3, 3, 4],
            [9, 10, 9, 9],
            [9, 9, 10, 9],
            [8, 9, 9, 8],
        ],
    },
    {
        date: 1454322678511,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [11, 10, 2, 1],
            [1, 2, 10, 11],
            [10, 1, 1, 10],
            [2, 11, 11, 2],
            [11, 1, 1, 11],
            [6, 1, 6, 11],
            [6, 11, 5, 1],
            [7, 1, 6, 11],
            [5, 11, 6, 1],
            [6, 1, 7, 11],
            [1, 6, 11, 6],
            [11, 6, 1, 5],
            [1, 7, 11, 6],
            [11, 5, 1, 6],
            [1, 6, 11, 7],
        ],
    },
    {
        date: 1454324860046,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 1],
            [1, 1, 11, 11],
            [11, 11, 1, 11],
            [11, 1, 11, 11],
            [1, 1, 1, 11],
            [11, 1, 1, 11],
            [1, 6, 11, 6],
            [6, 1, 6, 11],
            [9, 2, 10, 3],
            [10, 3, 10, 5],
            [10, 5, 8, 5],
            [8, 5, 7, 4],
            [7, 4, 7, 2],
            [7, 2, 9, 2],
            [8, 7, 10, 7],
            [10, 7, 10, 9],
            [10, 9, 9, 10],
            [9, 10, 7, 10],
            [7, 8, 7, 10],
            [7, 8, 8, 7],
            [5, 8, 4, 7],
            [4, 7, 2, 7],
            [2, 7, 2, 9],
            [2, 9, 3, 10],
            [3, 10, 5, 10],
            [5, 10, 5, 8],
            [2, 5, 2, 3],
            [2, 3, 3, 2],
            [3, 2, 5, 2],
            [5, 2, 5, 4],
            [5, 4, 4, 5],
            [4, 5, 2, 5],
            [10, 9, 11, 11],
            [10, 7, 11, 11],
            [9, 10, 11, 11],
            [7, 10, 11, 11],
            [7, 8, 6, 6],
            [8, 7, 6, 6],
            [10, 7, 6, 6],
            [7, 10, 6, 6],
            [8, 5, 6, 6],
            [10, 5, 6, 6],
            [7, 4, 6, 6],
            [11, 1, 9, 2],
            [11, 1, 10, 3],
            [11, 1, 10, 5],
            [11, 1, 7, 2],
            [6, 6, 7, 2],
            [5, 8, 6, 6],
            [4, 7, 6, 6],
            [6, 6, 2, 7],
            [6, 6, 5, 10],
            [1, 11, 3, 10],
            [1, 11, 5, 10],
            [1, 11, 2, 9],
            [1, 11, 2, 7],
            [5, 4, 6, 6],
            [5, 2, 6, 6],
            [4, 5, 6, 6],
            [2, 5, 6, 6],
            [2, 3, 1, 1],
            [5, 2, 1, 1],
            [3, 2, 1, 1],
            [2, 5, 1, 1],
            [8, 3, 8, 9],
            [9, 8, 9, 4],
            [9, 4, 8, 3],
            [9, 8, 8, 9],
            [4, 9, 4, 3],
            [3, 4, 3, 8],
            [3, 8, 4, 9],
            [3, 4, 4, 3],
            [3, 8, 9, 8],
            [4, 9, 8, 9],
            [10, 5, 11, 6],
            [11, 6, 10, 7],
            [2, 5, 1, 6],
            [1, 6, 2, 7],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [7, 2, 6, 1],
            [6, 1, 5, 2],
            [3, 4, 9, 4],
            [4, 3, 8, 3],
        ],
    },
    {
        date: 1454568946730,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [1, 11, 11, 1],
            [11, 6, 1, 6],
            [6, 1, 6, 11],
            [3, 3, 9, 3],
            [9, 3, 9, 9],
            [9, 9, 3, 9],
            [3, 9, 3, 3],
            [3, 3, 4, 4],
            [4, 4, 8, 4],
            [8, 4, 8, 8],
            [4, 8, 4, 4],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 5],
            [10, 2, 10, 10],
            [10, 10, 2, 10],
            [2, 10, 2, 2],
            [2, 2, 10, 2],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [11, 1, 1, 1],
            [8, 8, 4, 8],
            [10, 1, 10, 11],
            [9, 11, 9, 1],
            [8, 1, 8, 11],
            [7, 11, 7, 1],
            [5, 1, 5, 11],
            [4, 11, 4, 1],
            [3, 2, 3, 11],
            [3, 1, 3, 2],
            [2, 1, 2, 11],
            [1, 10, 11, 10],
            [11, 9, 1, 9],
            [1, 8, 11, 8],
            [11, 7, 1, 7],
            [10, 6, 11, 6],
            [1, 5, 11, 5],
            [11, 4, 1, 4],
            [1, 3, 11, 3],
            [11, 2, 1, 2],
        ],
    },
    {
        date: 1454595122470,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 11, 2],
            [11, 6, 10, 1],
            [6, 1, 11, 3],
            [11, 6, 9, 1],
            [6, 1, 11, 4],
            [11, 6, 8, 1],
            [6, 1, 11, 5],
            [11, 6, 7, 1],
            [6, 1, 1, 2],
            [6, 1, 1, 3],
            [6, 1, 1, 4],
            [6, 1, 1, 5],
            [1, 6, 2, 1],
            [1, 6, 3, 1],
            [1, 6, 4, 1],
            [1, 6, 5, 1],
            [1, 6, 5, 11],
            [6, 11, 1, 7],
            [1, 8, 6, 11],
            [1, 6, 4, 11],
            [1, 6, 3, 11],
            [6, 11, 1, 9],
            [1, 10, 6, 11],
            [1, 6, 2, 11],
            [11, 6, 10, 11],
            [11, 6, 9, 11],
            [11, 6, 8, 11],
            [11, 6, 7, 11],
            [6, 11, 11, 10],
            [6, 11, 11, 9],
            [6, 11, 11, 8],
            [6, 11, 11, 7],
            [2, 6, 6, 5],
            [2, 6, 6, 4],
            [2, 6, 6, 3],
            [2, 6, 6, 7],
            [2, 6, 6, 8],
            [2, 6, 6, 9],
            [6, 9, 10, 6],
            [6, 8, 10, 6],
            [6, 7, 10, 6],
            [6, 3, 10, 6],
            [6, 4, 10, 6],
            [6, 5, 10, 6],
            [6, 10, 3, 6],
            [6, 10, 4, 6],
            [6, 10, 5, 6],
            [6, 10, 7, 6],
            [6, 10, 8, 6],
            [6, 10, 9, 6],
            [6, 2, 3, 6],
            [6, 2, 4, 6],
            [6, 2, 5, 6],
            [6, 2, 7, 6],
            [6, 2, 8, 6],
            [6, 2, 9, 6],
            [6, 2, 6, 10],
            [2, 6, 10, 6],
            [2, 6, 6, 6],
        ],
    },
    {
        date: 1455117165008,
        row: 11,
        col: 11,
        segments: [
            [2, 3, 3, 3],
            [2, 4, 2, 5],
            [2, 4, 2, 3],
            [3, 5, 2, 5],
            [4, 4, 3, 5],
            [4, 4, 5, 5],
            [6, 5, 5, 5],
            [6, 4, 6, 5],
            [6, 3, 6, 4],
            [4, 3, 3, 3],
            [4, 3, 5, 3],
            [5, 3, 6, 3],
            [2, 5, 2, 6],
            [2, 7, 2, 6],
            [3, 7, 2, 7],
            [3, 7, 4, 6],
            [4, 6, 5, 7],
            [5, 7, 6, 7],
            [6, 7, 6, 6],
            [6, 6, 6, 5],
            [2, 7, 3, 8],
            [3, 8, 4, 7],
            [4, 7, 5, 8],
            [5, 8, 6, 7],
            [2, 3, 3, 4],
            [3, 4, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 6, 3],
            [2, 6, 3, 5],
            [3, 5, 4, 6],
            [4, 6, 5, 5],
            [5, 5, 6, 6],
            [2, 7, 2, 8],
            [2, 8, 2, 9],
            [2, 9, 3, 9],
            [3, 9, 4, 9],
            [4, 9, 5, 9],
            [5, 9, 6, 9],
            [6, 9, 6, 8],
            [6, 8, 6, 7],
            [2, 9, 3, 8],
            [3, 8, 4, 8],
            [4, 8, 5, 8],
            [5, 8, 6, 9],
        ],
    },
    {
        date: 1455119426776,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [1, 1, 5, 5],
            [7, 7, 11, 11],
            [5, 5, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 7, 5],
            [7, 5, 5, 5],
            [6, 5, 6, 7],
            [5, 6, 7, 6],
            [5, 6, 6, 5],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [7, 6, 6, 5],
            [4, 4, 4, 8],
            [4, 8, 8, 8],
            [8, 8, 8, 4],
            [8, 4, 4, 4],
            [4, 5, 5, 5],
            [5, 5, 5, 4],
            [5, 4, 4, 5],
            [4, 6, 5, 6],
            [5, 7, 4, 7],
            [5, 7, 5, 8],
            [6, 7, 6, 8],
            [7, 7, 7, 8],
            [7, 7, 8, 7],
            [7, 6, 8, 6],
            [7, 5, 8, 5],
            [7, 5, 7, 4],
            [6, 4, 6, 5],
            [5, 5, 6, 4],
            [6, 5, 7, 4],
            [7, 6, 8, 5],
            [7, 7, 8, 6],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [5, 7, 4, 6],
            [4, 6, 5, 5],
            [4, 5, 5, 6],
            [5, 6, 4, 7],
            [4, 7, 5, 8],
            [5, 8, 6, 7],
            [6, 7, 7, 8],
            [7, 8, 8, 7],
            [8, 7, 7, 6],
            [8, 6, 7, 5],
            [8, 5, 7, 4],
            [7, 5, 6, 4],
            [6, 5, 5, 4],
            [7, 3, 8, 4],
            [7, 3, 6, 4],
            [6, 4, 5, 3],
            [5, 3, 4, 4],
            [4, 4, 3, 5],
            [3, 5, 4, 6],
            [4, 6, 3, 7],
            [4, 8, 3, 7],
            [4, 8, 5, 9],
            [5, 9, 6, 8],
            [6, 8, 7, 9],
            [7, 9, 8, 8],
            [8, 8, 9, 7],
            [9, 7, 8, 6],
            [8, 6, 9, 5],
            [9, 5, 8, 4],
            [3, 3, 9, 3],
            [9, 3, 9, 9],
            [9, 9, 3, 9],
            [3, 9, 3, 3],
            [8, 3, 9, 4],
            [9, 4, 8, 4],
            [8, 4, 8, 3],
            [4, 3, 4, 4],
            [4, 4, 3, 4],
            [3, 4, 4, 3],
            [3, 8, 4, 8],
            [4, 8, 4, 9],
            [4, 9, 3, 8],
            [8, 8, 8, 9],
            [8, 8, 9, 8],
            [9, 8, 8, 9],
            [2, 9, 2, 10],
            [3, 10, 3, 9],
            [3, 9, 2, 9],
            [2, 10, 3, 10],
            [3, 10, 2, 9],
            [1, 2, 2, 2],
            [2, 2, 2, 3],
            [2, 3, 3, 3],
            [3, 3, 3, 2],
            [3, 2, 2, 3],
            [2, 2, 3, 2],
            [2, 2, 2, 1],
            [2, 1, 1, 2],
            [9, 3, 9, 2],
            [9, 2, 10, 2],
            [10, 2, 10, 1],
            [10, 1, 11, 2],
            [11, 2, 10, 2],
            [10, 2, 10, 3],
            [10, 3, 9, 2],
            [10, 3, 9, 3],
            [2, 10, 1, 10],
            [2, 10, 2, 11],
            [2, 11, 1, 10],
            [9, 9, 9, 10],
            [10, 10, 9, 10],
            [10, 10, 10, 11],
            [10, 10, 11, 10],
            [10, 10, 10, 9],
            [10, 9, 9, 9],
            [9, 10, 10, 9],
            [10, 11, 11, 10],
            [6, 5, 7, 5],
            [11, 1, 9, 3],
            [1, 11, 5, 7],
            [7, 5, 9, 3],
            [3, 2, 9, 2],
            [10, 3, 10, 9],
            [9, 10, 3, 10],
            [2, 9, 2, 3],
            [2, 3, 3, 4],
            [3, 4, 2, 5],
            [2, 5, 3, 6],
            [3, 6, 2, 7],
            [2, 7, 3, 8],
            [3, 8, 2, 9],
            [3, 9, 4, 10],
            [4, 10, 5, 9],
            [5, 9, 6, 10],
            [6, 10, 7, 9],
            [7, 9, 8, 10],
            [8, 10, 9, 9],
            [3, 2, 4, 3],
            [4, 3, 5, 2],
            [5, 2, 6, 3],
            [6, 3, 7, 2],
            [7, 2, 8, 3],
            [8, 3, 9, 2],
            [10, 3, 9, 4],
            [9, 4, 10, 5],
            [10, 5, 9, 6],
            [9, 6, 10, 7],
            [10, 7, 9, 8],
            [9, 8, 10, 9],
            [9, 10, 8, 9],
            [8, 9, 7, 10],
            [7, 10, 6, 9],
            [6, 9, 5, 10],
            [5, 10, 4, 9],
            [4, 9, 3, 10],
            [3, 9, 2, 8],
            [2, 8, 3, 7],
            [3, 7, 2, 6],
            [2, 6, 3, 5],
            [3, 5, 2, 4],
            [2, 4, 3, 3],
            [3, 4, 2, 4],
            [3, 5, 2, 5],
            [3, 6, 2, 6],
            [3, 7, 2, 7],
            [3, 8, 2, 8],
            [4, 7, 3, 7],
            [4, 6, 3, 6],
            [4, 5, 3, 5],
            [4, 2, 4, 3],
            [5, 2, 5, 3],
            [5, 3, 5, 4],
            [6, 2, 6, 3],
            [6, 3, 6, 4],
            [7, 2, 7, 3],
            [7, 3, 7, 4],
            [3, 3, 4, 2],
            [4, 2, 5, 3],
            [5, 3, 6, 2],
            [6, 2, 7, 3],
            [7, 3, 8, 2],
            [8, 2, 8, 3],
            [8, 2, 9, 3],
            [10, 4, 9, 4],
            [10, 5, 9, 5],
            [9, 5, 8, 5],
            [9, 5, 10, 4],
            [10, 4, 9, 3],
            [9, 5, 10, 6],
            [10, 6, 9, 6],
            [9, 6, 8, 6],
            [8, 7, 9, 7],
            [9, 7, 10, 7],
            [10, 6, 9, 7],
            [9, 7, 10, 8],
            [10, 8, 9, 9],
            [9, 8, 10, 8],
            [7, 8, 7, 9],
            [7, 9, 7, 10],
            [8, 9, 8, 10],
            [6, 9, 6, 10],
            [6, 8, 6, 9],
            [5, 10, 5, 9],
            [5, 9, 5, 8],
            [4, 9, 4, 10],
            [2, 2, 4, 1],
            [4, 1, 6, 2],
            [6, 2, 8, 1],
            [8, 1, 10, 2],
            [2, 2, 1, 4],
            [1, 4, 2, 6],
            [2, 6, 1, 8],
            [1, 8, 2, 10],
            [2, 10, 4, 11],
            [4, 11, 6, 10],
            [6, 10, 8, 11],
            [8, 11, 10, 10],
            [10, 10, 11, 8],
            [11, 8, 10, 6],
            [10, 6, 11, 4],
            [11, 4, 10, 2],
            [10, 8, 11, 9],
            [11, 9, 10, 10],
            [10, 8, 11, 7],
            [11, 7, 10, 6],
            [10, 6, 11, 5],
            [11, 5, 10, 4],
            [10, 4, 11, 3],
            [11, 3, 10, 2],
            [10, 2, 9, 1],
            [9, 1, 8, 2],
            [8, 2, 7, 1],
            [7, 1, 6, 2],
            [6, 2, 5, 1],
            [5, 1, 4, 2],
            [4, 2, 3, 1],
            [3, 1, 2, 2],
            [2, 2, 1, 3],
            [1, 3, 2, 4],
            [2, 4, 1, 5],
            [1, 5, 2, 6],
            [2, 6, 1, 7],
            [1, 7, 2, 8],
            [2, 8, 1, 9],
            [1, 9, 2, 10],
            [2, 10, 3, 11],
            [3, 11, 4, 10],
            [4, 10, 5, 11],
            [5, 11, 6, 10],
            [6, 10, 7, 11],
            [7, 11, 8, 10],
            [8, 10, 9, 11],
            [9, 11, 10, 10],
        ],
    },
    {
        date: 1455190693463,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [1, 1, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 11, 1],
            [11, 1, 10, 5],
            [10, 5, 11, 6],
            [11, 6, 10, 7],
            [10, 7, 11, 11],
            [11, 11, 7, 10],
            [7, 10, 6, 11],
            [6, 11, 5, 10],
            [5, 10, 1, 11],
            [1, 11, 2, 7],
            [2, 7, 1, 6],
            [1, 6, 2, 5],
            [2, 5, 1, 1],
            [2, 2, 3, 5],
            [3, 5, 2, 6],
            [2, 6, 3, 7],
            [3, 7, 2, 10],
            [2, 2, 5, 3],
            [5, 3, 6, 2],
            [6, 2, 7, 3],
            [7, 3, 10, 2],
            [10, 2, 9, 5],
            [9, 5, 10, 6],
            [10, 6, 9, 7],
            [9, 7, 10, 10],
            [10, 10, 7, 9],
            [7, 9, 6, 10],
            [6, 10, 5, 9],
            [5, 9, 2, 10],
            [5, 4, 6, 3],
            [6, 3, 7, 4],
            [7, 4, 9, 3],
            [9, 3, 8, 5],
            [8, 5, 9, 6],
            [9, 6, 8, 7],
            [8, 7, 9, 9],
            [9, 9, 7, 8],
            [7, 8, 6, 9],
            [6, 9, 5, 8],
            [5, 8, 3, 9],
            [3, 9, 4, 7],
            [4, 7, 3, 6],
            [3, 6, 4, 5],
            [4, 5, 3, 3],
            [3, 3, 5, 4],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [6, 7, 5, 6],
            [5, 5, 5, 7],
            [5, 7, 7, 7],
            [7, 7, 7, 5],
            [7, 5, 5, 5],
            [5, 5, 4, 6],
            [4, 6, 5, 7],
            [5, 7, 6, 8],
            [6, 8, 7, 7],
            [7, 7, 8, 6],
            [8, 6, 7, 5],
            [7, 5, 6, 4],
            [6, 4, 5, 5],
            [6, 9, 6, 8],
            [8, 6, 9, 6],
            [6, 3, 6, 4],
            [4, 6, 3, 6],
            [6, 4, 8, 4],
            [8, 4, 8, 6],
            [8, 6, 8, 8],
            [8, 8, 6, 8],
            [6, 8, 4, 8],
            [4, 8, 4, 6],
            [4, 6, 4, 4],
            [4, 4, 6, 4],
            [6, 5, 6, 4],
            [6, 7, 6, 8],
            [5, 6, 4, 6],
            [7, 6, 8, 6],
            [4, 8, 5, 7],
            [7, 7, 8, 8],
            [7, 5, 8, 4],
            [5, 5, 4, 4],
        ],
    },
    {
        date: 1455191537002,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 2],
            [1, 2, 1, 1],
            [1, 1, 11, 2],
            [11, 2, 11, 1],
            [1, 1, 11, 1],
            [11, 2, 1, 2],
            [1, 2, 11, 3],
            [11, 3, 11, 2],
            [1, 3, 11, 2],
            [11, 3, 1, 3],
            [1, 3, 1, 2],
            [1, 3, 1, 4],
            [1, 4, 11, 3],
            [11, 3, 11, 4],
            [11, 4, 1, 3],
            [1, 4, 11, 5],
            [11, 5, 11, 4],
            [11, 4, 1, 5],
            [1, 4, 11, 4],
            [11, 5, 1, 5],
            [1, 5, 11, 6],
            [11, 6, 11, 5],
            [11, 5, 1, 6],
            [11, 6, 1, 6],
            [11, 6, 11, 7],
            [11, 7, 1, 6],
            [1, 6, 1, 7],
            [1, 7, 11, 6],
            [11, 7, 11, 8],
            [11, 8, 1, 7],
            [1, 7, 1, 8],
            [1, 8, 11, 7],
            [1, 8, 1, 9],
            [1, 9, 11, 8],
            [11, 8, 11, 9],
            [1, 8, 11, 9],
            [11, 8, 1, 8],
            [1, 7, 11, 7],
            [1, 9, 1, 10],
            [1, 10, 11, 9],
            [11, 9, 11, 10],
            [11, 10, 1, 9],
            [1, 9, 11, 9],
            [11, 10, 1, 10],
            [1, 10, 11, 11],
            [11, 11, 11, 10],
            [1, 11, 11, 10],
            [1, 4, 1, 5],
            [1, 5, 1, 6],
            [2, 1, 2, 11],
            [3, 1, 3, 11],
            [4, 1, 4, 11],
            [5, 1, 5, 11],
            [6, 1, 6, 11],
            [7, 1, 7, 11],
            [8, 1, 8, 11],
            [9, 1, 9, 11],
            [10, 1, 10, 11],
        ],
    },
    {
        date: 1455217888147,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 1, 11],
            [1, 1, 11, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [2, 2, 1, 4],
            [2, 2, 4, 1],
            [4, 1, 6, 2],
            [6, 2, 8, 1],
            [8, 1, 10, 2],
            [10, 2, 11, 4],
            [11, 4, 10, 6],
            [10, 6, 11, 8],
            [11, 8, 10, 10],
            [10, 10, 8, 11],
            [8, 11, 6, 10],
            [6, 10, 4, 11],
            [4, 11, 2, 10],
            [2, 10, 1, 8],
            [1, 8, 2, 6],
            [1, 4, 2, 6],
            [6, 6, 5, 7],
            [6, 6, 5, 6],
            [6, 6, 5, 5],
            [6, 6, 6, 5],
            [6, 6, 7, 5],
            [6, 6, 7, 6],
            [6, 6, 7, 7],
            [6, 6, 6, 7],
            [6, 6, 4, 7],
            [6, 6, 4, 6],
            [6, 6, 4, 5],
            [6, 6, 4, 4],
            [6, 6, 5, 4],
            [6, 6, 7, 4],
            [6, 6, 8, 4],
            [6, 6, 8, 5],
            [6, 6, 8, 6],
            [6, 6, 8, 7],
            [6, 6, 8, 8],
            [6, 6, 7, 8],
            [6, 6, 6, 8],
            [6, 6, 5, 8],
            [6, 6, 4, 8],
            [6, 6, 3, 8],
            [6, 6, 3, 7],
            [6, 6, 3, 6],
            [6, 6, 3, 5],
            [6, 6, 3, 4],
            [6, 6, 3, 3],
            [6, 6, 4, 3],
            [6, 6, 5, 3],
            [6, 6, 7, 3],
            [6, 6, 6, 4],
            [6, 6, 8, 3],
            [6, 6, 9, 3],
            [6, 6, 9, 4],
            [6, 6, 9, 5],
            [6, 6, 9, 6],
            [6, 6, 9, 7],
            [6, 6, 9, 8],
            [6, 6, 6, 3],
            [3, 3, 3, 8],
            [3, 8, 9, 8],
            [9, 8, 9, 3],
            [9, 3, 3, 3],
            [3, 3, 2, 5],
            [2, 5, 3, 7],
            [2, 8, 3, 8],
            [3, 7, 2, 7],
            [2, 7, 2, 8],
            [2, 8, 3, 7],
            [3, 7, 3, 8],
            [3, 8, 2, 7],
            [3, 3, 6, 2],
            [6, 2, 9, 3],
            [9, 3, 10, 5],
            [10, 5, 9, 7],
            [9, 7, 10, 7],
            [10, 7, 10, 8],
            [10, 8, 9, 8],
            [9, 8, 10, 7],
            [9, 7, 10, 8],
            [9, 8, 6, 9],
            [6, 9, 3, 8],
        ],
    },
    {
        date: 1455191589584,
        row: 11,
        col: 11,
        segments: [
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 5, 5],
            [5, 5, 7, 5],
            [5, 5, 4, 6],
            [4, 6, 5, 7],
            [5, 7, 6, 8],
            [6, 8, 7, 7],
            [7, 7, 8, 6],
            [8, 6, 7, 5],
            [7, 5, 6, 4],
            [6, 4, 5, 5],
            [4, 4, 4, 8],
            [4, 8, 8, 8],
            [8, 8, 8, 4],
            [8, 4, 4, 4],
            [4, 4, 3, 6],
            [3, 6, 4, 8],
            [4, 8, 6, 9],
            [6, 9, 8, 8],
            [8, 8, 9, 6],
            [9, 6, 8, 4],
            [8, 4, 6, 3],
            [6, 3, 4, 4],
            [3, 3, 3, 9],
            [3, 9, 9, 9],
            [9, 9, 9, 3],
            [9, 3, 3, 3],
            [3, 3, 2, 6],
            [2, 6, 3, 9],
            [3, 9, 6, 10],
            [6, 10, 9, 9],
            [9, 9, 10, 6],
            [10, 6, 9, 3],
            [9, 3, 6, 2],
            [6, 2, 3, 3],
            [2, 10, 10, 10],
            [10, 10, 10, 2],
            [10, 2, 2, 2],
            [2, 10, 2, 2],
            [2, 2, 1, 4],
            [1, 4, 2, 6],
            [2, 6, 1, 8],
            [1, 8, 2, 10],
            [2, 10, 4, 11],
            [4, 11, 6, 10],
            [6, 10, 8, 11],
            [8, 11, 10, 10],
            [10, 10, 11, 8],
            [11, 8, 10, 6],
            [10, 6, 11, 4],
            [11, 4, 10, 2],
            [10, 2, 8, 1],
            [8, 1, 6, 2],
            [6, 2, 4, 1],
            [4, 1, 2, 2],
            [11, 11, 1, 1],
            [1, 11, 11, 1],
        ],
    },
    {
        date: 1455218300678,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 2],
            [2, 2, 3, 3],
            [3, 3, 4, 4],
            [4, 4, 5, 5],
            [5, 5, 6, 6],
            [6, 6, 7, 7],
            [7, 7, 8, 8],
            [8, 8, 9, 9],
            [9, 9, 10, 10],
            [10, 10, 11, 11],
            [1, 11, 2, 10],
            [2, 10, 3, 9],
            [3, 9, 4, 8],
            [4, 8, 5, 7],
            [5, 7, 6, 6],
            [6, 6, 7, 5],
            [7, 5, 8, 4],
            [8, 4, 9, 3],
            [9, 3, 10, 2],
            [10, 2, 11, 1],
            [2, 9, 3, 8],
            [3, 8, 4, 7],
            [4, 7, 6, 6],
            [6, 6, 8, 5],
            [8, 5, 9, 4],
            [9, 4, 10, 3],
            [10, 3, 11, 1],
            [10, 9, 9, 8],
            [9, 8, 8, 7],
            [8, 7, 6, 6],
            [6, 6, 5, 4],
            [5, 4, 4, 3],
            [4, 3, 3, 2],
            [3, 2, 1, 1],
            [2, 9, 1, 11],
            [10, 9, 11, 11],
            [6, 6, 7, 4],
            [7, 4, 8, 3],
            [8, 3, 9, 2],
            [9, 2, 11, 1],
            [6, 6, 7, 3],
            [7, 3, 8, 2],
            [6, 6, 7, 2],
            [8, 2, 11, 1],
            [7, 2, 11, 1],
            [6, 6, 9, 7],
            [9, 7, 10, 8],
            [10, 8, 11, 11],
            [6, 6, 10, 7],
            [10, 7, 11, 11],
            [6, 6, 7, 8],
            [7, 8, 8, 9],
            [8, 9, 9, 10],
            [9, 10, 11, 11],
            [6, 6, 7, 9],
            [7, 9, 8, 10],
            [8, 10, 11, 11],
            [6, 6, 7, 10],
            [7, 10, 11, 11],
            [6, 6, 9, 5],
            [9, 5, 10, 4],
            [10, 4, 11, 1],
            [6, 6, 10, 5],
            [10, 5, 11, 1],
            [6, 6, 5, 8],
            [5, 8, 4, 9],
            [4, 9, 3, 10],
            [3, 10, 1, 11],
            [6, 6, 5, 9],
            [5, 9, 4, 10],
            [4, 10, 1, 11],
            [6, 6, 5, 10],
            [5, 10, 1, 11],
            [6, 6, 3, 7],
            [3, 7, 2, 8],
            [2, 8, 1, 11],
            [6, 6, 2, 7],
            [2, 7, 1, 11],
            [6, 6, 5, 3],
            [5, 3, 4, 2],
            [4, 2, 1, 1],
            [6, 6, 5, 2],
            [5, 2, 1, 1],
            [6, 6, 4, 5],
            [4, 5, 3, 4],
            [2, 3, 3, 4],
            [3, 4, 2, 3],
            [2, 3, 1, 1],
            [6, 6, 3, 5],
            [3, 5, 2, 4],
            [2, 4, 1, 1],
            [6, 6, 2, 5],
            [2, 5, 1, 1],
            [1, 11, 6, 11],
            [6, 11, 11, 11],
            [11, 11, 11, 6],
            [11, 6, 11, 1],
            [11, 1, 6, 1],
            [6, 1, 1, 1],
            [1, 1, 1, 6],
            [1, 6, 1, 11],
            [1, 6, 6, 6],
            [6, 6, 11, 6],
            [6, 6, 6, 1],
            [6, 6, 6, 11],
        ],
    },
    {
        date: 1455218408492,
        row: 11,
        col: 11,
        segments: [
            [10, 3, 11, 4],
            [11, 4, 10, 5],
            [10, 5, 11, 6],
            [10, 7, 11, 6],
            [10, 7, 11, 8],
            [11, 8, 10, 9],
            [10, 9, 11, 10],
            [11, 10, 10, 11],
            [9, 10, 8, 11],
            [8, 11, 7, 10],
            [7, 10, 6, 11],
            [6, 11, 5, 10],
            [5, 10, 4, 11],
            [10, 3, 11, 2],
            [11, 2, 10, 1],
            [4, 11, 3, 10],
            [3, 10, 2, 11],
            [2, 11, 1, 10],
            [1, 10, 2, 9],
            [2, 9, 1, 8],
            [1, 8, 2, 7],
            [2, 7, 1, 6],
            [1, 6, 2, 5],
            [2, 5, 1, 4],
            [1, 4, 2, 3],
            [2, 3, 1, 2],
            [1, 2, 2, 1],
            [2, 1, 3, 2],
            [3, 2, 4, 1],
            [4, 1, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 8, 1],
            [8, 1, 9, 2],
            [10, 1, 9, 2],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [6, 7, 5, 6],
            [2, 8, 3, 8],
            [3, 8, 3, 9],
            [3, 9, 4, 9],
            [4, 9, 4, 10],
            [4, 10, 5, 9],
            [5, 9, 6, 10],
            [6, 10, 7, 9],
            [7, 9, 8, 10],
            [8, 9, 8, 10],
            [8, 9, 9, 9],
            [9, 9, 9, 8],
            [9, 8, 10, 8],
            [10, 8, 9, 7],
            [9, 7, 10, 6],
            [10, 6, 9, 5],
            [9, 5, 10, 4],
            [10, 4, 9, 4],
            [9, 4, 9, 3],
            [9, 3, 8, 3],
            [8, 3, 8, 2],
            [8, 2, 7, 3],
            [7, 3, 6, 2],
            [6, 2, 5, 3],
            [5, 3, 4, 2],
            [4, 2, 4, 3],
            [4, 3, 3, 3],
            [3, 4, 3, 3],
            [3, 4, 2, 4],
            [2, 4, 3, 5],
            [3, 5, 2, 6],
            [2, 6, 3, 7],
            [3, 7, 2, 8],
            [4, 5, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 6, 3],
            [6, 3, 7, 4],
            [7, 4, 8, 4],
            [8, 4, 8, 5],
            [8, 5, 9, 6],
            [9, 6, 8, 7],
            [8, 7, 8, 8],
            [8, 8, 7, 8],
            [7, 8, 6, 9],
            [6, 9, 5, 8],
            [5, 8, 4, 8],
            [4, 8, 4, 7],
            [4, 7, 3, 6],
            [3, 6, 4, 5],
            [6, 4, 5, 5],
            [5, 5, 4, 6],
            [4, 6, 5, 7],
            [5, 7, 6, 8],
            [6, 8, 7, 7],
            [7, 7, 8, 6],
            [8, 6, 7, 5],
            [7, 5, 6, 4],
            [1, 11, 1, 1],
            [1, 1, 11, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [6, 8, 6, 4],
            [4, 6, 8, 6],
            [6, 6, 7, 5],
            [6, 6, 7, 7],
            [6, 6, 5, 7],
            [6, 6, 5, 6],
            [5, 5, 6, 6],
            [9, 10, 10, 11],
        ],
    },
    {
        date: 1455279233723,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 11, 6],
            [11, 6, 11, 11],
            [11, 11, 6, 11],
            [6, 11, 1, 11],
            [1, 11, 1, 6],
            [1, 6, 1, 1],
            [1, 1, 6, 1],
            [6, 1, 11, 1],
            [6, 1, 6, 6],
            [6, 6, 6, 11],
            [1, 6, 6, 6],
            [6, 6, 11, 6],
            [6, 6, 1, 11],
            [1, 1, 6, 6],
            [6, 6, 11, 11],
            [11, 1, 6, 6],
            [6, 6, 7, 4],
            [7, 4, 11, 1],
            [6, 6, 7, 3],
            [7, 3, 11, 1],
            [6, 6, 7, 2],
            [7, 2, 11, 1],
            [6, 6, 8, 5],
            [8, 5, 11, 1],
            [6, 6, 9, 5],
            [9, 5, 11, 1],
            [6, 6, 10, 5],
            [10, 5, 11, 1],
            [6, 6, 8, 7],
            [11, 11, 8, 7],
            [6, 6, 7, 8],
            [7, 8, 11, 11],
            [6, 6, 7, 9],
            [7, 9, 11, 11],
            [6, 6, 7, 10],
            [7, 10, 11, 11],
            [6, 6, 9, 7],
            [9, 7, 11, 11],
            [6, 6, 10, 7],
            [10, 7, 11, 11],
            [6, 6, 5, 4],
            [5, 4, 1, 1],
            [6, 6, 5, 3],
            [5, 3, 1, 1],
            [6, 6, 5, 2],
            [5, 2, 1, 1],
            [6, 6, 4, 5],
            [4, 5, 1, 1],
            [6, 6, 3, 5],
            [3, 5, 1, 1],
            [6, 6, 2, 5],
            [2, 5, 1, 1],
            [6, 6, 5, 8],
            [5, 8, 1, 11],
            [6, 6, 5, 9],
            [5, 9, 1, 11],
            [6, 6, 5, 10],
            [5, 10, 1, 11],
            [6, 6, 4, 7],
            [4, 7, 1, 11],
            [6, 6, 3, 7],
            [3, 7, 1, 11],
            [6, 6, 2, 7],
            [2, 7, 1, 11],
            [8, 2, 8, 3],
            [8, 3, 9, 4],
            [9, 4, 10, 4],
            [8, 10, 8, 9],
            [8, 9, 9, 8],
            [9, 8, 10, 8],
            [2, 8, 3, 8],
            [3, 8, 4, 9],
            [4, 9, 4, 10],
            [2, 4, 3, 4],
            [3, 4, 4, 3],
            [4, 3, 4, 2],
            [6, 1, 7, 2],
            [5, 2, 6, 1],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [10, 7, 11, 6],
            [2, 7, 1, 6],
            [1, 6, 2, 5],
            [11, 6, 10, 5],
            [7, 1, 7, 2],
            [8, 1, 8, 2],
            [9, 1, 9, 2],
            [10, 1, 10, 2],
            [10, 4, 10, 3],
            [10, 3, 10, 2],
            [9, 2, 9, 3],
            [9, 3, 9, 4],
            [4, 1, 4, 2],
            [3, 1, 3, 2],
            [3, 2, 3, 3],
            [3, 3, 3, 4],
            [2, 4, 2, 3],
            [2, 3, 2, 2],
            [2, 2, 2, 1],
            [4, 10, 4, 11],
            [3, 11, 3, 10],
            [3, 10, 3, 9],
            [3, 9, 3, 8],
            [2, 8, 2, 9],
            [2, 9, 2, 10],
            [2, 10, 2, 11],
            [8, 10, 8, 11],
            [9, 11, 9, 10],
            [9, 10, 9, 9],
            [9, 9, 9, 8],
            [10, 8, 10, 9],
            [10, 9, 10, 10],
            [10, 10, 10, 11],
            [10, 5, 11, 4],
            [2, 5, 1, 4],
            [2, 7, 1, 8],
            [10, 7, 11, 8],
        ],
    },
    {
        date: 1455280034726,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 7, 2],
            [7, 8, 7, 2],
            [7, 8, 11, 11],
            [5, 2, 1, 1],
            [5, 2, 5, 8],
            [5, 8, 1, 11],
            [5, 2, 1, 5],
            [1, 5, 5, 8],
            [7, 2, 11, 5],
            [11, 5, 7, 8],
            [7, 2, 6, 3],
            [6, 3, 5, 4],
            [5, 8, 5, 7],
            [5, 7, 5, 5],
            [5, 5, 5, 3],
            [5, 2, 6, 2],
            [6, 2, 7, 2],
            [5, 2, 7, 4],
            [5, 3, 6, 2],
            [6, 2, 7, 3],
            [7, 3, 6, 3],
            [6, 3, 6, 2],
            [6, 3, 5, 3],
            [5, 3, 6, 4],
            [6, 4, 5, 4],
            [6, 4, 6, 3],
            [7, 3, 6, 4],
            [6, 4, 7, 4],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [6, 4, 7, 5],
            [6, 4, 5, 5],
            [5, 5, 6, 5],
            [6, 5, 7, 5],
            [6, 6, 6, 5],
            [6, 5, 6, 4],
            [6, 6, 5, 5],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
            [6, 6, 7, 5],
            [6, 6, 7, 6],
            [6, 6, 5, 6],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [7, 7, 6, 7],
            [6, 7, 6, 6],
            [6, 7, 5, 7],
            [5, 7, 6, 6],
            [6, 6, 7, 7],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [5, 8, 6, 7],
            [6, 7, 7, 8],
            [7, 8, 6, 8],
            [6, 8, 6, 7],
            [6, 8, 5, 8],
            [2, 10, 2, 11],
            [3, 10, 3, 11],
            [4, 10, 4, 11],
            [5, 10, 5, 11],
            [6, 10, 6, 11],
            [7, 10, 7, 11],
            [8, 10, 8, 11],
            [9, 10, 9, 11],
            [10, 10, 10, 11],
            [10, 11, 9, 11],
            [9, 11, 8, 11],
            [8, 11, 7, 11],
            [7, 11, 6, 11],
            [6, 11, 5, 11],
            [5, 11, 4, 11],
            [4, 11, 3, 11],
            [3, 11, 2, 11],
            [2, 11, 1, 11],
            [1, 11, 1, 10],
            [1, 10, 2, 10],
            [2, 10, 3, 10],
            [3, 10, 4, 10],
            [4, 10, 5, 10],
            [5, 10, 6, 10],
            [6, 10, 7, 10],
            [7, 10, 8, 10],
            [8, 10, 9, 10],
            [9, 10, 10, 10],
            [10, 10, 11, 10],
            [11, 10, 11, 11],
            [11, 11, 10, 11],
            [3, 10, 3, 9],
            [4, 9, 4, 10],
            [5, 9, 5, 10],
            [6, 9, 6, 10],
            [7, 9, 7, 10],
            [8, 9, 8, 10],
            [9, 9, 9, 10],
            [9, 9, 3, 9],
            [4, 9, 4, 8],
            [5, 9, 5, 8],
            [6, 9, 6, 8],
            [7, 9, 7, 8],
            [8, 9, 8, 8],
            [8, 8, 4, 8],
            [1, 1, 1, 2],
            [1, 2, 2, 2],
            [2, 2, 3, 2],
            [3, 2, 4, 2],
            [4, 2, 5, 2],
            [7, 2, 8, 2],
            [8, 2, 9, 2],
            [9, 2, 10, 2],
            [10, 2, 11, 2],
            [11, 2, 11, 1],
            [11, 1, 10, 1],
            [10, 1, 9, 1],
            [9, 1, 8, 1],
            [8, 1, 7, 1],
            [7, 1, 6, 1],
            [1, 1, 2, 1],
            [2, 1, 3, 1],
            [3, 1, 4, 1],
            [4, 1, 5, 1],
            [5, 1, 6, 1],
            [2, 1, 2, 2],
            [3, 1, 3, 2],
            [4, 1, 4, 2],
            [5, 1, 5, 2],
            [6, 1, 6, 2],
            [7, 1, 7, 2],
            [8, 1, 8, 2],
            [9, 1, 9, 2],
            [10, 1, 10, 2],
            [3, 2, 3, 3],
            [3, 3, 4, 3],
            [4, 3, 5, 3],
            [7, 3, 8, 3],
            [8, 3, 9, 3],
            [9, 3, 9, 2],
            [8, 2, 8, 3],
            [4, 3, 4, 2],
            [4, 3, 4, 4],
            [5, 4, 4, 4],
            [7, 4, 8, 4],
            [8, 4, 8, 3],
        ],
    },
    {
        date: 1455280170934,
        row: 11,
        col: 11,
        segments: [
            [2, 1, 1, 2],
            [1, 2, 2, 3],
            [2, 3, 1, 4],
            [1, 4, 2, 5],
            [2, 5, 1, 6],
            [1, 6, 2, 7],
            [2, 7, 1, 8],
            [1, 8, 2, 9],
            [2, 9, 1, 10],
            [1, 10, 2, 11],
            [2, 11, 3, 10],
            [3, 10, 4, 11],
            [4, 11, 5, 10],
            [5, 10, 6, 11],
            [6, 11, 7, 10],
            [7, 10, 8, 11],
            [8, 11, 9, 10],
            [9, 10, 10, 11],
            [10, 11, 11, 10],
            [11, 10, 10, 9],
            [10, 9, 11, 8],
            [11, 8, 10, 7],
            [10, 7, 11, 6],
            [11, 6, 10, 5],
            [10, 5, 11, 4],
            [11, 4, 10, 3],
            [10, 3, 11, 2],
            [11, 2, 10, 1],
            [10, 1, 9, 2],
            [9, 2, 8, 1],
            [8, 1, 7, 2],
            [7, 2, 6, 1],
            [6, 1, 5, 2],
            [5, 2, 4, 1],
            [4, 1, 3, 2],
            [3, 2, 2, 1],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [2, 2, 2, 4],
            [2, 2, 4, 2],
            [8, 2, 10, 2],
            [10, 2, 10, 4],
            [10, 8, 10, 10],
            [10, 10, 8, 10],
            [2, 8, 2, 10],
            [2, 10, 4, 10],
            [5, 3, 6, 2],
            [6, 2, 7, 3],
            [3, 5, 2, 6],
            [2, 6, 3, 7],
            [5, 9, 6, 10],
            [6, 10, 7, 9],
            [9, 7, 10, 6],
            [10, 6, 9, 5],
            [3, 7, 3, 9],
            [3, 9, 5, 9],
            [3, 5, 3, 3],
            [3, 3, 5, 3],
            [7, 3, 9, 3],
            [9, 3, 9, 5],
            [9, 7, 9, 9],
            [9, 9, 7, 9],
            [3, 6, 4, 5],
            [3, 6, 4, 7],
            [5, 8, 6, 9],
            [6, 9, 7, 8],
            [8, 7, 9, 6],
            [9, 6, 8, 5],
            [5, 4, 6, 3],
            [6, 3, 7, 4],
            [4, 6, 5, 7],
            [4, 6, 5, 5],
            [5, 5, 6, 4],
            [6, 4, 7, 5],
            [7, 5, 8, 6],
            [8, 6, 7, 7],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [4, 8, 4, 7],
            [4, 8, 5, 8],
            [7, 8, 8, 8],
            [8, 8, 8, 7],
            [8, 5, 8, 4],
            [8, 4, 7, 4],
            [5, 4, 4, 4],
            [4, 4, 4, 5],
            [6, 5, 6, 7],
            [6, 7, 7, 6],
            [5, 6, 6, 7],
            [5, 6, 7, 6],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
        ],
    },
    {
        date: 1455293413925,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 1, 4],
            [1, 4, 2, 6],
            [2, 6, 1, 8],
            [1, 8, 2, 10],
            [2, 10, 4, 11],
            [4, 11, 6, 10],
            [6, 10, 8, 11],
            [8, 11, 10, 10],
            [10, 10, 11, 8],
            [11, 8, 10, 6],
            [10, 6, 11, 4],
            [11, 4, 10, 2],
            [10, 2, 8, 1],
            [8, 1, 6, 2],
            [6, 2, 4, 1],
            [4, 1, 2, 2],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [3, 2, 2, 3],
            [2, 5, 3, 6],
            [3, 6, 2, 7],
            [3, 10, 2, 9],
            [5, 10, 6, 9],
            [6, 9, 7, 10],
            [9, 10, 10, 9],
            [10, 7, 9, 6],
            [9, 6, 10, 5],
            [10, 3, 9, 2],
            [9, 2, 7, 2],
            [7, 2, 6, 3],
            [6, 3, 5, 2],
            [5, 2, 3, 2],
            [9, 10, 7, 10],
            [3, 10, 5, 10],
            [2, 9, 2, 7],
            [2, 5, 2, 3],
            [10, 9, 10, 7],
            [10, 3, 10, 5],
            [3, 3, 3, 5],
            [3, 5, 4, 6],
            [4, 6, 3, 7],
            [3, 7, 3, 9],
            [3, 9, 5, 9],
            [5, 9, 6, 8],
            [6, 8, 7, 9],
            [7, 9, 9, 9],
            [9, 9, 9, 7],
            [9, 7, 8, 6],
            [8, 6, 9, 5],
            [9, 5, 9, 3],
            [9, 3, 7, 3],
            [7, 3, 6, 4],
            [6, 4, 5, 3],
            [5, 3, 3, 3],
            [4, 5, 4, 4],
            [4, 4, 5, 4],
            [5, 4, 6, 5],
            [6, 5, 7, 4],
            [7, 4, 8, 4],
            [8, 4, 8, 5],
            [8, 5, 7, 6],
            [7, 6, 8, 7],
            [8, 7, 8, 8],
            [8, 8, 7, 8],
            [7, 8, 6, 7],
            [6, 7, 5, 8],
            [5, 8, 4, 8],
            [4, 8, 4, 7],
            [4, 7, 5, 6],
            [5, 6, 4, 5],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [5, 7, 7, 7],
            [5, 7, 5, 5],
            [5, 6, 6, 5],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [6, 7, 5, 6],
            [6, 7, 6, 5],
            [5, 6, 7, 6],
        ],
    },
    {
        date: 1455382126916,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 11, 1],
            [11, 1, 11, 6],
            [11, 6, 11, 11],
            [11, 11, 6, 11],
            [6, 11, 1, 11],
            [1, 11, 1, 6],
            [1, 6, 1, 1],
            [6, 1, 6, 6],
            [6, 6, 6, 11],
            [1, 6, 6, 6],
            [6, 6, 11, 6],
            [11, 6, 6, 1],
            [6, 1, 1, 6],
            [1, 6, 6, 11],
            [6, 11, 11, 6],
            [11, 1, 10, 5],
            [11, 1, 9, 4],
            [11, 1, 8, 3],
            [11, 1, 7, 2],
            [6, 6, 7, 2],
            [6, 6, 8, 3],
            [6, 6, 9, 4],
            [6, 6, 10, 5],
            [6, 6, 10, 7],
            [6, 6, 9, 8],
            [6, 6, 8, 9],
            [6, 6, 7, 10],
            [11, 11, 10, 7],
            [11, 11, 9, 8],
            [11, 11, 8, 9],
            [11, 11, 7, 10],
            [6, 6, 5, 10],
            [6, 6, 4, 9],
            [6, 6, 3, 8],
            [6, 6, 2, 7],
            [1, 11, 5, 10],
            [1, 11, 2, 7],
            [1, 11, 3, 8],
            [1, 11, 4, 9],
            [6, 6, 5, 2],
            [6, 6, 4, 3],
            [6, 6, 3, 4],
            [6, 6, 2, 5],
            [2, 5, 1, 1],
            [1, 1, 3, 4],
            [4, 3, 1, 1],
            [5, 2, 1, 1],
            [1, 1, 6, 1],
        ],
    },
    {
        date: 1456137282911,
        row: 11,
        col: 11,
        segments: [
            [3, 3, 5, 3],
            [5, 3, 6, 4],
            [6, 4, 7, 3],
            [7, 3, 9, 3],
            [9, 3, 9, 5],
            [9, 5, 6, 8],
            [6, 8, 3, 5],
            [3, 5, 3, 3],
            [3, 4, 2, 3],
            [2, 3, 2, 4],
            [2, 4, 1, 4],
            [1, 4, 2, 5],
            [2, 5, 1, 6],
            [1, 6, 2, 6],
            [2, 6, 3, 5],
            [9, 4, 10, 3],
            [10, 3, 10, 4],
            [10, 4, 11, 4],
            [11, 4, 10, 5],
            [10, 5, 11, 6],
            [11, 6, 10, 6],
            [10, 6, 9, 5],
            [4, 2, 8, 2],
            [8, 2, 8, 1],
            [4, 1, 4, 2],
            [4, 1, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 8, 1],
        ],
    },
    {
        date: 1455383764051,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 1],
            [11, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 1, 1],
            [1, 1, 1, 11],
            [11, 11, 11, 1],
            [11, 1, 8, 8],
            [8, 8, 4, 8],
            [4, 8, 1, 1],
            [1, 1, 6, 3],
            [6, 3, 11, 1],
            [6, 1, 6, 11],
            [6, 11, 9, 9],
            [9, 9, 11, 5],
            [6, 11, 3, 9],
            [3, 9, 1, 5],
        ],
    },
    {
        date: 1456738755667,
        row: 11,
        col: 11,
        segments: [
            [3, 5, 4, 3],
            [4, 3, 6, 2],
            [6, 2, 8, 3],
            [8, 3, 9, 5],
            [9, 5, 6, 8],
            [6, 8, 3, 5],
            [5, 4, 5, 3],
            [7, 4, 7, 3],
            [7, 5, 5, 5],
            [10, 2, 10, 1],
            [11, 1, 10, 1],
            [11, 1, 11, 2],
            [11, 2, 10, 2],
            [2, 2, 2, 1],
            [2, 2, 1, 2],
            [1, 2, 1, 1],
            [1, 1, 2, 1],
            [1, 11, 1, 10],
            [2, 11, 2, 10],
            [1, 10, 2, 10],
            [2, 11, 1, 11],
            [10, 11, 10, 10],
            [10, 10, 11, 10],
            [11, 10, 11, 11],
            [11, 11, 10, 11],
            [9, 5, 11, 5],
            [3, 5, 1, 5],
            [6, 2, 6, 1],
            [6, 8, 6, 11],
        ],
    },
    {
        date: 1457886581304,
        row: 11,
        col: 11,
        segments: [
            [10, 2, 7, 4],
            [7, 2, 10, 4],
            [5, 2, 2, 4],
            [2, 2, 5, 4],
            [6, 5, 5, 6],
            [5, 6, 7, 6],
            [7, 6, 6, 5],
            [6, 8, 3, 6],
            [3, 6, 6, 9],
            [9, 6, 6, 8],
            [6, 9, 9, 6],
        ],
    },
    {
        date: 1461578076726,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 11],
            [1, 11, 6, 1],
            [6, 1, 11, 6],
            [11, 6, 6, 11],
            [6, 11, 1, 6],
            [1, 6, 11, 1],
            [1, 1, 11, 11],
            [11, 11, 1, 6],
            [1, 6, 11, 6],
            [11, 6, 1, 1],
            [11, 1, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [1, 1, 11, 1],
            [1, 6, 6, 1],
            [6, 1, 6, 11],
            [11, 11, 6, 1],
            [1, 11, 11, 6],
        ],
    },
    {
        date: 1427120261771,
        row: 11,
        col: 11,
        segments: [
            [11, 10, 10, 11],
            [11, 9, 9, 11],
            [11, 8, 8, 11],
            [11, 7, 7, 11],
            [11, 6, 6, 11],
            [11, 5, 5, 11],
            [9, 1, 1, 9],
            [8, 1, 1, 8],
            [7, 1, 1, 7],
            [6, 1, 1, 6],
            [5, 1, 1, 5],
            [4, 1, 1, 4],
            [3, 1, 1, 3],
            [2, 1, 1, 2],
            [4, 11, 11, 4],
            [11, 3, 3, 11],
            [11, 1, 1, 11],
            [1, 10, 10, 1],
            [2, 11, 11, 2],
            [10, 1, 11, 2],
            [11, 3, 9, 1],
            [11, 4, 8, 1],
            [11, 5, 7, 1],
            [11, 6, 6, 1],
            [11, 7, 5, 1],
            [11, 8, 4, 1],
            [11, 9, 3, 1],
            [11, 10, 2, 1],
            [11, 11, 1, 1],
            [1, 2, 10, 11],
            [9, 11, 1, 3],
            [1, 4, 8, 11],
            [7, 11, 1, 5],
            [1, 6, 6, 11],
            [5, 11, 1, 7],
            [1, 8, 4, 11],
            [3, 11, 1, 9],
            [1, 10, 2, 11],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [11, 1, 1, 1],
            [10, 1, 10, 11],
            [9, 1, 9, 11],
            [8, 1, 8, 11],
            [7, 11, 7, 6],
            [7, 1, 7, 6],
            [6, 1, 6, 11],
            [5, 11, 5, 1],
            [4, 1, 4, 11],
            [3, 11, 3, 1],
            [2, 1, 2, 11],
            [1, 10, 11, 10],
            [11, 9, 1, 9],
            [1, 8, 11, 8],
            [11, 7, 1, 7],
            [1, 6, 11, 6],
            [11, 5, 1, 5],
            [1, 4, 11, 4],
            [11, 3, 1, 3],
            [1, 2, 11, 2],
        ],
    },
    {
        date: 1464343487368,
        row: 11,
        col: 11,
        segments: [
            [3, 2, 2, 2],
            [2, 2, 2, 3],
            [2, 3, 2, 4],
            [2, 4, 2, 6],
            [2, 6, 2, 8],
            [2, 8, 2, 10],
            [2, 10, 5, 10],
            [5, 10, 7, 10],
            [7, 10, 8, 10],
            [8, 10, 10, 10],
            [10, 10, 10, 7],
            [10, 7, 10, 4],
            [10, 4, 10, 2],
            [10, 2, 3, 2],
            [2, 2, 1, 1],
            [3, 2, 3, 1],
            [4, 2, 4, 1],
            [5, 2, 5, 1],
            [6, 2, 6, 1],
            [7, 2, 7, 1],
            [8, 2, 8, 1],
            [9, 2, 9, 1],
            [10, 2, 10, 1],
            [10, 2, 11, 1],
            [10, 2, 11, 2],
            [11, 2, 10, 3],
            [10, 3, 11, 3],
            [11, 3, 10, 4],
            [10, 4, 11, 4],
            [11, 4, 10, 5],
            [10, 5, 11, 5],
            [11, 5, 10, 6],
            [10, 6, 11, 6],
            [11, 6, 10, 7],
            [10, 7, 11, 7],
            [11, 7, 10, 8],
            [10, 8, 11, 8],
            [11, 8, 10, 9],
            [10, 9, 11, 9],
            [11, 9, 10, 10],
            [10, 10, 11, 10],
            [10, 10, 11, 11],
            [10, 10, 10, 11],
            [9, 10, 9, 11],
            [8, 10, 8, 11],
            [7, 10, 7, 11],
            [6, 10, 6, 11],
            [5, 10, 5, 11],
            [4, 10, 4, 11],
            [3, 10, 3, 11],
            [2, 10, 1, 11],
            [2, 10, 2, 11],
            [1, 10, 2, 10],
            [2, 10, 1, 9],
            [1, 9, 2, 9],
            [2, 9, 1, 8],
            [1, 8, 2, 8],
            [2, 8, 1, 7],
            [1, 7, 2, 7],
            [2, 7, 1, 6],
            [1, 6, 2, 6],
            [2, 6, 1, 5],
            [1, 5, 2, 5],
            [2, 5, 1, 4],
            [1, 4, 2, 4],
            [2, 4, 1, 3],
            [1, 3, 2, 3],
            [2, 3, 1, 2],
            [1, 2, 2, 2],
            [2, 2, 2, 1],
            [3, 3, 5, 5],
            [5, 5, 7, 5],
            [7, 5, 9, 3],
            [7, 5, 7, 7],
            [7, 7, 5, 7],
            [5, 7, 3, 9],
            [7, 7, 9, 9],
            [5, 5, 5, 7],
            [5, 5, 5, 3],
            [6, 5, 6, 3],
            [7, 5, 7, 3],
            [7, 5, 9, 5],
            [7, 6, 9, 6],
            [7, 7, 9, 7],
            [7, 7, 7, 9],
            [6, 7, 6, 9],
            [5, 7, 5, 9],
            [5, 7, 3, 7],
            [5, 6, 3, 6],
            [5, 5, 3, 5],
            [5, 5, 6, 6],
            [6, 6, 7, 5],
            [7, 6, 6, 6],
            [7, 7, 6, 6],
            [6, 6, 6, 7],
            [5, 7, 6, 6],
            [5, 6, 6, 6],
            [3, 9, 3, 3],
            [3, 3, 9, 3],
            [9, 3, 9, 9],
            [9, 9, 3, 9],
            [6, 6, 6, 5],
        ],
    },
    {
        date: 1465553357613,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 11, 11],
            [11, 11, 11, 5],
            [11, 5, 1, 5],
            [1, 5, 1, 11],
            [1, 11, 11, 1],
            [11, 1, 1, 1],
            [6, 11, 6, 1],
            [1, 7, 6, 6],
            [1, 8, 6, 6],
            [1, 9, 6, 6],
            [1, 10, 6, 6],
            [2, 11, 6, 6],
            [3, 11, 6, 6],
            [4, 11, 6, 6],
            [5, 11, 6, 6],
            [7, 11, 6, 6],
            [8, 11, 6, 6],
            [9, 11, 6, 6],
            [10, 11, 6, 6],
            [11, 10, 6, 6],
            [6, 6, 11, 9],
            [11, 8, 6, 6],
            [6, 6, 11, 7],
            [11, 6, 6, 6],
            [11, 5, 6, 6],
            [9, 5, 6, 6],
            [8, 5, 6, 6],
            [7, 5, 6, 6],
            [6, 6, 5, 5],
            [6, 6, 4, 5],
            [6, 6, 3, 5],
            [6, 6, 2, 5],
            [6, 6, 1, 5],
            [6, 6, 1, 6],
            [1, 5, 1, 2],
            [1, 2, 11, 2],
            [11, 2, 11, 5],
            [3, 2, 6, 4],
            [6, 4, 9, 2],
            [5, 2, 5, 3],
            [7, 2, 7, 3],
            [5, 4, 4, 4],
            [7, 4, 8, 4],
            [8, 5, 10, 3],
            [10, 5, 11, 3],
            [3, 5, 1, 3],
            [4, 5, 2, 3],
            [3, 1, 3, 2],
            [4, 1, 4, 2],
            [5, 1, 5, 2],
            [7, 1, 7, 2],
            [8, 1, 8, 2],
            [9, 2, 9, 1],
            [10, 1, 10, 2],
            [1, 3, 11, 3],
            [11, 4, 1, 4],
            [1, 5, 1, 7],
        ],
    },
    {
        date: 1477385666090,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 3, 2],
            [3, 2, 3, 3],
            [3, 3, 2, 3],
            [2, 3, 2, 2],
            [1, 1, 1, 4],
            [1, 4, 4, 4],
            [4, 4, 4, 1],
            [4, 1, 1, 1],
            [8, 1, 11, 1],
            [11, 1, 11, 4],
            [11, 4, 8, 4],
            [8, 4, 8, 1],
            [9, 2, 10, 2],
            [10, 2, 10, 3],
            [10, 3, 9, 3],
            [9, 3, 9, 2],
            [2, 9, 2, 10],
            [2, 10, 3, 10],
            [3, 9, 3, 10],
            [2, 9, 3, 9],
            [1, 8, 4, 8],
            [4, 8, 4, 11],
            [4, 11, 1, 11],
            [1, 11, 1, 8],
            [8, 8, 11, 8],
            [11, 8, 11, 11],
            [11, 11, 8, 11],
            [8, 8, 8, 11],
            [9, 9, 9, 10],
            [9, 10, 10, 10],
            [10, 10, 10, 9],
            [10, 9, 9, 9],
            [5, 3, 5, 5],
            [5, 5, 3, 5],
            [3, 7, 5, 7],
            [5, 7, 5, 9],
            [5, 9, 6, 11],
            [6, 11, 7, 9],
            [7, 9, 7, 7],
            [7, 7, 9, 7],
            [9, 7, 11, 6],
            [11, 6, 9, 5],
            [9, 5, 7, 5],
            [7, 5, 7, 3],
            [7, 3, 6, 1],
            [5, 3, 6, 1],
            [3, 7, 1, 6],
            [1, 6, 3, 5],
            [6, 5, 5, 6],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [7, 6, 6, 5],
            [5, 4, 4, 5],
            [4, 7, 5, 8],
            [7, 8, 8, 7],
            [7, 4, 8, 5],
            [2, 6, 4, 5],
            [2, 6, 4, 7],
            [5, 8, 6, 10],
            [6, 10, 7, 8],
            [8, 7, 10, 6],
            [10, 6, 8, 5],
            [7, 4, 6, 2],
            [5, 4, 6, 2],
        ],
    },
    {
        date: 1466157501093,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 11],
            [1, 1, 11, 11],
            [11, 11, 7, 6],
            [7, 6, 11, 1],
            [11, 1, 6, 5],
            [6, 5, 1, 1],
            [1, 1, 5, 6],
            [5, 6, 1, 11],
            [1, 11, 6, 7],
            [6, 7, 11, 11],
            [6, 7, 6, 5],
            [5, 6, 7, 6],
            [1, 11, 6, 8],
            [6, 8, 11, 11],
            [11, 11, 6, 9],
            [6, 9, 1, 11],
            [1, 11, 6, 10],
            [6, 10, 11, 11],
            [11, 11, 8, 6],
            [8, 6, 11, 1],
            [11, 11, 9, 6],
            [9, 6, 11, 1],
            [11, 1, 10, 6],
            [11, 1, 6, 4],
            [6, 4, 1, 1],
            [1, 1, 6, 3],
            [6, 3, 11, 1],
            [11, 1, 6, 2],
            [6, 2, 1, 1],
            [1, 1, 4, 6],
            [4, 6, 1, 11],
            [1, 11, 3, 6],
            [3, 6, 1, 1],
            [1, 1, 2, 6],
            [2, 6, 1, 11],
            [6, 7, 6, 10],
            [6, 5, 6, 2],
            [2, 6, 10, 6],
            [11, 2, 10, 6],
            [11, 11, 10, 6],
            [11, 10, 10, 6],
            [11, 10, 11, 11],
            [11, 2, 11, 1],
            [1, 2, 2, 6],
            [2, 6, 1, 10],
            [1, 10, 1, 11],
            [1, 2, 1, 1],
            [2, 1, 6, 2],
            [6, 2, 10, 1],
            [10, 1, 11, 1],
            [2, 1, 1, 1],
        ],
    },
    {
        date: 1478733572188,
        row: 11,
        col: 11,
        segments: [
            [1, 11, 11, 1],
            [11, 1, 2, 11],
            [11, 1, 1, 10],
            [11, 1, 1, 9],
            [11, 1, 1, 8],
            [11, 1, 1, 7],
            [1, 6, 11, 1],
            [11, 1, 1, 5],
            [1, 4, 11, 1],
            [11, 1, 1, 3],
            [1, 2, 11, 1],
            [3, 11, 11, 1],
            [11, 1, 4, 11],
            [5, 11, 11, 1],
            [11, 1, 6, 11],
            [7, 11, 11, 1],
            [11, 1, 8, 11],
            [9, 11, 11, 1],
            [10, 11, 11, 1],
            [1, 1, 11, 2],
            [1, 1, 11, 3],
            [1, 1, 11, 4],
            [11, 5, 1, 1],
            [1, 1, 11, 6],
            [11, 7, 1, 1],
            [1, 1, 11, 8],
            [11, 9, 1, 1],
            [11, 10, 1, 1],
            [1, 1, 11, 11],
            [10, 11, 1, 1],
            [1, 1, 9, 11],
            [8, 11, 1, 1],
            [7, 11, 1, 1],
            [6, 11, 1, 1],
            [5, 11, 1, 1],
            [4, 11, 1, 1],
            [3, 11, 1, 1],
            [2, 11, 1, 1],
            [1, 11, 10, 1],
            [1, 11, 9, 1],
            [1, 11, 8, 1],
            [1, 11, 7, 1],
            [6, 1, 1, 11],
            [5, 1, 1, 11],
            [4, 1, 1, 11],
            [3, 1, 1, 11],
            [2, 1, 1, 11],
            [11, 2, 1, 11],
            [1, 11, 11, 3],
            [1, 11, 11, 4],
            [11, 5, 1, 11],
            [1, 11, 11, 6],
            [11, 7, 1, 11],
            [1, 11, 11, 8],
            [11, 9, 1, 11],
            [1, 11, 11, 10],
            [11, 11, 2, 1],
            [11, 11, 3, 1],
            [4, 1, 11, 11],
            [11, 11, 5, 1],
            [6, 1, 11, 11],
            [11, 11, 7, 1],
            [8, 1, 11, 11],
            [9, 1, 11, 11],
            [11, 11, 10, 1],
            [11, 11, 1, 10],
            [1, 9, 11, 11],
            [11, 11, 1, 8],
            [1, 7, 11, 11],
            [11, 11, 1, 6],
            [1, 5, 11, 11],
            [11, 11, 1, 4],
            [1, 3, 11, 11],
            [11, 11, 1, 2],
        ],
    },
    {
        date: 1485197383031,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 1, 6],
            [1, 6, 6, 11],
            [6, 11, 11, 6],
            [11, 6, 6, 1],
            [5, 1, 1, 5],
            [1, 5, 6, 10],
            [6, 10, 11, 5],
            [11, 5, 7, 1],
            [4, 1, 1, 4],
            [1, 4, 6, 9],
            [6, 9, 11, 4],
            [11, 4, 8, 1],
            [3, 1, 1, 3],
            [1, 3, 6, 8],
            [6, 8, 11, 3],
            [11, 3, 9, 1],
            [2, 1, 1, 2],
            [1, 2, 6, 7],
            [6, 7, 11, 2],
            [11, 2, 10, 1],
            [6, 2, 1, 7],
            [1, 7, 5, 11],
            [7, 11, 11, 7],
            [11, 7, 6, 2],
            [6, 3, 1, 8],
            [1, 8, 4, 11],
            [8, 11, 11, 8],
            [11, 8, 6, 3],
            [6, 4, 1, 9],
            [1, 9, 3, 11],
            [6, 4, 11, 9],
            [11, 9, 9, 11],
            [1, 10, 2, 11],
            [10, 11, 11, 10],
            [11, 10, 6, 5],
            [6, 5, 1, 10],
            [11, 1, 1, 1],
            [1, 1, 1, 11],
            [1, 11, 11, 11],
            [11, 11, 11, 1],
            [6, 5, 6, 7],
            [7, 6, 5, 6],
        ],
    },
    {
        date: 1485023765453,
        row: 11,
        col: 11,
        segments: [
            [1, 1, 2, 2],
            [3, 1, 2, 2],
            [2, 2, 1, 3],
            [2, 2, 3, 3],
            [3, 3, 5, 1],
            [3, 1, 5, 3],
            [1, 3, 1, 1],
            [5, 1, 7, 3],
            [5, 3, 7, 1],
            [7, 3, 8, 2],
            [8, 2, 7, 1],
            [8, 2, 9, 1],
            [8, 2, 9, 3],
            [9, 3, 10, 2],
            [10, 2, 9, 1],
            [10, 2, 11, 1],
            [10, 2, 11, 3],
            [1, 3, 4, 4],
            [4, 4, 8, 4],
            [8, 4, 11, 3],
            [4, 4, 1, 5],
            [8, 4, 11, 5],
            [1, 5, 1, 3],
            [11, 5, 11, 3],
            [1, 5, 2, 6],
            [1, 7, 2, 6],
            [2, 6, 3, 5],
            [3, 5, 4, 6],
            [4, 6, 3, 7],
            [3, 7, 2, 6],
            [4, 6, 5, 5],
            [5, 5, 6, 6],
            [6, 6, 5, 7],
            [5, 7, 4, 6],
            [6, 6, 7, 5],
            [7, 5, 8, 6],
            [8, 6, 7, 7],
            [7, 7, 6, 6],
            [8, 6, 9, 5],
            [9, 5, 10, 6],
            [10, 6, 9, 7],
            [9, 7, 8, 6],
            [10, 6, 11, 5],
            [10, 6, 11, 7],
            [1, 7, 4, 8],
            [4, 8, 8, 8],
            [11, 7, 8, 8],
            [8, 8, 11, 9],
            [4, 8, 1, 9],
            [1, 9, 2, 10],
            [1, 11, 2, 10],
            [2, 10, 3, 9],
            [3, 9, 4, 10],
            [4, 10, 3, 11],
            [3, 11, 2, 10],
            [4, 10, 5, 9],
            [5, 9, 6, 10],
            [6, 10, 5, 11],
            [5, 11, 4, 10],
            [6, 10, 7, 9],
            [7, 9, 8, 10],
            [8, 10, 7, 11],
            [7, 11, 6, 10],
            [8, 10, 9, 9],
            [9, 9, 10, 10],
            [10, 10, 9, 11],
            [9, 11, 8, 10],
            [10, 10, 11, 9],
            [10, 10, 11, 11],
        ],
    },
    {
        date: 1485252509644,
        row: 11,
        col: 11,
        segments: [
            [6, 1, 2, 5],
            [10, 5, 6, 1],
            [6, 5, 6, 1],
            [2, 5, 6, 5],
            [10, 5, 6, 5],
            [2, 7, 2, 5],
            [1, 7, 2, 5],
            [2, 7, 1, 7],
            [10, 7, 10, 5],
            [10, 5, 11, 7],
            [10, 7, 11, 7],
            [2, 5, 2, 9],
            [10, 9, 10, 7],
            [6, 5, 6, 9],
            [6, 9, 2, 5],
            [6, 9, 10, 5],
            [2, 9, 6, 9],
            [10, 9, 6, 9],
            [6, 9, 4, 11],
            [6, 9, 8, 11],
            [6, 9, 6, 11],
            [4, 11, 6, 11],
            [8, 11, 6, 11],
        ],
    },
    {
        date: 1489016318524,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 5, 3],
            [4, 4, 5, 3],
            [7, 3, 6, 2],
            [8, 4, 7, 3],
            [4, 4, 8, 4],
            [4, 4, 4, 6],
            [8, 6, 4, 6],
            [8, 4, 8, 6],
            [4, 11, 4, 6],
            [8, 6, 8, 11],
            [4, 9, 2, 11],
            [8, 9, 10, 11],
            [6, 7, 5, 8],
            [7, 8, 6, 7],
            [5, 8, 6, 9],
            [7, 8, 6, 9],
        ],
    },
    {
        date: 1488996082405,
        row: 11,
        col: 11,
        segments: [
            [2, 3, 5, 3],
            [6, 2, 7, 3],
            [5, 3, 6, 2],
            [10, 3, 7, 3],
            [2, 5, 5, 5],
            [5, 6, 7, 6],
            [7, 5, 10, 5],
            [10, 3, 10, 5],
            [2, 3, 2, 5],
            [5, 5, 5, 6],
            [7, 6, 7, 5],
            [3, 8, 5, 6],
            [9, 8, 7, 6],
            [3, 10, 5, 10],
            [5, 9, 7, 9],
            [7, 10, 9, 10],
            [7, 9, 7, 10],
            [5, 9, 5, 10],
            [3, 8, 3, 10],
            [9, 8, 9, 10],
            [5, 7, 7, 7],
            [7, 8, 5, 8],
            [5, 7, 5, 8],
            [7, 7, 7, 8],
        ],
    },
    {
        date: 1490174038952,
        row: 11,
        col: 11,
        segments: [
            [6, 2, 5, 3],
            [7, 3, 6, 2],
            [5, 3, 7, 3],
            [5, 4, 5, 3],
            [7, 3, 7, 4],
            [4, 4, 8, 4],
            [4, 5, 4, 4],
            [8, 5, 8, 4],
            [9, 5, 3, 5],
            [3, 6, 3, 5],
            [9, 6, 9, 5],
            [10, 6, 2, 6],
            [10, 7, 10, 6],
            [2, 7, 2, 6],
            [1, 7, 11, 7],
            [11, 8, 11, 7],
            [1, 8, 1, 7],
            [11, 8, 1, 8],
            [5, 8, 5, 10],
            [7, 8, 7, 10],
            [5, 10, 7, 10],
            [4, 10, 5, 10],
            [8, 10, 7, 10],
        ],
    },
    {
        date: 1490174380471,
        row: 11,
        col: 11,
        segments: [
            [4, 3, 8, 3],
            [9, 4, 8, 3],
            [3, 4, 4, 3],
            [9, 4, 3, 4],
            [3, 8, 3, 4],
            [9, 8, 9, 4],
            [9, 8, 3, 8],
            [4, 8, 4, 6],
            [5, 6, 4, 6],
            [5, 8, 5, 6],
            [6, 5, 7, 5],
            [7, 6, 7, 5],
            [6, 6, 7, 6],
            [6, 5, 6, 6],
            [5, 3, 5, 2],
            [6, 2, 5, 2],
            [6, 3, 6, 2],
            [5, 11, 4, 8],
            [7, 11, 5, 8],
        ],
    },
    {
        date: 1491549518378,
        row: 11,
        col: 11,
        segments: [
            [9, 1, 11, 3],
            [11, 9, 9, 11],
            [1, 9, 3, 11],
            [3, 1, 1, 3],
            [3, 1, 6, 5],
            [6, 5, 9, 1],
            [11, 3, 7, 6],
            [7, 6, 11, 9],
            [9, 11, 6, 7],
            [6, 7, 3, 11],
            [1, 9, 5, 6],
            [5, 6, 1, 3],
            [6, 5, 6, 7],
            [5, 6, 7, 6],
            [6, 5, 5, 6],
            [5, 6, 6, 7],
            [6, 7, 7, 6],
            [7, 6, 6, 5],
            [9, 1, 7, 6],
            [6, 5, 11, 3],
            [7, 6, 9, 11],
            [6, 7, 11, 9],
            [5, 6, 3, 11],
            [1, 9, 6, 7],
            [1, 3, 6, 5],
            [3, 1, 5, 6],
            [9, 1, 11, 1],
            [11, 1, 11, 3],
            [11, 9, 11, 11],
            [11, 11, 9, 11],
            [3, 11, 1, 11],
            [1, 11, 1, 9],
            [1, 3, 1, 1],
            [1, 1, 3, 1],
            [2, 2, 1, 1],
            [11, 1, 10, 2],
            [10, 10, 11, 11],
            [2, 10, 1, 11],
        ],
    },
    {
        date: 1491549776640,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 11],
            [2, 11, 10, 1],
            [9, 1, 3, 11],
            [4, 11, 8, 1],
            [7, 1, 5, 11],
            [6, 1, 6, 11],
            [5, 1, 7, 11],
            [4, 1, 8, 11],
            [3, 1, 9, 11],
            [2, 1, 10, 11],
            [1, 1, 11, 11],
            [11, 10, 1, 2],
            [1, 3, 11, 9],
            [11, 8, 1, 4],
            [1, 5, 11, 7],
            [1, 6, 11, 6],
            [11, 5, 1, 7],
            [1, 8, 11, 4],
            [11, 3, 1, 9],
            [1, 10, 11, 2],
            [11, 1, 11, 2],
            [11, 2, 11, 11],
            [11, 11, 1, 11],
            [1, 11, 1, 1],
            [1, 1, 11, 1],
            [10, 1, 11, 2],
            [11, 10, 10, 11],
            [1, 10, 2, 11],
            [2, 1, 1, 2],
            [3, 1, 1, 3],
            [1, 4, 4, 1],
            [5, 1, 1, 5],
            [1, 9, 3, 11],
            [4, 11, 1, 8],
            [1, 7, 5, 11],
            [6, 11, 1, 6],
            [1, 6, 6, 1],
            [9, 1, 11, 3],
            [11, 4, 8, 1],
            [7, 1, 11, 5],
            [11, 6, 6, 1],
            [9, 11, 11, 9],
            [11, 8, 8, 11],
            [7, 11, 11, 7],
            [11, 6, 6, 11],
            [11, 5, 5, 11],
            [4, 11, 11, 4],
            [11, 3, 3, 11],
            [5, 1, 11, 7],
            [11, 8, 4, 1],
            [7, 1, 1, 7],
            [1, 8, 8, 1],
            [9, 1, 1, 9],
            [1, 5, 7, 11],
            [1, 4, 8, 11],
            [9, 11, 1, 3],
            [3, 1, 11, 9],
            [6, 4, 7, 5],
            [7, 5, 8, 6],
            [8, 6, 7, 7],
            [7, 7, 6, 8],
            [6, 8, 5, 7],
            [5, 7, 4, 6],
            [4, 6, 5, 5],
            [5, 5, 6, 4],
        ],
    },
    {
        date: 1491550790928,
        row: 11,
        col: 11,
        segments: [
            [2, 2, 10, 10],
            [10, 2, 10, 10],
            [10, 2, 2, 10],
            [2, 10, 2, 2],
            [2, 2, 10, 2],
            [10, 10, 2, 10],
            [6, 10, 6, 2],
            [2, 6, 10, 6],
            [4, 5, 4, 8],
            [8, 8, 8, 4],
            [4, 4, 8, 4],
            [4, 4, 4, 5],
            [4, 8, 8, 8],
            [5, 5, 5, 7],
            [7, 7, 5, 7],
            [5, 5, 7, 5],
            [7, 5, 7, 7],
            [9, 3, 3, 3],
            [3, 9, 3, 3],
            [3, 9, 9, 9],
            [9, 9, 9, 3],
        ],
    },
    {
        date: 1491551711089,
        row: 11,
        col: 11,
        segments: [
            [11, 1, 1, 1],
            [1, 1, 1, 11],
            [11, 11, 1, 11],
            [11, 11, 11, 1],
            [2, 11, 1, 10],
            [1, 10, 2, 9],
            [2, 9, 1, 8],
            [1, 8, 2, 7],
            [2, 7, 1, 6],
            [1, 6, 2, 5],
            [2, 5, 1, 4],
            [1, 4, 2, 3],
            [2, 3, 1, 2],
            [1, 2, 2, 1],
            [3, 2, 2, 1],
            [3, 2, 2, 3],
            [2, 3, 3, 4],
            [3, 4, 2, 5],
            [2, 5, 3, 6],
            [3, 6, 2, 7],
            [2, 7, 3, 8],
            [3, 8, 2, 9],
            [2, 9, 3, 10],
            [3, 10, 2, 11],
            [4, 11, 3, 10],
            [3, 10, 4, 9],
            [4, 9, 3, 8],
            [3, 8, 4, 7],
            [4, 7, 3, 6],
            [3, 6, 4, 5],
            [4, 5, 3, 4],
            [3, 4, 4, 3],
            [4, 3, 3, 2],
            [3, 2, 4, 1],
            [4, 1, 5, 2],
            [5, 2, 4, 3],
            [4, 3, 5, 4],
            [5, 4, 4, 5],
            [4, 5, 5, 6],
            [5, 6, 4, 7],
            [4, 7, 5, 8],
            [5, 8, 4, 9],
            [4, 9, 5, 10],
            [5, 10, 4, 11],
            [4, 11, 4, 1],
            [2, 1, 2, 11],
            [6, 11, 5, 10],
            [5, 10, 6, 9],
            [6, 9, 5, 8],
            [5, 8, 6, 7],
            [6, 7, 5, 6],
            [5, 6, 6, 5],
            [6, 5, 5, 4],
            [5, 4, 6, 3],
            [6, 3, 5, 2],
            [5, 2, 6, 1],
            [6, 1, 7, 2],
            [7, 2, 6, 3],
            [6, 3, 7, 4],
            [7, 4, 6, 5],
            [6, 5, 7, 6],
            [7, 6, 6, 7],
            [6, 7, 7, 8],
            [7, 8, 6, 9],
            [6, 9, 7, 10],
            [7, 10, 6, 11],
            [8, 11, 7, 10],
            [7, 10, 8, 9],
            [8, 9, 7, 8],
            [7, 8, 8, 7],
            [8, 7, 7, 6],
            [7, 6, 8, 5],
            [8, 5, 7, 4],
            [7, 4, 8, 3],
            [8, 3, 7, 2],
            [7, 2, 8, 1],
            [8, 1, 9, 2],
            [9, 2, 8, 3],
            [8, 3, 9, 4],
            [9, 4, 8, 5],
            [8, 5, 9, 6],
            [8, 7, 9, 6],
            [8, 7, 9, 8],
            [9, 8, 8, 9],
            [8, 9, 9, 10],
            [9, 10, 8, 11],
            [10, 3, 9, 2],
            [9, 2, 10, 1],
            [11, 2, 10, 1],
            [11, 2, 10, 3],
            [10, 11, 9, 10],
            [9, 10, 10, 9],
            [10, 9, 9, 8],
            [9, 8, 10, 7],
            [10, 7, 9, 6],
            [9, 6, 10, 5],
            [10, 5, 9, 4],
            [9, 4, 10, 3],
            [10, 3, 11, 4],
            [11, 4, 10, 5],
            [10, 5, 11, 6],
            [11, 6, 10, 7],
            [10, 7, 11, 8],
            [11, 8, 10, 9],
            [10, 9, 11, 10],
            [11, 10, 10, 11],
            [10, 11, 10, 1],
            [8, 1, 8, 11],
            [6, 11, 6, 1],
            [1, 1, 6, 6],
            [6, 6, 11, 1],
            [6, 6, 11, 11],
            [6, 6, 1, 11],
            [1, 2, 5, 6],
            [1, 3, 5, 7],
            [5, 7, 9, 11],
            [3, 1, 7, 5],
            [5, 1, 8, 4],
            [7, 1, 9, 3],
            [11, 9, 7, 5],
            [11, 7, 8, 4],
            [11, 5, 9, 3],
            [11, 3, 10, 2],
            [9, 1, 10, 2],
            [1, 5, 4, 8],
            [1, 7, 3, 9],
            [1, 9, 2, 10],
            [3, 11, 2, 10],
            [7, 11, 4, 8],
            [5, 11, 3, 9],
            [3, 11, 4, 10],
            [8, 2, 9, 1],
            [2, 2, 3, 1],
            [1, 7, 2, 6],
            [1, 5, 2, 4],
            [1, 3, 2, 2],
            [1, 9, 2, 8],
            [10, 10, 11, 9],
            [10, 8, 11, 7],
            [10, 6, 11, 5],
            [10, 4, 11, 3],
            [9, 11, 10, 10],
            [5, 11, 6, 10],
            [7, 11, 8, 10],
            [7, 1, 6, 2],
            [5, 1, 4, 2],
            [7, 3, 8, 2],
            [5, 3, 6, 2],
            [3, 3, 4, 2],
            [2, 4, 3, 3],
            [2, 6, 3, 5],
            [2, 8, 3, 7],
            [8, 10, 9, 9],
            [9, 9, 10, 8],
            [8, 8, 9, 7],
            [9, 7, 10, 6],
            [8, 6, 9, 5],
            [9, 5, 10, 4],
            [5, 3, 3, 5],
            [7, 3, 3, 7],
            [8, 6, 4, 10],
            [8, 8, 6, 10],
        ],
    },
    {
        date: 1427877063486,
        row: 11,
        col: 11,
        segments: [
            [4, 2, 4, 4],
            [7, 4, 7, 2],
            [4, 2, 7, 2],
            [7, 4, 4, 4],
            [5, 4, 5, 5],
            [6, 4, 6, 5],
            [6, 5, 8, 6],
            [8, 6, 6, 6],
            [5, 5, 3, 6],
            [3, 6, 5, 6],
            [5, 6, 5, 8],
            [6, 6, 6, 8],
            [6, 8, 7, 10],
            [7, 10, 6, 9],
            [6, 9, 5, 9],
            [5, 8, 4, 10],
            [4, 10, 5, 9],
            [5, 8, 6, 8],
            [5, 3, 6, 3],
            [4, 2, 5, 1],
            [5, 2, 6, 1],
            [6, 2, 7, 1],
            [7, 2, 8, 1],
            [5, 1, 8, 1],
            [8, 6, 9, 5],
            [8, 6, 9, 6],
            [8, 6, 9, 7],
            [3, 6, 2, 5],
            [3, 6, 2, 6],
            [3, 6, 2, 7],
            [7, 10, 6, 11],
            [7, 10, 7, 11],
            [7, 10, 8, 10],
            [4, 10, 3, 10],
            [4, 10, 3, 11],
            [4, 10, 4, 11],
            [7, 3, 8, 2],
            [8, 3, 8, 2],
            [8, 3, 7, 4],
            [4, 3, 3, 2],
            [3, 2, 3, 3],
            [3, 3, 4, 4],
            [7, 10, 8, 11],
            [4, 10, 5, 11],
            [8, 6, 8, 5],
            [8, 6, 8, 7],
            [3, 6, 3, 5],
            [3, 6, 3, 7],
        ],
    },
    {
        date: 1462988300993,
        row: 11,
        col: 11,
        segments: [
            [2, 5, 3, 3],
            [3, 3, 9, 3],
            [9, 3, 10, 5],
            [10, 5, 2, 5],
            [7, 3, 7, 2],
            [7, 2, 8, 2],
            [8, 2, 8, 3],
            [9, 5, 9, 10],
            [11, 10, 1, 10],
            [3, 10, 3, 5],
            [4, 6, 4, 7],
            [4, 7, 5, 7],
            [5, 7, 5, 6],
            [5, 6, 4, 6],
            [7, 6, 7, 7],
            [7, 7, 8, 7],
            [8, 7, 8, 6],
            [8, 6, 7, 6],
            [5, 10, 5, 8],
            [5, 8, 7, 8],
            [7, 8, 7, 10],
            [6, 8, 6, 10],
        ],
    },
];
